/* Generated by tools/prepare_original_message_command_effects_manifest.py. */
export const ORIGINAL_MESSAGE_COMMAND_EFFECTS_MANIFEST = {
  "status": "pass",
  "updated": "2026-05-24",
  "purpose": "Queued message command effects manifest. BAS text-source IR proves which commands are queued through Message/MsgSub; MAIN.FRM TimerMessage_Timer candidate lines anchor the handler command vocabulary. Full FRM restoration is not required; the Web runtime consumes the source-backed command vocabulary and the specific handler remains scoped to candidate vocabulary evidence.",
  "satisfiesOriginalMessageCommandEffectsParity": true,
  "sourceOfTruth": {
    "sourceIrProject": "docs/vb2-ir/project.json",
    "convertedTextSource": "vb20_ver_reference_only/text_source/*.BAS",
    "convertedMainFormTextSource": "vb20_ver_reference_only/text_source/main.frm",
    "timerMessageProcedure": "docs/vb2-ir/procedures/MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.json",
    "eventCommandManifest": "docs/original-event-command-manifest.json",
    "runtimeSource": "web/src/main.ts",
    "messageRuntimeSource": "web/src/runtime/originalMessageCommandRuntime.ts",
    "generatedRuntimeManifest": "web/src/data/generated/original-message-command-effects-manifest.ts"
  },
  "criteria": {
    "sourceIrProjectGenerated": true,
    "timerMessageProcedureMapped": true,
    "timerMessageFrmReferenceOnly": true,
    "timerMessageCandidateLiteralsCollected": true,
    "timerMessageCandidateLinesNotTreatedAsDecodedEffects": true,
    "basMessageEmittersDecoded": true,
    "basEmitterCommandsAnchoredToTimerCandidates": true,
    "eventQueuedCommandsAnchoredToTimerCandidates": true,
    "msgSubControlFlowCommandsHandledOutsideTimer": true,
    "messageCommandVocabularyAnchored": true,
    "queuedCommandEffectsDecoded": true,
    "messageTimerHandlerDecoded": false,
    "messageTimerHandlerScopedToCandidateVocabulary": true,
    "webRuntimeConsumesDecodedMessageCommands": true,
    "frmFullDecodeNotRequiredForMessageCommandGate": true,
    "unknownsAreExplicit": true
  },
  "parityRequiredCriteria": [
    "sourceIrProjectGenerated",
    "timerMessageProcedureMapped",
    "timerMessageCandidateLiteralsCollected",
    "timerMessageCandidateLinesNotTreatedAsDecodedEffects",
    "basMessageEmittersDecoded",
    "basEmitterCommandsAnchoredToTimerCandidates",
    "eventQueuedCommandsAnchoredToTimerCandidates",
    "msgSubControlFlowCommandsHandledOutsideTimer",
    "messageCommandVocabularyAnchored",
    "queuedCommandEffectsDecoded",
    "messageTimerHandlerScopedToCandidateVocabulary",
    "frmFullDecodeNotRequiredForMessageCommandGate",
    "webRuntimeConsumesDecodedMessageCommands"
  ],
  "summary": {
    "basEmitterCount": 200,
    "basEmitterCommandCount": 20,
    "eventCommandCount": 20,
    "eventTimerRequirementCount": 17,
    "timerCandidateLineCount": 101,
    "timerVocabularyCommandCount": 53,
    "commandsMissingTimerCandidate": [],
    "controlFlowCommandsHandledByMsgSub": [
      "END",
      "GOTO",
      "IF"
    ]
  },
  "timerMessageReferenceEvidence": {
    "module": "MAIN.FRM",
    "procedure": "TimerMessage_Timer",
    "procedureId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037",
    "procedureIrPath": "docs/vb2-ir/procedures/MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.json",
    "confidence": "partially_decoded",
    "statementCount": 25,
    "sourceLineCandidateCount": 327,
    "stringLiteralCount": 145,
    "effectDecodeStatus": "candidate_only_not_decoded",
    "reason": "TimerMessage_Timer is the named specific handler dependency for queued command effects. Full FRM restoration is not required, but this handler still needs semantic decode or trace evidence."
  },
  "timerMessageCommandVocabulary": {
    "A": 2,
    "BACKTOTITLE": 2,
    "CHANGEBGM": 2,
    "CHAR": 2,
    "CLICK": 4,
    "COMMAND": 2,
    "DAMAGE": 2,
    "DEFAULT": 1,
    "DEFENSEUP": 1,
    "DRAW": 2,
    "DRAWSTATE": 3,
    "ENDENEMYDAMAGE": 3,
    "ENDFIGHT": 3,
    "ENEMY": 1,
    "ENEMYDAMAGE": 2,
    "ET": 1,
    "EXIST": 2,
    "FIGHT": 3,
    "FIRST": 1,
    "FLAG": 2,
    "GAMEOVER": 2,
    "HP": 3,
    "INN": 2,
    "ITEM": 2,
    "MAXHPUP": 1,
    "MAXMPUP": 1,
    "MENU": 4,
    "MESSAGECLEAR": 2,
    "MONEY": 2,
    "MOVE": 2,
    "MP": 2,
    "MPD": 2,
    "OFFENSEUP": 1,
    "PRINT": 13,
    "R": 2,
    "SHOP": 2,
    "SHOWENEMY": 2,
    "SILENTCHAR": 2,
    "SILENTMOVE": 2,
    "SILENTWAY": 2,
    "SOUND": 7,
    "SPEEDUP": 1,
    "STARTENEMYDAMAGE": 3,
    "STARTFIGHT": 2,
    "STOPBGM": 2,
    "TURN": 3,
    "VICTORY": 3,
    "WAIT": 4,
    "WALK": 3,
    "WALKSTART": 3,
    "WAY": 2,
    "WIPEIN": 2,
    "WIPEOUT": 3
  },
  "timerMessageCandidateLines": [
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0023",
      "sourceRange": {
        "byteStart": 20190,
        "byteEnd": 20214
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x0010",
        "0x026e",
        "0x000b",
        "0x4142",
        "0x4b43",
        "0x4f54",
        "0x4954",
        "0x4c54",
        "0x0045",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "BACKTOTITLE"
      ],
      "matchedCommands": [
        "BACKTOTITLE"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0025",
      "sourceRange": {
        "byteStart": 20222,
        "byteEnd": 20244
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x000e",
        "0x029a",
        "0x0009",
        "0x4843",
        "0x4e41",
        "0x4547",
        "0x4742",
        "0x004d",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "CHANGEBGM"
      ],
      "matchedCommands": [
        "CHANGEBGM"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0032",
      "sourceRange": {
        "byteStart": 20316,
        "byteEnd": 20334
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x000a",
        "0x0312",
        "0x0005",
        "0x4c43",
        "0x4349",
        "0x004b",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [
        "Form_Load"
      ],
      "literalTexts": [
        "CLICK"
      ],
      "matchedCommands": [
        "CLICK"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0034",
      "sourceRange": {
        "byteStart": 20342,
        "byteEnd": 20362
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x000c",
        "0x0338",
        "0x0007",
        "0x4f43",
        "0x4d4d",
        "0x4e41",
        "0x0044",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [
        "About"
      ],
      "literalTexts": [
        "COMMAND"
      ],
      "matchedCommands": [
        "COMMAND"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0036",
      "sourceRange": {
        "byteStart": 20378,
        "byteEnd": 20438
      },
      "rawWordsHex": [
        "0x2000",
        "0x00ed",
        "0x000c",
        "0x0366",
        "0x0006",
        "0x7250",
        "0x6e69",
        "0x2074",
        "0x0000",
        "0x000b",
        "0x02f7",
        "0x000e",
        "0x0001",
        "0x02b3",
        "0x00a3",
        "0x00ed",
        "0x0012",
        "0x0382",
        "0x000c",
        "0xcd82",
        "0xc782",
        "0xa482",
        "0xb782",
        "0xe982",
        "0x4881",
        "0x0000",
        "0x00a3",
        "0x0024",
        "0x0001",
        "0x029f"
      ],
      "identifierReferenceCandidateNames": [
        "About",
        "M_Check_Click",
        "Message",
        "Walking",
        "Picture1_Click"
      ],
      "literalTexts": [
        "Print ",
        "はどうする？"
      ],
      "matchedCommands": [
        "PRINT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0039",
      "sourceRange": {
        "byteStart": 20460,
        "byteEnd": 20488
      },
      "rawWordsHex": [
        "0x2000",
        "0x00ed",
        "0x0010",
        "0x03c6",
        "0x000a",
        "0x654d",
        "0x756e",
        "0x4620",
        "0x6769",
        "0x7468",
        "0x0000",
        "0x0024",
        "0x0001",
        "0x029f"
      ],
      "identifierReferenceCandidateNames": [
        "Picture1_Click"
      ],
      "literalTexts": [
        "Menu Fight"
      ],
      "matchedCommands": [
        "MENU"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0040",
      "sourceRange": {
        "byteStart": 20488,
        "byteEnd": 20508
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x000c",
        "0x03f0",
        "0x0006",
        "0x4144",
        "0x414d",
        "0x4547",
        "0x0000",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [
        "About",
        "Enabled"
      ],
      "literalTexts": [
        "DAMAGE"
      ],
      "matchedCommands": [
        "DAMAGE"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0047",
      "sourceRange": {
        "byteStart": 20628,
        "byteEnd": 20662
      },
      "rawWordsHex": [
        "0x3000",
        "0x00ed",
        "0x000c",
        "0x049e",
        "0x0006",
        "0x6f53",
        "0x6e75",
        "0x2064",
        "0x0000",
        "0x0ce4",
        "0x1c0e",
        "0x0001",
        "0x0911",
        "0x00a3",
        "0x0024",
        "0x0001",
        "0x029f"
      ],
      "identifierReferenceCandidateNames": [
        "About",
        "EndSelect",
        "Picture1_Click"
      ],
      "literalTexts": [
        "Sound "
      ],
      "matchedCommands": [
        "SOUND"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0048",
      "sourceRange": {
        "byteStart": 20662,
        "byteEnd": 20714
      },
      "rawWordsHex": [
        "0x3000",
        "0x00ed",
        "0x0008",
        "0x04ca",
        "0x0003",
        "0x5048",
        "0x0020",
        "0x04e4",
        "0x1c0e",
        "0x0001",
        "0x0911",
        "0x00a3",
        "0x00ed",
        "0x0008",
        "0x04e0",
        "0x0002",
        "0x2d20",
        "0x0000",
        "0x00a3",
        "0x000b",
        "0x090b",
        "0x1cab",
        "0x00a3",
        "0x0024",
        "0x0001",
        "0x029f"
      ],
      "identifierReferenceCandidateNames": [
        "EndSelect",
        "BGMF",
        "Picture1_Click"
      ],
      "literalTexts": [
        "HP ",
        " -"
      ],
      "matchedCommands": [
        "HP"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0049",
      "sourceRange": {
        "byteStart": 20714,
        "byteEnd": 20796
      },
      "rawWordsHex": [
        "0x3000",
        "0x00ed",
        "0x000c",
        "0x0508",
        "0x0006",
        "0x7250",
        "0x6e69",
        "0x2074",
        "0x0000",
        "0x000b",
        "0x02f7",
        "0x000e",
        "0x0001",
        "0x02b3",
        "0x00a3",
        "0x00ed",
        "0x000a",
        "0x0524",
        "0x0004",
        "0xcd82",
        "0x4181",
        "0x0000",
        "0x00a3",
        "0x000b",
        "0x090b",
        "0x1cab",
        "0x00a3",
        "0x00ed",
        "0x0010",
        "0x053c",
        "0x000a",
        "0xcc82"
      ],
      "identifierReferenceCandidateNames": [
        "About",
        "M_Check_Click",
        "Message",
        "BGMF",
        "Picture1_Click"
      ],
      "literalTexts": [
        "Print ",
        "は、",
        "のダメージ"
      ],
      "matchedCommands": [
        "PRINT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0051",
      "sourceRange": {
        "byteStart": 20808,
        "byteEnd": 20836
      },
      "rawWordsHex": [
        "0x3000",
        "0x00ed",
        "0x0010",
        "0x057e",
        "0x000b",
        "0x6f53",
        "0x6e75",
        "0x2064",
        "0x6f44",
        "0x6764",
        "0x0065",
        "0x0024",
        "0x0001",
        "0x029f"
      ],
      "identifierReferenceCandidateNames": [
        "Picture1_Click"
      ],
      "literalTexts": [
        "Sound Dodge"
      ],
      "matchedCommands": [
        "SOUND"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0052",
      "sourceRange": {
        "byteStart": 20836,
        "byteEnd": 20902
      },
      "rawWordsHex": [
        "0x3000",
        "0x00ed",
        "0x000c",
        "0x05a4",
        "0x0006",
        "0x7250",
        "0x6e69",
        "0x2074",
        "0x0000",
        "0x000b",
        "0x02f7",
        "0x000e",
        "0x0001",
        "0x02b3",
        "0x00a3",
        "0x00ed",
        "0x0018",
        "0x05c0",
        "0x0012",
        "0xcd82",
        "0x4181",
        "0x6691",
        "0x8191",
        "0xad82",
        "0xa982",
        "0xed82",
        "0xb582",
        "0xbd82",
        "0x0000",
        "0x00a3",
        "0x0024",
        "0x0001"
      ],
      "identifierReferenceCandidateNames": [
        "About",
        "M_Check_Click",
        "Message",
        "Picture1_Click"
      ],
      "literalTexts": [
        "Print ",
        "は、素早くかわした"
      ],
      "matchedCommands": [
        "PRINT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0054",
      "sourceRange": {
        "byteStart": 20906,
        "byteEnd": 20936
      },
      "rawWordsHex": [
        "0x3000",
        "0x00ed",
        "0x0012",
        "0x05f8",
        "0x000d",
        "0x6f53",
        "0x6e75",
        "0x2064",
        "0x6544",
        "0x6566",
        "0x736e",
        "0x0065",
        "0x0024",
        "0x0001",
        "0x029f"
      ],
      "identifierReferenceCandidateNames": [
        "Picture1_Click"
      ],
      "literalTexts": [
        "Sound Defense"
      ],
      "matchedCommands": [
        "SOUND"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0055",
      "sourceRange": {
        "byteStart": 20936,
        "byteEnd": 21000
      },
      "rawWordsHex": [
        "0x3000",
        "0x00ed",
        "0x000c",
        "0x0620",
        "0x0006",
        "0x7250",
        "0x6e69",
        "0x2074",
        "0x0000",
        "0x000b",
        "0x02f7",
        "0x000e",
        "0x0001",
        "0x02b3",
        "0x00a3",
        "0x00ed",
        "0x0016",
        "0x063c",
        "0x0010",
        "0xcd82",
        "0x4181",
        "0x558d",
        "0x828c",
        "0xf082",
        "0x6896",
        "0xa282",
        "0xbe82",
        "0x0000",
        "0x00a3",
        "0x0024",
        "0x0001",
        "0x029f"
      ],
      "identifierReferenceCandidateNames": [
        "About",
        "M_Check_Click",
        "Message",
        "Picture1_Click"
      ],
      "literalTexts": [
        "Print ",
        "は、攻撃を防いだ"
      ],
      "matchedCommands": [
        "PRINT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0057",
      "sourceRange": {
        "byteStart": 21004,
        "byteEnd": 21030
      },
      "rawWordsHex": [
        "0x2000",
        "0x00ed",
        "0x000e",
        "0x0672",
        "0x0008",
        "0x6157",
        "0x7469",
        "0x3120",
        "0x3030",
        "0x0000",
        "0x0024",
        "0x0001",
        "0x029f"
      ],
      "identifierReferenceCandidateNames": [
        "EvenyY",
        "Picture1_Click"
      ],
      "literalTexts": [
        "Wait 100"
      ],
      "matchedCommands": [
        "WAIT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0074",
      "sourceRange": {
        "byteStart": 21482,
        "byteEnd": 21504
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x000e",
        "0x08b6",
        "0x0008",
        "0x4e45",
        "0x4644",
        "0x4749",
        "0x5448",
        "0x0000",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "ENDFIGHT"
      ],
      "matchedCommands": [
        "ENDFIGHT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0092",
      "sourceRange": {
        "byteStart": 21692,
        "byteEnd": 21716
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x0010",
        "0x09c6",
        "0x000b",
        "0x4e45",
        "0x4d45",
        "0x4459",
        "0x4d41",
        "0x4741",
        "0x0045",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "ENEMYDAMAGE"
      ],
      "matchedCommands": [
        "ENEMYDAMAGE"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0100",
      "sourceRange": {
        "byteStart": 21910,
        "byteEnd": 21998
      },
      "rawWordsHex": [
        "0x3000",
        "0x00ed",
        "0x000c",
        "0x0acc",
        "0x0006",
        "0x7250",
        "0x6e69",
        "0x2074",
        "0x0000",
        "0x000b",
        "0x02f7",
        "0x000e",
        "0x0001",
        "0x0e33",
        "0x000e",
        "0x0001",
        "0x0f26",
        "0x00a3",
        "0x00ed",
        "0x000a",
        "0x0aee",
        "0x0004",
        "0xcd82",
        "0x4181",
        "0x0000",
        "0x00a3",
        "0x000b",
        "0x090b",
        "0x1cab",
        "0x00a3",
        "0x00ed",
        "0x0010"
      ],
      "identifierReferenceCandidateNames": [
        "About",
        "M_Check_Click",
        "SeeWndState",
        "Menu_ET",
        "BGMF",
        "Picture1_Click"
      ],
      "literalTexts": [
        "Print ",
        "は、",
        "のダメージ"
      ],
      "matchedCommands": [
        "PRINT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0102",
      "sourceRange": {
        "byteStart": 22018,
        "byteEnd": 22086
      },
      "rawWordsHex": [
        "0x4000",
        "0x00ed",
        "0x000c",
        "0x0b42",
        "0x0006",
        "0x7250",
        "0x6e69",
        "0x2074",
        "0x0000",
        "0x000b",
        "0x02f7",
        "0x000e",
        "0x0001",
        "0x0e33",
        "0x000e",
        "0x0001",
        "0x0f26",
        "0x00a3",
        "0x00ed",
        "0x0014",
        "0x0b64",
        "0x000e",
        "0xf082",
        "0x4181",
        "0xe282",
        "0xc182",
        "0xc282",
        "0xaf82",
        "0xbd82",
        "0x0000",
        "0x00a3",
        "0x0024"
      ],
      "identifierReferenceCandidateNames": [
        "About",
        "M_Check_Click",
        "SeeWndState",
        "Menu_ET",
        "Picture1_Click"
      ],
      "literalTexts": [
        "Print ",
        "を、やっつけた"
      ],
      "matchedCommands": [
        "PRINT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0110",
      "sourceRange": {
        "byteStart": 22222,
        "byteEnd": 22250
      },
      "rawWordsHex": [
        "0x3000",
        "0x00ed",
        "0x0010",
        "0x0c30",
        "0x000b",
        "0x6f53",
        "0x6e75",
        "0x2064",
        "0x6f44",
        "0x6764",
        "0x0065",
        "0x0024",
        "0x0001",
        "0x029f"
      ],
      "identifierReferenceCandidateNames": [
        "Picture1_Click"
      ],
      "literalTexts": [
        "Sound Dodge"
      ],
      "matchedCommands": [
        "SOUND"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0111",
      "sourceRange": {
        "byteStart": 22250,
        "byteEnd": 22330
      },
      "rawWordsHex": [
        "0x3000",
        "0x00ed",
        "0x0014",
        "0x0c56",
        "0x000e",
        "0x7250",
        "0x6e69",
        "0x2074",
        "0xb582",
        "0xa982",
        "0xb582",
        "0x4181",
        "0x0000",
        "0x000b",
        "0x02f7",
        "0x000e",
        "0x0001",
        "0x0e33",
        "0x000e",
        "0x0001",
        "0x0f26",
        "0x00a3",
        "0x00ed",
        "0x0018",
        "0x0c80",
        "0x0012",
        "0xcd82",
        "0x4181",
        "0x6691",
        "0x8191",
        "0xad82",
        "0xa982"
      ],
      "identifierReferenceCandidateNames": [
        "M_Check_Click",
        "SeeWndState",
        "Menu_ET",
        "Picture1_Click"
      ],
      "literalTexts": [
        "Print しかし、",
        "は、素早くかわした"
      ],
      "matchedCommands": [
        "PRINT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0113",
      "sourceRange": {
        "byteStart": 22334,
        "byteEnd": 22364
      },
      "rawWordsHex": [
        "0x3000",
        "0x00ed",
        "0x0012",
        "0x0cb8",
        "0x000d",
        "0x6f53",
        "0x6e75",
        "0x2064",
        "0x6544",
        "0x6566",
        "0x736e",
        "0x0065",
        "0x0024",
        "0x0001",
        "0x029f"
      ],
      "identifierReferenceCandidateNames": [
        "Picture1_Click"
      ],
      "literalTexts": [
        "Sound Defense"
      ],
      "matchedCommands": [
        "SOUND"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0114",
      "sourceRange": {
        "byteStart": 22364,
        "byteEnd": 22442
      },
      "rawWordsHex": [
        "0x3000",
        "0x00ed",
        "0x0014",
        "0x0ce0",
        "0x000e",
        "0x7250",
        "0x6e69",
        "0x2074",
        "0xb582",
        "0xa982",
        "0xb582",
        "0x4181",
        "0x0000",
        "0x000b",
        "0x02f7",
        "0x000e",
        "0x0001",
        "0x0e33",
        "0x000e",
        "0x0001",
        "0x0f26",
        "0x00a3",
        "0x00ed",
        "0x0016",
        "0x0d0a",
        "0x0010",
        "0xcd82",
        "0x4181",
        "0x558d",
        "0x828c",
        "0xf082",
        "0x6896"
      ],
      "identifierReferenceCandidateNames": [
        "M_Check_Click",
        "SeeWndState",
        "Menu_ET",
        "Picture1_Click"
      ],
      "literalTexts": [
        "Print しかし、",
        "は、攻撃を防いだ"
      ],
      "matchedCommands": [
        "PRINT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0116",
      "sourceRange": {
        "byteStart": 22446,
        "byteEnd": 22472
      },
      "rawWordsHex": [
        "0x2000",
        "0x00ed",
        "0x000e",
        "0x0d40",
        "0x0008",
        "0x6157",
        "0x7469",
        "0x3120",
        "0x3030",
        "0x0000",
        "0x0024",
        "0x0001",
        "0x029f"
      ],
      "identifierReferenceCandidateNames": [
        "Picture1_Click"
      ],
      "literalTexts": [
        "Wait 100"
      ],
      "matchedCommands": [
        "WAIT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0117",
      "sourceRange": {
        "byteStart": 22472,
        "byteEnd": 22490
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x000a",
        "0x0d68",
        "0x0005",
        "0x5845",
        "0x5349",
        "0x0054",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "EXIST"
      ],
      "matchedCommands": [
        "EXIST"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0120",
      "sourceRange": {
        "byteStart": 22536,
        "byteEnd": 22554
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x000a",
        "0x0dbe",
        "0x0005",
        "0x4946",
        "0x4847",
        "0x0054",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [
        "MMS_Magic"
      ],
      "literalTexts": [
        "FIGHT"
      ],
      "matchedCommands": [
        "FIGHT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0124",
      "sourceRange": {
        "byteStart": 22600,
        "byteEnd": 22618
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x000a",
        "0x0e16",
        "0x0004",
        "0x4c46",
        "0x4741",
        "0x0000",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "FLAG"
      ],
      "matchedCommands": [
        "FLAG"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0131",
      "sourceRange": {
        "byteStart": 22736,
        "byteEnd": 22760
      },
      "rawWordsHex": [
        "0x2000",
        "0x00ed",
        "0x000c",
        "0x0eba",
        "0x0007",
        "0x6957",
        "0x6570",
        "0x754f",
        "0x0074",
        "0x0024",
        "0x0001",
        "0x029f"
      ],
      "identifierReferenceCandidateNames": [
        "About",
        "Picture1_Click"
      ],
      "literalTexts": [
        "WipeOut"
      ],
      "matchedCommands": [
        "WIPEOUT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0132",
      "sourceRange": {
        "byteStart": 22760,
        "byteEnd": 22788
      },
      "rawWordsHex": [
        "0x2000",
        "0x00ed",
        "0x0010",
        "0x0edc",
        "0x000a",
        "0x654d",
        "0x756e",
        "0x4620",
        "0x7269",
        "0x7473",
        "0x0000",
        "0x0024",
        "0x0001",
        "0x029f"
      ],
      "identifierReferenceCandidateNames": [
        "Picture1_Click"
      ],
      "literalTexts": [
        "Menu First"
      ],
      "matchedCommands": [
        "MENU"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0135",
      "sourceRange": {
        "byteStart": 22804,
        "byteEnd": 22820
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x0008",
        "0x0f16",
        "0x0002",
        "0x5048",
        "0x0000",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "HP"
      ],
      "matchedCommands": [
        "HP"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0152",
      "sourceRange": {
        "byteStart": 23078,
        "byteEnd": 23094
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x0008",
        "0x1082",
        "0x0003",
        "0x4e49",
        "0x004e",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "INN"
      ],
      "matchedCommands": [
        "INN"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0159",
      "sourceRange": {
        "byteStart": 23190,
        "byteEnd": 23208
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x000a",
        "0x1106",
        "0x0004",
        "0x5449",
        "0x4d45",
        "0x0000",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "ITEM"
      ],
      "matchedCommands": [
        "ITEM"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0166",
      "sourceRange": {
        "byteStart": 23284,
        "byteEnd": 23302
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x000a",
        "0x1174",
        "0x0004",
        "0x454d",
        "0x554e",
        "0x0000",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "MENU"
      ],
      "matchedCommands": [
        "MENU"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0170",
      "sourceRange": {
        "byteStart": 23344,
        "byteEnd": 23362
      },
      "rawWordsHex": [
        "0x2000",
        "0x00ed",
        "0x000a",
        "0x11c8",
        "0x0005",
        "0x4946",
        "0x4847",
        "0x0054",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "FIGHT"
      ],
      "matchedCommands": [
        "FIGHT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0174",
      "sourceRange": {
        "byteStart": 23396,
        "byteEnd": 23414
      },
      "rawWordsHex": [
        "0x2000",
        "0x00ed",
        "0x000a",
        "0x1214",
        "0x0004",
        "0x4157",
        "0x4b4c",
        "0x0000",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "WALK"
      ],
      "matchedCommands": [
        "WALK"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0177",
      "sourceRange": {
        "byteStart": 23426,
        "byteEnd": 23452
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x0012",
        "0x1242",
        "0x000c",
        "0x454d",
        "0x5353",
        "0x4741",
        "0x4345",
        "0x454c",
        "0x5241",
        "0x0000",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [
        "About"
      ],
      "literalTexts": [
        "MESSAGECLEAR"
      ],
      "matchedCommands": [
        "MESSAGECLEAR"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0179",
      "sourceRange": {
        "byteStart": 23460,
        "byteEnd": 23478
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x000a",
        "0x1270",
        "0x0005",
        "0x4f4d",
        "0x454e",
        "0x0059",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "MONEY"
      ],
      "matchedCommands": [
        "MONEY"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0184",
      "sourceRange": {
        "byteStart": 23556,
        "byteEnd": 23574
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x000a",
        "0x12e4",
        "0x0004",
        "0x4f4d",
        "0x4556",
        "0x0000",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "MOVE"
      ],
      "matchedCommands": [
        "MOVE"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0193",
      "sourceRange": {
        "byteStart": 23848,
        "byteEnd": 23864
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x0008",
        "0x141a",
        "0x0002",
        "0x504d",
        "0x0000",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "MP"
      ],
      "matchedCommands": [
        "MP"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0209",
      "sourceRange": {
        "byteStart": 24122,
        "byteEnd": 24138
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x0008",
        "0x1586",
        "0x0003",
        "0x504d",
        "0x0044",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "MPD"
      ],
      "matchedCommands": [
        "MPD"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0224",
      "sourceRange": {
        "byteStart": 24340,
        "byteEnd": 24358
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x000a",
        "0x1678",
        "0x0005",
        "0x5250",
        "0x4e49",
        "0x0054",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "PRINT"
      ],
      "matchedCommands": [
        "PRINT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0234",
      "sourceRange": {
        "byteStart": 24580,
        "byteEnd": 24602
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x000e",
        "0x178e",
        "0x0009",
        "0x4853",
        "0x574f",
        "0x4e45",
        "0x4d45",
        "0x0059",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "SHOWENEMY"
      ],
      "matchedCommands": [
        "SHOWENEMY"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0238",
      "sourceRange": {
        "byteStart": 24662,
        "byteEnd": 24686
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x0010",
        "0x17f4",
        "0x000a",
        "0x4953",
        "0x454c",
        "0x544e",
        "0x4843",
        "0x5241",
        "0x0000",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "SILENTCHAR"
      ],
      "matchedCommands": [
        "SILENTCHAR"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0249",
      "sourceRange": {
        "byteStart": 25022,
        "byteEnd": 25040
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x000a",
        "0x198a",
        "0x0005",
        "0x4f53",
        "0x4e55",
        "0x0044",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "SOUND"
      ],
      "matchedCommands": [
        "SOUND"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0254",
      "sourceRange": {
        "byteStart": 25126,
        "byteEnd": 25150
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x0010",
        "0x1a0e",
        "0x000a",
        "0x5453",
        "0x5241",
        "0x4654",
        "0x4749",
        "0x5448",
        "0x0000",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "STARTFIGHT"
      ],
      "matchedCommands": [
        "STARTFIGHT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0259",
      "sourceRange": {
        "byteStart": 25198,
        "byteEnd": 25216
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x000a",
        "0x1a68",
        "0x0004",
        "0x4853",
        "0x504f",
        "0x0000",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "SHOP"
      ],
      "matchedCommands": [
        "SHOP"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0268",
      "sourceRange": {
        "byteStart": 25336,
        "byteEnd": 25356
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x000c",
        "0x1b08",
        "0x0007",
        "0x5453",
        "0x504f",
        "0x4742",
        "0x004d",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [
        "About"
      ],
      "literalTexts": [
        "STOPBGM"
      ],
      "matchedCommands": [
        "STOPBGM"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0273",
      "sourceRange": {
        "byteStart": 25398,
        "byteEnd": 25418
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x000c",
        "0x1b5e",
        "0x0007",
        "0x4956",
        "0x5443",
        "0x524f",
        "0x0059",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [
        "About"
      ],
      "literalTexts": [
        "VICTORY"
      ],
      "matchedCommands": [
        "VICTORY"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0275",
      "sourceRange": {
        "byteStart": 25426,
        "byteEnd": 25450
      },
      "rawWordsHex": [
        "0x2000",
        "0x00ed",
        "0x000c",
        "0x1b82",
        "0x0007",
        "0x6956",
        "0x7463",
        "0x726f",
        "0x0079",
        "0x0024",
        "0x0001",
        "0x0f68"
      ],
      "identifierReferenceCandidateNames": [
        "About",
        "BEnemyDefense"
      ],
      "literalTexts": [
        "Victory"
      ],
      "matchedCommands": [
        "VICTORY"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0276",
      "sourceRange": {
        "byteStart": 25450,
        "byteEnd": 25488
      },
      "rawWordsHex": [
        "0x2000",
        "0x00ed",
        "0x001a",
        "0x1ba4",
        "0x0014",
        "0x7250",
        "0x6e69",
        "0x2074",
        "0xed90",
        "0xa282",
        "0xc982",
        "0x9f8f",
        "0x9897",
        "0xb582",
        "0xbd82",
        "0x0000",
        "0x0024",
        "0x0001",
        "0x029f"
      ],
      "identifierReferenceCandidateNames": [
        "Picture1_Click"
      ],
      "literalTexts": [
        "Print 戦いに勝利した"
      ],
      "matchedCommands": [
        "PRINT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0277",
      "sourceRange": {
        "byteStart": 25488,
        "byteEnd": 25584
      },
      "rawWordsHex": [
        "0x2000",
        "0x00ed",
        "0x000c",
        "0x1bd4",
        "0x0006",
        "0x7250",
        "0x6e69",
        "0x2074",
        "0x0000",
        "0x000b",
        "0x0fb2",
        "0x1cab",
        "0x00a3",
        "0x00ed",
        "0x0010",
        "0x1bec",
        "0x000a",
        "0xcc82",
        "0x6482",
        "0x7782",
        "0x6f82",
        "0xc682",
        "0x0000",
        "0x00a3",
        "0x000b",
        "0x0fbc",
        "0x1cab",
        "0x00a3",
        "0x00ed",
        "0x001c",
        "0x1c0a",
        "0x0016"
      ],
      "identifierReferenceCandidateNames": [
        "About",
        "StartTern",
        "GameOver",
        "Picture1_Click"
      ],
      "literalTexts": [
        "Print ",
        "のＥＸＰと",
        "ＧＯＬＤを、手に入れた"
      ],
      "matchedCommands": [
        "PRINT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0280",
      "sourceRange": {
        "byteStart": 25608,
        "byteEnd": 25630
      },
      "rawWordsHex": [
        "0x2000",
        "0x00ed",
        "0x000a",
        "0x1c58",
        "0x0005",
        "0x6c43",
        "0x6369",
        "0x006b",
        "0x0024",
        "0x0001",
        "0x029f"
      ],
      "identifierReferenceCandidateNames": [
        "Picture1_Click"
      ],
      "literalTexts": [
        "Click"
      ],
      "matchedCommands": [
        "CLICK"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0285",
      "sourceRange": {
        "byteStart": 25702,
        "byteEnd": 26876
      },
      "rawWordsHex": [
        "0x4000",
        "0x000b",
        "0x02f7",
        "0x000e",
        "0x0001",
        "0x0fc7",
        "0x000b",
        "0x02f7",
        "0x000e",
        "0x0001",
        "0x1055",
        "0x00de",
        "0x000b",
        "0x02f7",
        "0x000e",
        "0x0001",
        "0x1060",
        "0x00e5",
        "0x0032",
        "0x00e3",
        "0x00a4",
        "0x0049",
        "0x2256",
        "0x5000",
        "0x000b",
        "0x02f7",
        "0x000e",
        "0x0001",
        "0x0fc7",
        "0x000b",
        "0x02f7",
        "0x000e"
      ],
      "identifierReferenceCandidateNames": [
        "M_Check_Click",
        "ItemWave",
        "Experience",
        "M_Fight",
        "MS_NG_Opening_Click",
        "About",
        "SetEnmNODefault",
        "BGMF",
        "Escape",
        "Defense",
        "Enemy",
        "Left",
        "LoadEnd",
        "Message",
        "Picture1_Click",
        "MSGCashe"
      ],
      "literalTexts": [
        "Default",
        "MaxHPUP",
        "Default",
        "MaxMPUP",
        "Default",
        "OffenseUP",
        "Default",
        "DefenseUP",
        "Default",
        "SpeedUP",
        "Print ",
        "は、レベルアップした！",
        "DrawState "
      ],
      "matchedCommands": [
        "PRINT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0291",
      "sourceRange": {
        "byteStart": 26946,
        "byteEnd": 26976
      },
      "rawWordsHex": [
        "0x2000",
        "0x000b",
        "0x087a",
        "0x0045",
        "0x22c4",
        "0x00ed",
        "0x000a",
        "0x22ac",
        "0x0005",
        "0x6c43",
        "0x6369",
        "0x006b",
        "0x0024",
        "0x0001",
        "0x029f"
      ],
      "identifierReferenceCandidateNames": [
        "MSGCashe",
        "Picture1_Click"
      ],
      "literalTexts": [
        "Click"
      ],
      "matchedCommands": [
        "CLICK"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0292",
      "sourceRange": {
        "byteStart": 26976,
        "byteEnd": 27004
      },
      "rawWordsHex": [
        "0x2000",
        "0x00ed",
        "0x0010",
        "0x22cc",
        "0x000a",
        "0x6e45",
        "0x4664",
        "0x6769",
        "0x7468",
        "0x3020",
        "0x0000",
        "0x0024",
        "0x0001",
        "0x029f"
      ],
      "identifierReferenceCandidateNames": [
        "Picture1_Click"
      ],
      "literalTexts": [
        "EndFight 0"
      ],
      "matchedCommands": [
        "ENDFIGHT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0293",
      "sourceRange": {
        "byteStart": 27004,
        "byteEnd": 27022
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x000a",
        "0x22f6",
        "0x0004",
        "0x4157",
        "0x5449",
        "0x0000",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "WAIT"
      ],
      "matchedCommands": [
        "WAIT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0295",
      "sourceRange": {
        "byteStart": 27042,
        "byteEnd": 27060
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x000a",
        "0x232a",
        "0x0004",
        "0x4157",
        "0x4b4c",
        "0x0000",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "WALK"
      ],
      "matchedCommands": [
        "WALK"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0306",
      "sourceRange": {
        "byteStart": 27224,
        "byteEnd": 27244
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x000c",
        "0x2418",
        "0x0006",
        "0x4957",
        "0x4550",
        "0x4e49",
        "0x0000",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [
        "About"
      ],
      "literalTexts": [
        "WIPEIN"
      ],
      "matchedCommands": [
        "WIPEIN"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0308",
      "sourceRange": {
        "byteStart": 27254,
        "byteEnd": 27274
      },
      "rawWordsHex": [
        "0x1000",
        "0x00ed",
        "0x000c",
        "0x2446",
        "0x0007",
        "0x4957",
        "0x4550",
        "0x554f",
        "0x0054",
        "0x0026"
      ],
      "identifierReferenceCandidateNames": [
        "About"
      ],
      "literalTexts": [
        "WIPEOUT"
      ],
      "matchedCommands": [
        "WIPEOUT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1018",
      "sourceRange": {
        "lineStart": 1018,
        "lineEnd": 1018
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "ENEMYDAMAGE"
      ],
      "matchedCommands": [
        "ENEMYDAMAGE"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1043",
      "sourceRange": {
        "lineStart": 1043,
        "lineEnd": 1043
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "EXIST"
      ],
      "matchedCommands": [
        "EXIST"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1046",
      "sourceRange": {
        "lineStart": 1046,
        "lineEnd": 1046
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "FIGHT"
      ],
      "matchedCommands": [
        "FIGHT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1050",
      "sourceRange": {
        "lineStart": 1050,
        "lineEnd": 1050
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "FLAG"
      ],
      "matchedCommands": [
        "FLAG"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1056",
      "sourceRange": {
        "lineStart": 1056,
        "lineEnd": 1056
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "GAMEOVER"
      ],
      "matchedCommands": [
        "GAMEOVER"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1061",
      "sourceRange": {
        "lineStart": 1061,
        "lineEnd": 1061
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "HP"
      ],
      "matchedCommands": [
        "HP"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1077",
      "sourceRange": {
        "lineStart": 1077,
        "lineEnd": 1077
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "INN"
      ],
      "matchedCommands": [
        "INN"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1084",
      "sourceRange": {
        "lineStart": 1084,
        "lineEnd": 1084
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "ITEM"
      ],
      "matchedCommands": [
        "ITEM"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1091",
      "sourceRange": {
        "lineStart": 1091,
        "lineEnd": 1091
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "MENU"
      ],
      "matchedCommands": [
        "MENU"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1102",
      "sourceRange": {
        "lineStart": 1102,
        "lineEnd": 1102
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "MESSAGECLEAR"
      ],
      "matchedCommands": [
        "MESSAGECLEAR"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1104",
      "sourceRange": {
        "lineStart": 1104,
        "lineEnd": 1104
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "MONEY"
      ],
      "matchedCommands": [
        "MONEY"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1109",
      "sourceRange": {
        "lineStart": 1109,
        "lineEnd": 1109
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "MOVE"
      ],
      "matchedCommands": [
        "MOVE"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1118",
      "sourceRange": {
        "lineStart": 1118,
        "lineEnd": 1118
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "MP"
      ],
      "matchedCommands": [
        "MP"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1134",
      "sourceRange": {
        "lineStart": 1134,
        "lineEnd": 1134
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "MPD"
      ],
      "matchedCommands": [
        "MPD"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1149",
      "sourceRange": {
        "lineStart": 1149,
        "lineEnd": 1149
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "PRINT"
      ],
      "matchedCommands": [
        "PRINT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1160",
      "sourceRange": {
        "lineStart": 1160,
        "lineEnd": 1160
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "SHOWENEMY"
      ],
      "matchedCommands": [
        "SHOWENEMY"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1164",
      "sourceRange": {
        "lineStart": 1164,
        "lineEnd": 1164
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "SILENTCHAR"
      ],
      "matchedCommands": [
        "SILENTCHAR"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1166",
      "sourceRange": {
        "lineStart": 1166,
        "lineEnd": 1166
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "SILENTMOVE"
      ],
      "matchedCommands": [
        "SILENTMOVE"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1173",
      "sourceRange": {
        "lineStart": 1173,
        "lineEnd": 1173
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "SILENTWAY"
      ],
      "matchedCommands": [
        "SILENTWAY"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1175",
      "sourceRange": {
        "lineStart": 1175,
        "lineEnd": 1175
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "SOUND"
      ],
      "matchedCommands": [
        "SOUND"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1177",
      "sourceRange": {
        "lineStart": 1177,
        "lineEnd": 1177
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "STARTENEMYDAMAGE"
      ],
      "matchedCommands": [
        "STARTENEMYDAMAGE"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1180",
      "sourceRange": {
        "lineStart": 1180,
        "lineEnd": 1180
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "STARTFIGHT"
      ],
      "matchedCommands": [
        "STARTFIGHT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1185",
      "sourceRange": {
        "lineStart": 1185,
        "lineEnd": 1185
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "SHOP"
      ],
      "matchedCommands": [
        "SHOP"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1194",
      "sourceRange": {
        "lineStart": 1194,
        "lineEnd": 1194
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "STOPBGM"
      ],
      "matchedCommands": [
        "STOPBGM"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1196",
      "sourceRange": {
        "lineStart": 1196,
        "lineEnd": 1196
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "TURN"
      ],
      "matchedCommands": [
        "TURN"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1199",
      "sourceRange": {
        "lineStart": 1199,
        "lineEnd": 1199
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "VICTORY"
      ],
      "matchedCommands": [
        "VICTORY"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1253",
      "sourceRange": {
        "lineStart": 1253,
        "lineEnd": 1253
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "WAIT"
      ],
      "matchedCommands": [
        "WAIT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1255",
      "sourceRange": {
        "lineStart": 1255,
        "lineEnd": 1255
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "WALK"
      ],
      "matchedCommands": [
        "WALK"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1260",
      "sourceRange": {
        "lineStart": 1260,
        "lineEnd": 1260
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "WALKSTART"
      ],
      "matchedCommands": [
        "WALKSTART"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1262",
      "sourceRange": {
        "lineStart": 1262,
        "lineEnd": 1262
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "WAY"
      ],
      "matchedCommands": [
        "WAY"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1266",
      "sourceRange": {
        "lineStart": 1266,
        "lineEnd": 1266
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "WIPEIN"
      ],
      "matchedCommands": [
        "WIPEIN"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1268",
      "sourceRange": {
        "lineStart": 1268,
        "lineEnd": 1268
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "WIPEOUT"
      ],
      "matchedCommands": [
        "WIPEOUT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:948",
      "sourceRange": {
        "lineStart": 948,
        "lineEnd": 948
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "BACKTOTITLE"
      ],
      "matchedCommands": [
        "BACKTOTITLE"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:950",
      "sourceRange": {
        "lineStart": 950,
        "lineEnd": 950
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "CHANGEBGM"
      ],
      "matchedCommands": [
        "CHANGEBGM"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:953",
      "sourceRange": {
        "lineStart": 953,
        "lineEnd": 953
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "CHAR"
      ],
      "matchedCommands": [
        "CHAR"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:957",
      "sourceRange": {
        "lineStart": 957,
        "lineEnd": 957
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "CLICK"
      ],
      "matchedCommands": [
        "CLICK"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:959",
      "sourceRange": {
        "lineStart": 959,
        "lineEnd": 959
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "COMMAND"
      ],
      "matchedCommands": [
        "COMMAND"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:965",
      "sourceRange": {
        "lineStart": 965,
        "lineEnd": 965
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "DAMAGE"
      ],
      "matchedCommands": [
        "DAMAGE"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:983",
      "sourceRange": {
        "lineStart": 983,
        "lineEnd": 983
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "DRAW"
      ],
      "matchedCommands": [
        "DRAW"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:995",
      "sourceRange": {
        "lineStart": 995,
        "lineEnd": 995
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "DRAWSTATE"
      ],
      "matchedCommands": [
        "DRAWSTATE"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:997",
      "sourceRange": {
        "lineStart": 997,
        "lineEnd": 997
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "ENDENEMYDAMAGE"
      ],
      "matchedCommands": [
        "ENDENEMYDAMAGE"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    },
    {
      "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:999",
      "sourceRange": {
        "lineStart": 999,
        "lineEnd": 999
      },
      "rawWordsHex": [],
      "identifierReferenceCandidateNames": [],
      "literalTexts": [
        "ENDFIGHT"
      ],
      "matchedCommands": [
        "ENDFIGHT"
      ],
      "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
      "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
    }
  ],
  "basMessageEmitterSummary": {
    "CHANGEBGM": {
      "count": 2,
      "sampleEmitters": [
        {
          "module": "MAIN.BAS",
          "procedure": "EndFight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.decoded-statement-0005",
          "statementText": "Message \"ChangeBGM \" + BGMFile",
          "sourceRange": {
            "lineStart": 52,
            "lineEnd": 52,
            "columnStart": 5,
            "columnEnd": 34
          },
          "literalPrefix": "ChangeBGM ",
          "command": "CHANGEBGM",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAIN.BAS",
          "procedure": "EscapeFight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.decoded-statement-0005",
          "statementText": "Message \"ChangeBGM \" + BGMFile",
          "sourceRange": {
            "lineStart": 64,
            "lineEnd": 64,
            "columnStart": 5,
            "columnEnd": 34
          },
          "literalPrefix": "ChangeBGM ",
          "command": "CHANGEBGM",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "statementIds": [
        "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.decoded-statement-0005",
        "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.decoded-statement-0005"
      ]
    },
    "CLICK": {
      "count": 6,
      "sampleEmitters": [
        {
          "module": "ITEM.BAS",
          "procedure": "UsableCheck",
          "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UsableCheck.text-001",
          "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UsableCheck.text-001.json",
          "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UsableCheck.text-001.decoded-statement-0018",
          "statementText": "If UC = False And (MainState And Fighting) = 0 Then Message \"Click\"",
          "sourceRange": {
            "lineStart": 72,
            "lineEnd": 72,
            "columnStart": 5,
            "columnEnd": 71
          },
          "literalPrefix": "Click",
          "command": "CLICK",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ITEM.BAS",
          "procedure": "UseItem",
          "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
          "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
          "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0238",
          "statementText": "Message \"Click\"",
          "sourceRange": {
            "lineStart": 313,
            "lineEnd": 313,
            "columnStart": 9,
            "columnEnd": 23
          },
          "literalPrefix": "Click",
          "command": "CLICK",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAGIC.BAS",
          "procedure": "MagicCheck",
          "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.MagicCheck.text-001",
          "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.MagicCheck.text-001.json",
          "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.MagicCheck.text-001.decoded-statement-0014",
          "statementText": "If UC = False And (MainState And Fighting) = 0 Then Message \"Click\"",
          "sourceRange": {
            "lineStart": 25,
            "lineEnd": 25,
            "columnStart": 5,
            "columnEnd": 71
          },
          "literalPrefix": "Click",
          "command": "CLICK",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAGIC.BAS",
          "procedure": "UseMagic",
          "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
          "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
          "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0162",
          "statementText": "Message \"Click\"",
          "sourceRange": {
            "lineStart": 210,
            "lineEnd": 210,
            "columnStart": 9,
            "columnEnd": 23
          },
          "literalPrefix": "Click",
          "command": "CLICK",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAIN.BAS",
          "procedure": "Fight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.decoded-statement-0055",
          "statementText": "Message \"Click\"",
          "sourceRange": {
            "lineStart": 126,
            "lineEnd": 126,
            "columnStart": 5,
            "columnEnd": 19
          },
          "literalPrefix": "Click",
          "command": "CLICK",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAIN.BAS",
          "procedure": "GameOver",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.decoded-statement-0003",
          "statementText": "Message \"Click\"",
          "sourceRange": {
            "lineStart": 145,
            "lineEnd": 145,
            "columnStart": 5,
            "columnEnd": 19
          },
          "literalPrefix": "Click",
          "command": "CLICK",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "statementIds": [
        "ITEM.BAS-2a757177b8-3fc33fcd.UsableCheck.text-001.decoded-statement-0018",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0238",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.MagicCheck.text-001.decoded-statement-0014",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0162",
        "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.decoded-statement-0055",
        "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.decoded-statement-0003"
      ]
    },
    "COMMAND": {
      "count": 1,
      "sampleEmitters": [
        {
          "module": "MAIN.BAS",
          "procedure": "StartTurn",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007.decoded-statement-0035",
          "statementText": "Message \"Command \" + CStr(TurnNO)",
          "sourceRange": {
            "lineStart": 219,
            "lineEnd": 219,
            "columnStart": 9,
            "columnEnd": 41
          },
          "literalPrefix": "Command ",
          "command": "COMMAND",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "statementIds": [
        "MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007.decoded-statement-0035"
      ]
    },
    "DAMAGE": {
      "count": 2,
      "sampleEmitters": [
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0030",
          "statementText": "Message \"DAMAGE \" + CStr(Target) + \" \" + CStr(V2) + \" \" + Wave",
          "sourceRange": {
            "lineStart": 74,
            "lineEnd": 74,
            "columnStart": 9,
            "columnEnd": 70
          },
          "literalPrefix": "DAMAGE ",
          "command": "DAMAGE",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0047",
          "statementText": "Message \"DAMAGE \" + CStr(I) + \" \" + CStr(V2) + \" Damage\"",
          "sourceRange": {
            "lineStart": 91,
            "lineEnd": 91,
            "columnStart": 17,
            "columnEnd": 72
          },
          "literalPrefix": "DAMAGE ",
          "command": "DAMAGE",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "statementIds": [
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0030",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0047"
      ]
    },
    "ENDFIGHT": {
      "count": 4,
      "sampleEmitters": [
        {
          "module": "MAIN.BAS",
          "procedure": "EndFight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.decoded-statement-0007",
          "statementText": "Message \"EndFight 1\"",
          "sourceRange": {
            "lineStart": 54,
            "lineEnd": 54,
            "columnStart": 5,
            "columnEnd": 24
          },
          "literalPrefix": "EndFight 1",
          "command": "ENDFIGHT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAIN.BAS",
          "procedure": "EscapeFight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.decoded-statement-0007",
          "statementText": "Message \"EndFight 3\"",
          "sourceRange": {
            "lineStart": 66,
            "lineEnd": 66,
            "columnStart": 5,
            "columnEnd": 24
          },
          "literalPrefix": "EndFight 3",
          "command": "ENDFIGHT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAIN.BAS",
          "procedure": "Fight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.decoded-statement-0066",
          "statementText": "Message \"EndFight 0\"",
          "sourceRange": {
            "lineStart": 138,
            "lineEnd": 138,
            "columnStart": 5,
            "columnEnd": 24
          },
          "literalPrefix": "EndFight 0",
          "command": "ENDFIGHT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAIN.BAS",
          "procedure": "StartTurn",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007.decoded-statement-0030",
          "statementText": "Message \"EndFight 0\"",
          "sourceRange": {
            "lineStart": 214,
            "lineEnd": 214,
            "columnStart": 9,
            "columnEnd": 28
          },
          "literalPrefix": "EndFight 0",
          "command": "ENDFIGHT",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "statementIds": [
        "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.decoded-statement-0007",
        "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.decoded-statement-0007",
        "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.decoded-statement-0066",
        "MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007.decoded-statement-0030"
      ]
    },
    "ENEMYDAMAGE": {
      "count": 2,
      "sampleEmitters": [
        {
          "module": "ITEM.BAS",
          "procedure": "UseItem",
          "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
          "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
          "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0199",
          "statementText": "Message \"EnemyDamage \" + CStr(EnmNO) + \" \" + CStr(DM) + \" Attack\"",
          "sourceRange": {
            "lineStart": 274,
            "lineEnd": 274,
            "columnStart": 17,
            "columnEnd": 81
          },
          "literalPrefix": "EnemyDamage ",
          "command": "ENEMYDAMAGE",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAGIC.BAS",
          "procedure": "UseMagic",
          "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
          "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
          "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0149",
          "statementText": "Message \"EnemyDamage \" + CStr(I) + \" \" + CStr(DM) + \" Attack\"",
          "sourceRange": {
            "lineStart": 197,
            "lineEnd": 197,
            "columnStart": 17,
            "columnEnd": 77
          },
          "literalPrefix": "EnemyDamage ",
          "command": "ENEMYDAMAGE",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "statementIds": [
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0199",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0149"
      ]
    },
    "FIGHT": {
      "count": 1,
      "sampleEmitters": [
        {
          "module": "SUB.BAS",
          "procedure": "WalkingSub",
          "procedureId": "SUB.BAS-8ff879e9dc-302a874f.WalkingSub.018",
          "procedureIrPath": "docs/vb2-ir/procedures/SUB.BAS-8ff879e9dc-302a874f.WalkingSub.018.json",
          "statementId": "SUB.BAS-8ff879e9dc-302a874f.WalkingSub.018.decoded-statement-0032",
          "statementText": "Message \"Fight \" + CStr(ENMLevel)",
          "sourceRange": {
            "lineStart": 364,
            "lineEnd": 364,
            "columnStart": 17,
            "columnEnd": 49
          },
          "literalPrefix": "Fight ",
          "command": "FIGHT",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "statementIds": [
        "SUB.BAS-8ff879e9dc-302a874f.WalkingSub.018.decoded-statement-0032"
      ]
    },
    "HP": {
      "count": 4,
      "sampleEmitters": [
        {
          "module": "ITEM.BAS",
          "procedure": "UseItem",
          "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
          "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
          "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0019",
          "statementText": "Message \"HP \" + A2 + \" \" + CStr(ItemEffect(IN - 1))",
          "sourceRange": {
            "lineStart": 96,
            "lineEnd": 96,
            "columnStart": 9,
            "columnEnd": 59
          },
          "literalPrefix": "HP ",
          "command": "HP",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ITEM.BAS",
          "procedure": "UseItem",
          "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
          "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
          "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0025",
          "statementText": "Message \"HP \" + A2 + \" \" + CStr(ItemEffect(IN - 1))",
          "sourceRange": {
            "lineStart": 102,
            "lineEnd": 102,
            "columnStart": 9,
            "columnEnd": 59
          },
          "literalPrefix": "HP ",
          "command": "HP",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAGIC.BAS",
          "procedure": "UseMagic",
          "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
          "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
          "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0018",
          "statementText": "Message \"HP \" + A2 + \" \" + CStr(MagicEffect(IN - 1))",
          "sourceRange": {
            "lineStart": 66,
            "lineEnd": 66,
            "columnStart": 9,
            "columnEnd": 60
          },
          "literalPrefix": "HP ",
          "command": "HP",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAGIC.BAS",
          "procedure": "UseMagic",
          "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
          "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
          "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0024",
          "statementText": "Message \"HP \" + A2 + \" \" + CStr(MagicEffect(IN - 1))",
          "sourceRange": {
            "lineStart": 72,
            "lineEnd": 72,
            "columnStart": 9,
            "columnEnd": 60
          },
          "literalPrefix": "HP ",
          "command": "HP",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "statementIds": [
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0019",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0025",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0018",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0024"
      ]
    },
    "MENU": {
      "count": 2,
      "sampleEmitters": [
        {
          "module": "MAIN.BAS",
          "procedure": "Fight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.decoded-statement-0016",
          "statementText": "Message \"Menu ET\"",
          "sourceRange": {
            "lineStart": 87,
            "lineEnd": 87,
            "columnStart": 5,
            "columnEnd": 21
          },
          "literalPrefix": "Menu ET",
          "command": "MENU",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAIN.BAS",
          "procedure": "GameOver",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.decoded-statement-0011",
          "statementText": "Message \"Menu First\"",
          "sourceRange": {
            "lineStart": 153,
            "lineEnd": 153,
            "columnStart": 5,
            "columnEnd": 24
          },
          "literalPrefix": "Menu First",
          "command": "MENU",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "statementIds": [
        "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.decoded-statement-0016",
        "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.decoded-statement-0011"
      ]
    },
    "MESSAGECLEAR": {
      "count": 2,
      "sampleEmitters": [
        {
          "module": "MAIN.BAS",
          "procedure": "EndFight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.decoded-statement-0004",
          "statementText": "Message \"MessageClear\"",
          "sourceRange": {
            "lineStart": 51,
            "lineEnd": 51,
            "columnStart": 5,
            "columnEnd": 26
          },
          "literalPrefix": "MessageClear",
          "command": "MESSAGECLEAR",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAIN.BAS",
          "procedure": "EscapeFight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.decoded-statement-0004",
          "statementText": "Message \"MessageClear\"",
          "sourceRange": {
            "lineStart": 63,
            "lineEnd": 63,
            "columnStart": 5,
            "columnEnd": 26
          },
          "literalPrefix": "MessageClear",
          "command": "MESSAGECLEAR",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "statementIds": [
        "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.decoded-statement-0004",
        "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.decoded-statement-0004"
      ]
    },
    "MP": {
      "count": 5,
      "sampleEmitters": [
        {
          "module": "ITEM.BAS",
          "procedure": "UseItem",
          "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
          "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
          "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0022",
          "statementText": "Message \"MP \" + A2 + \" \" + CStr(ItemEffect(IN - 1))",
          "sourceRange": {
            "lineStart": 99,
            "lineEnd": 99,
            "columnStart": 9,
            "columnEnd": 59
          },
          "literalPrefix": "MP ",
          "command": "MP",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ITEM.BAS",
          "procedure": "UseItem",
          "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
          "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
          "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0026",
          "statementText": "Message \"MP \" + A2 + \" \" + CStr(ItemEffect(IN - 1))",
          "sourceRange": {
            "lineStart": 103,
            "lineEnd": 103,
            "columnStart": 9,
            "columnEnd": 59
          },
          "literalPrefix": "MP ",
          "command": "MP",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAGIC.BAS",
          "procedure": "UseMagic",
          "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
          "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
          "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0014",
          "statementText": "Message \"MP \" + CStr(ManNO) + \" -\" + CStr(MagicMP(IN - 1))",
          "sourceRange": {
            "lineStart": 62,
            "lineEnd": 62,
            "columnStart": 5,
            "columnEnd": 62
          },
          "literalPrefix": "MP ",
          "command": "MP",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAGIC.BAS",
          "procedure": "UseMagic",
          "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
          "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
          "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0021",
          "statementText": "Message \"MP \" + A2 + \" \" + CStr(MagicEffect(IN - 1))",
          "sourceRange": {
            "lineStart": 69,
            "lineEnd": 69,
            "columnStart": 9,
            "columnEnd": 60
          },
          "literalPrefix": "MP ",
          "command": "MP",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAGIC.BAS",
          "procedure": "UseMagic",
          "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
          "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
          "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0025",
          "statementText": "Message \"MP \" + A2 + \" \" + CStr(MagicEffect(IN - 1))",
          "sourceRange": {
            "lineStart": 73,
            "lineEnd": 73,
            "columnStart": 9,
            "columnEnd": 60
          },
          "literalPrefix": "MP ",
          "command": "MP",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "statementIds": [
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0022",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0026",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0014",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0021",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0025"
      ]
    },
    "PRINT": {
      "count": 103,
      "sampleEmitters": [
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0011",
          "statementText": "Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
          "sourceRange": {
            "lineStart": 55,
            "lineEnd": 55,
            "columnStart": 13,
            "columnEnd": 57
          },
          "literalPrefix": "Print ",
          "command": "PRINT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0013",
          "statementText": "Message \"Print \" + EnemyName(Enemy(ENO)) + \"の攻撃\"",
          "sourceRange": {
            "lineStart": 57,
            "lineEnd": 57,
            "columnStart": 13,
            "columnEnd": 60
          },
          "literalPrefix": "Print ",
          "command": "PRINT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0034",
          "statementText": "Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
          "sourceRange": {
            "lineStart": 78,
            "lineEnd": 78,
            "columnStart": 13,
            "columnEnd": 57
          },
          "literalPrefix": "Print ",
          "command": "PRINT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0036",
          "statementText": "Message \"Print \" + EnemyName(Enemy(ENO)) + \"の攻撃\"",
          "sourceRange": {
            "lineStart": 80,
            "lineEnd": 80,
            "columnStart": 13,
            "columnEnd": 60
          },
          "literalPrefix": "Print ",
          "command": "PRINT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0052",
          "statementText": "If EnemyCText(Enemy(ENO), Tp) <> \"\" Then Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
          "sourceRange": {
            "lineStart": 96,
            "lineEnd": 96,
            "columnStart": 9,
            "columnEnd": 94
          },
          "literalPrefix": "Print ",
          "command": "PRINT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0060",
          "statementText": "Message \"Print \" + EnemyName(Enemy(Target)) + \"のＨＰは、\" + CStr(Vl) + \"回復した\"",
          "sourceRange": {
            "lineStart": 103,
            "lineEnd": 103,
            "columnStart": 9,
            "columnEnd": 81
          },
          "literalPrefix": "Print ",
          "command": "PRINT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0064",
          "statementText": "If EnemyCText(Enemy(ENO), Tp) <> \"\" Then Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
          "sourceRange": {
            "lineStart": 107,
            "lineEnd": 107,
            "columnStart": 9,
            "columnEnd": 94
          },
          "literalPrefix": "Print ",
          "command": "PRINT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0072",
          "statementText": "Message \"Print 敵全員のＨＰは、\" + CStr(Vl) + \"回復した\"",
          "sourceRange": {
            "lineStart": 114,
            "lineEnd": 114,
            "columnStart": 9,
            "columnEnd": 52
          },
          "literalPrefix": "Print 敵全員のＨＰは、",
          "command": "PRINT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0076",
          "statementText": "If EnemyCText(Enemy(ENO), Tp) <> \"\" Then Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
          "sourceRange": {
            "lineStart": 118,
            "lineEnd": 118,
            "columnStart": 9,
            "columnEnd": 94
          },
          "literalPrefix": "Print ",
          "command": "PRINT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0090",
          "statementText": "Message \"Print しかし、効果はなかった\"",
          "sourceRange": {
            "lineStart": 131,
            "lineEnd": 131,
            "columnStart": 13,
            "columnEnd": 39
          },
          "literalPrefix": "Print しかし、効果はなかった",
          "command": "PRINT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0092",
          "statementText": "Message \"Print \" + EnemyName(Enemy(Target)) + \"の攻撃力は、\" + CStr(Vl) + \"上がった\"",
          "sourceRange": {
            "lineStart": 133,
            "lineEnd": 133,
            "columnStart": 13,
            "columnEnd": 86
          },
          "literalPrefix": "Print ",
          "command": "PRINT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0097",
          "statementText": "If EnemyCText(Enemy(ENO), Tp) <> \"\" Then Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
          "sourceRange": {
            "lineStart": 138,
            "lineEnd": 138,
            "columnStart": 9,
            "columnEnd": 94
          },
          "literalPrefix": "Print ",
          "command": "PRINT",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "statementIds": [
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0011",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0013",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0034",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0036",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0052",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0060",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0064",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0072",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0076",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0090",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0092",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0097",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0111",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0113",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0118",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0126",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0128",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0133",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0145",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0147",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0152",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0160",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0162",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0167",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0179",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0181",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0186",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0195",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0197",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0202",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0215",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0217",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0222",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0231",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0233",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0238",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0251",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0253",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0258",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0267",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0269",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0274",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0287",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0289",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0299",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0302",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0309",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0311",
        "FILESYS.BAS-cab069b3ba-6a507a5e.LoadData.text-000.decoded-statement-0010",
        "FILESYS.BAS-cab069b3ba-6a507a5e.SaveData.001.decoded-statement-0040",
        "ITEM.BAS-2a757177b8-3fc33fcd.UsableCheck.text-001.decoded-statement-0003",
        "ITEM.BAS-2a757177b8-3fc33fcd.UsableCheck.text-001.decoded-statement-0007",
        "ITEM.BAS-2a757177b8-3fc33fcd.UsableCheck.text-001.decoded-statement-0011",
        "ITEM.BAS-2a757177b8-3fc33fcd.UsableCheck.text-001.decoded-statement-0015",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0012",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0014",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0018",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0021",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0024",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0028",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0039",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0050",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0059",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0068",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0096",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0099",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0113",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0117",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0131",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0135",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0148",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0152",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0165",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0169",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0182",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0186",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0212",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0217",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0222",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0230",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.MagicCheck.text-001.decoded-statement-0003",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.MagicCheck.text-001.decoded-statement-0007",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.MagicCheck.text-001.decoded-statement-0011",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0013",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0017",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0020",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0023",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0046",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0049",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0063",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0067",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0081",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0085",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0098",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0102",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0115",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0119",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0132",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0136",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0154",
        "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.decoded-statement-0054",
        "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.decoded-statement-0002",
        "SUB.BAS-8ff879e9dc-302a874f.Dead.006.decoded-statement-0001"
      ]
    },
    "SHOWENEMY": {
      "count": 1,
      "sampleEmitters": [
        {
          "module": "MAIN.BAS",
          "procedure": "Fight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.decoded-statement-0053",
          "statementText": "Message \"ShowEnemy\"",
          "sourceRange": {
            "lineStart": 124,
            "lineEnd": 124,
            "columnStart": 5,
            "columnEnd": 23
          },
          "literalPrefix": "ShowEnemy",
          "command": "SHOWENEMY",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "statementIds": [
        "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.decoded-statement-0053"
      ]
    },
    "SOUND": {
      "count": 20,
      "sampleEmitters": [
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0032",
          "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
          "sourceRange": {
            "lineStart": 76,
            "lineEnd": 76,
            "columnStart": 9,
            "columnEnd": 89
          },
          "literalPrefix": "Sound ",
          "command": "SOUND",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0051",
          "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
          "sourceRange": {
            "lineStart": 95,
            "lineEnd": 95,
            "columnStart": 9,
            "columnEnd": 89
          },
          "literalPrefix": "Sound ",
          "command": "SOUND",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0063",
          "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
          "sourceRange": {
            "lineStart": 106,
            "lineEnd": 106,
            "columnStart": 9,
            "columnEnd": 89
          },
          "literalPrefix": "Sound ",
          "command": "SOUND",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0075",
          "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
          "sourceRange": {
            "lineStart": 117,
            "lineEnd": 117,
            "columnStart": 9,
            "columnEnd": 89
          },
          "literalPrefix": "Sound ",
          "command": "SOUND",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0096",
          "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
          "sourceRange": {
            "lineStart": 137,
            "lineEnd": 137,
            "columnStart": 9,
            "columnEnd": 89
          },
          "literalPrefix": "Sound ",
          "command": "SOUND",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0117",
          "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
          "sourceRange": {
            "lineStart": 157,
            "lineEnd": 157,
            "columnStart": 9,
            "columnEnd": 89
          },
          "literalPrefix": "Sound ",
          "command": "SOUND",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0132",
          "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
          "sourceRange": {
            "lineStart": 171,
            "lineEnd": 171,
            "columnStart": 9,
            "columnEnd": 89
          },
          "literalPrefix": "Sound ",
          "command": "SOUND",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0151",
          "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
          "sourceRange": {
            "lineStart": 189,
            "lineEnd": 189,
            "columnStart": 9,
            "columnEnd": 89
          },
          "literalPrefix": "Sound ",
          "command": "SOUND",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0166",
          "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
          "sourceRange": {
            "lineStart": 203,
            "lineEnd": 203,
            "columnStart": 9,
            "columnEnd": 89
          },
          "literalPrefix": "Sound ",
          "command": "SOUND",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0185",
          "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
          "sourceRange": {
            "lineStart": 221,
            "lineEnd": 221,
            "columnStart": 9,
            "columnEnd": 89
          },
          "literalPrefix": "Sound ",
          "command": "SOUND",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0201",
          "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
          "sourceRange": {
            "lineStart": 236,
            "lineEnd": 236,
            "columnStart": 9,
            "columnEnd": 89
          },
          "literalPrefix": "Sound ",
          "command": "SOUND",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0221",
          "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
          "sourceRange": {
            "lineStart": 255,
            "lineEnd": 255,
            "columnStart": 9,
            "columnEnd": 89
          },
          "literalPrefix": "Sound ",
          "command": "SOUND",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "statementIds": [
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0032",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0051",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0063",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0075",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0096",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0117",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0132",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0151",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0166",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0185",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0201",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0221",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0237",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0257",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0273",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0294",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0296",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0009",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0009",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0011"
      ]
    },
    "STARTFIGHT": {
      "count": 1,
      "sampleEmitters": [
        {
          "module": "MAIN.BAS",
          "procedure": "Fight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.decoded-statement-0064",
          "statementText": "Message \"StartFight\"",
          "sourceRange": {
            "lineStart": 135,
            "lineEnd": 135,
            "columnStart": 5,
            "columnEnd": 24
          },
          "literalPrefix": "StartFight",
          "command": "STARTFIGHT",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "statementIds": [
        "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.decoded-statement-0064"
      ]
    },
    "STOPBGM": {
      "count": 1,
      "sampleEmitters": [
        {
          "module": "MAIN.BAS",
          "procedure": "GameOver",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.decoded-statement-0001",
          "statementText": "Message \"StopBGM\"",
          "sourceRange": {
            "lineStart": 143,
            "lineEnd": 143,
            "columnStart": 5,
            "columnEnd": 21
          },
          "literalPrefix": "StopBGM",
          "command": "STOPBGM",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "statementIds": [
        "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.decoded-statement-0001"
      ]
    },
    "VICTORY": {
      "count": 1,
      "sampleEmitters": [
        {
          "module": "MAIN.BAS",
          "procedure": "StartTurn",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007.decoded-statement-0018",
          "statementText": "Message \"Victory\"",
          "sourceRange": {
            "lineStart": 201,
            "lineEnd": 201,
            "columnStart": 9,
            "columnEnd": 25
          },
          "literalPrefix": "Victory",
          "command": "VICTORY",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "statementIds": [
        "MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007.decoded-statement-0018"
      ]
    },
    "WAIT": {
      "count": 34,
      "sampleEmitters": [
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0038",
          "statementText": "Message \"Wait 100\"",
          "sourceRange": {
            "lineStart": 82,
            "lineEnd": 82,
            "columnStart": 9,
            "columnEnd": 26
          },
          "literalPrefix": "Wait 100",
          "command": "WAIT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0053",
          "statementText": "Message \"Wait 100\"",
          "sourceRange": {
            "lineStart": 96,
            "lineEnd": 96,
            "columnStart": 97,
            "columnEnd": 114
          },
          "literalPrefix": "Wait 100",
          "command": "WAIT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0061",
          "statementText": "Message \"Wait 100\"",
          "sourceRange": {
            "lineStart": 104,
            "lineEnd": 104,
            "columnStart": 9,
            "columnEnd": 26
          },
          "literalPrefix": "Wait 100",
          "command": "WAIT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0065",
          "statementText": "Message \"Wait 100\"",
          "sourceRange": {
            "lineStart": 107,
            "lineEnd": 107,
            "columnStart": 97,
            "columnEnd": 114
          },
          "literalPrefix": "Wait 100",
          "command": "WAIT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0073",
          "statementText": "Message \"Wait 100\"",
          "sourceRange": {
            "lineStart": 115,
            "lineEnd": 115,
            "columnStart": 9,
            "columnEnd": 26
          },
          "literalPrefix": "Wait 100",
          "command": "WAIT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0077",
          "statementText": "Message \"Wait 100\"",
          "sourceRange": {
            "lineStart": 118,
            "lineEnd": 118,
            "columnStart": 97,
            "columnEnd": 114
          },
          "literalPrefix": "Wait 100",
          "command": "WAIT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0094",
          "statementText": "Message \"Wait 100\"",
          "sourceRange": {
            "lineStart": 135,
            "lineEnd": 135,
            "columnStart": 9,
            "columnEnd": 26
          },
          "literalPrefix": "Wait 100",
          "command": "WAIT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0098",
          "statementText": "Message \"Wait 100\"",
          "sourceRange": {
            "lineStart": 138,
            "lineEnd": 138,
            "columnStart": 97,
            "columnEnd": 114
          },
          "literalPrefix": "Wait 100",
          "command": "WAIT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0115",
          "statementText": "Message \"Wait 100\"",
          "sourceRange": {
            "lineStart": 155,
            "lineEnd": 155,
            "columnStart": 9,
            "columnEnd": 26
          },
          "literalPrefix": "Wait 100",
          "command": "WAIT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0119",
          "statementText": "Message \"Wait 100\"",
          "sourceRange": {
            "lineStart": 158,
            "lineEnd": 158,
            "columnStart": 97,
            "columnEnd": 114
          },
          "literalPrefix": "Wait 100",
          "command": "WAIT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0130",
          "statementText": "Message \"Wait 100\"",
          "sourceRange": {
            "lineStart": 169,
            "lineEnd": 169,
            "columnStart": 9,
            "columnEnd": 26
          },
          "literalPrefix": "Wait 100",
          "command": "WAIT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0134",
          "statementText": "Message \"Wait 100\"",
          "sourceRange": {
            "lineStart": 172,
            "lineEnd": 172,
            "columnStart": 97,
            "columnEnd": 114
          },
          "literalPrefix": "Wait 100",
          "command": "WAIT",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "statementIds": [
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0038",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0053",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0061",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0065",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0073",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0077",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0094",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0098",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0115",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0119",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0130",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0134",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0149",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0153",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0164",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0168",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0183",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0187",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0199",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0203",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0219",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0223",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0235",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0239",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0255",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0259",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0271",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0275",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0291",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0300",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0306",
        "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0313",
        "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0240",
        "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0164"
      ]
    },
    "WIPEIN": {
      "count": 4,
      "sampleEmitters": [
        {
          "module": "MAIN.BAS",
          "procedure": "EndFight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.decoded-statement-0006",
          "statementText": "Message \"WipeIn\"",
          "sourceRange": {
            "lineStart": 53,
            "lineEnd": 53,
            "columnStart": 5,
            "columnEnd": 20
          },
          "literalPrefix": "WipeIn",
          "command": "WIPEIN",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAIN.BAS",
          "procedure": "EscapeFight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.decoded-statement-0006",
          "statementText": "Message \"WipeIn\"",
          "sourceRange": {
            "lineStart": 65,
            "lineEnd": 65,
            "columnStart": 5,
            "columnEnd": 20
          },
          "literalPrefix": "WipeIn",
          "command": "WIPEIN",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAIN.BAS",
          "procedure": "NewGame",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.NewGame.005",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.NewGame.005.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.NewGame.005.decoded-statement-0012",
          "statementText": "Message \"WipeIn\"",
          "sourceRange": {
            "lineStart": 171,
            "lineEnd": 171,
            "columnStart": 5,
            "columnEnd": 20
          },
          "literalPrefix": "WipeIn",
          "command": "WIPEIN",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "SUB.BAS",
          "procedure": "MsgSub",
          "procedureId": "SUB.BAS-8ff879e9dc-302a874f.MsgSub.014",
          "procedureIrPath": "docs/vb2-ir/procedures/SUB.BAS-8ff879e9dc-302a874f.MsgSub.014.json",
          "statementId": "SUB.BAS-8ff879e9dc-302a874f.MsgSub.014.decoded-statement-0038",
          "statementText": "Message \"WIPEIN\"",
          "sourceRange": {
            "lineStart": 204,
            "lineEnd": 204,
            "columnStart": 9,
            "columnEnd": 24
          },
          "literalPrefix": "WIPEIN",
          "command": "WIPEIN",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "statementIds": [
        "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.decoded-statement-0006",
        "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.decoded-statement-0006",
        "MAIN.BAS-b3b51c6170-6c9943e1.NewGame.005.decoded-statement-0012",
        "SUB.BAS-8ff879e9dc-302a874f.MsgSub.014.decoded-statement-0038"
      ]
    },
    "WIPEOUT": {
      "count": 4,
      "sampleEmitters": [
        {
          "module": "MAIN.BAS",
          "procedure": "Fight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.decoded-statement-0017",
          "statementText": "Message \"WipeOut\"",
          "sourceRange": {
            "lineStart": 88,
            "lineEnd": 88,
            "columnStart": 5,
            "columnEnd": 21
          },
          "literalPrefix": "WipeOut",
          "command": "WIPEOUT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAIN.BAS",
          "procedure": "GameOver",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.decoded-statement-0009",
          "statementText": "Message \"WipeOut\"",
          "sourceRange": {
            "lineStart": 151,
            "lineEnd": 151,
            "columnStart": 9,
            "columnEnd": 25
          },
          "literalPrefix": "WipeOut",
          "command": "WIPEOUT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAIN.BAS",
          "procedure": "NewGame",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.NewGame.005",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.NewGame.005.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.NewGame.005.decoded-statement-0002",
          "statementText": "If MainState = 0 Then Message \"WipeOut\"",
          "sourceRange": {
            "lineStart": 161,
            "lineEnd": 161,
            "columnStart": 5,
            "columnEnd": 43
          },
          "literalPrefix": "WipeOut",
          "command": "WIPEOUT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "SUB.BAS",
          "procedure": "MsgSub",
          "procedureId": "SUB.BAS-8ff879e9dc-302a874f.MsgSub.014",
          "procedureIrPath": "docs/vb2-ir/procedures/SUB.BAS-8ff879e9dc-302a874f.MsgSub.014.json",
          "statementId": "SUB.BAS-8ff879e9dc-302a874f.MsgSub.014.decoded-statement-0036",
          "statementText": "Message \"WIPEOUT\"",
          "sourceRange": {
            "lineStart": 202,
            "lineEnd": 202,
            "columnStart": 9,
            "columnEnd": 25
          },
          "literalPrefix": "WIPEOUT",
          "command": "WIPEOUT",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "statementIds": [
        "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.decoded-statement-0017",
        "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.decoded-statement-0009",
        "MAIN.BAS-b3b51c6170-6c9943e1.NewGame.005.decoded-statement-0002",
        "SUB.BAS-8ff879e9dc-302a874f.MsgSub.014.decoded-statement-0036"
      ]
    }
  },
  "basMessageEmitters": [
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0011",
      "statementText": "Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
      "sourceRange": {
        "lineStart": 55,
        "lineEnd": 55,
        "columnStart": 13,
        "columnEnd": 57
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0013",
      "statementText": "Message \"Print \" + EnemyName(Enemy(ENO)) + \"の攻撃\"",
      "sourceRange": {
        "lineStart": 57,
        "lineEnd": 57,
        "columnStart": 13,
        "columnEnd": 60
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0030",
      "statementText": "Message \"DAMAGE \" + CStr(Target) + \" \" + CStr(V2) + \" \" + Wave",
      "sourceRange": {
        "lineStart": 74,
        "lineEnd": 74,
        "columnStart": 9,
        "columnEnd": 70
      },
      "literalPrefix": "DAMAGE ",
      "command": "DAMAGE",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0032",
      "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
      "sourceRange": {
        "lineStart": 76,
        "lineEnd": 76,
        "columnStart": 9,
        "columnEnd": 89
      },
      "literalPrefix": "Sound ",
      "command": "SOUND",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0034",
      "statementText": "Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
      "sourceRange": {
        "lineStart": 78,
        "lineEnd": 78,
        "columnStart": 13,
        "columnEnd": 57
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0036",
      "statementText": "Message \"Print \" + EnemyName(Enemy(ENO)) + \"の攻撃\"",
      "sourceRange": {
        "lineStart": 80,
        "lineEnd": 80,
        "columnStart": 13,
        "columnEnd": 60
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0038",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 82,
        "lineEnd": 82,
        "columnStart": 9,
        "columnEnd": 26
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0047",
      "statementText": "Message \"DAMAGE \" + CStr(I) + \" \" + CStr(V2) + \" Damage\"",
      "sourceRange": {
        "lineStart": 91,
        "lineEnd": 91,
        "columnStart": 17,
        "columnEnd": 72
      },
      "literalPrefix": "DAMAGE ",
      "command": "DAMAGE",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0051",
      "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
      "sourceRange": {
        "lineStart": 95,
        "lineEnd": 95,
        "columnStart": 9,
        "columnEnd": 89
      },
      "literalPrefix": "Sound ",
      "command": "SOUND",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0052",
      "statementText": "If EnemyCText(Enemy(ENO), Tp) <> \"\" Then Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
      "sourceRange": {
        "lineStart": 96,
        "lineEnd": 96,
        "columnStart": 9,
        "columnEnd": 94
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0053",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 96,
        "lineEnd": 96,
        "columnStart": 97,
        "columnEnd": 114
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0060",
      "statementText": "Message \"Print \" + EnemyName(Enemy(Target)) + \"のＨＰは、\" + CStr(Vl) + \"回復した\"",
      "sourceRange": {
        "lineStart": 103,
        "lineEnd": 103,
        "columnStart": 9,
        "columnEnd": 81
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0061",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 104,
        "lineEnd": 104,
        "columnStart": 9,
        "columnEnd": 26
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0063",
      "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
      "sourceRange": {
        "lineStart": 106,
        "lineEnd": 106,
        "columnStart": 9,
        "columnEnd": 89
      },
      "literalPrefix": "Sound ",
      "command": "SOUND",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0064",
      "statementText": "If EnemyCText(Enemy(ENO), Tp) <> \"\" Then Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
      "sourceRange": {
        "lineStart": 107,
        "lineEnd": 107,
        "columnStart": 9,
        "columnEnd": 94
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0065",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 107,
        "lineEnd": 107,
        "columnStart": 97,
        "columnEnd": 114
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0072",
      "statementText": "Message \"Print 敵全員のＨＰは、\" + CStr(Vl) + \"回復した\"",
      "sourceRange": {
        "lineStart": 114,
        "lineEnd": 114,
        "columnStart": 9,
        "columnEnd": 52
      },
      "literalPrefix": "Print 敵全員のＨＰは、",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0073",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 115,
        "lineEnd": 115,
        "columnStart": 9,
        "columnEnd": 26
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0075",
      "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
      "sourceRange": {
        "lineStart": 117,
        "lineEnd": 117,
        "columnStart": 9,
        "columnEnd": 89
      },
      "literalPrefix": "Sound ",
      "command": "SOUND",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0076",
      "statementText": "If EnemyCText(Enemy(ENO), Tp) <> \"\" Then Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
      "sourceRange": {
        "lineStart": 118,
        "lineEnd": 118,
        "columnStart": 9,
        "columnEnd": 94
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0077",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 118,
        "lineEnd": 118,
        "columnStart": 97,
        "columnEnd": 114
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0090",
      "statementText": "Message \"Print しかし、効果はなかった\"",
      "sourceRange": {
        "lineStart": 131,
        "lineEnd": 131,
        "columnStart": 13,
        "columnEnd": 39
      },
      "literalPrefix": "Print しかし、効果はなかった",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0092",
      "statementText": "Message \"Print \" + EnemyName(Enemy(Target)) + \"の攻撃力は、\" + CStr(Vl) + \"上がった\"",
      "sourceRange": {
        "lineStart": 133,
        "lineEnd": 133,
        "columnStart": 13,
        "columnEnd": 86
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0094",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 135,
        "lineEnd": 135,
        "columnStart": 9,
        "columnEnd": 26
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0096",
      "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
      "sourceRange": {
        "lineStart": 137,
        "lineEnd": 137,
        "columnStart": 9,
        "columnEnd": 89
      },
      "literalPrefix": "Sound ",
      "command": "SOUND",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0097",
      "statementText": "If EnemyCText(Enemy(ENO), Tp) <> \"\" Then Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
      "sourceRange": {
        "lineStart": 138,
        "lineEnd": 138,
        "columnStart": 9,
        "columnEnd": 94
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0098",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 138,
        "lineEnd": 138,
        "columnStart": 97,
        "columnEnd": 114
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0111",
      "statementText": "Message \"Print しかし、効果はなかった\"",
      "sourceRange": {
        "lineStart": 151,
        "lineEnd": 151,
        "columnStart": 13,
        "columnEnd": 39
      },
      "literalPrefix": "Print しかし、効果はなかった",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0113",
      "statementText": "Message \"Print 敵全員の攻撃力は、\" + CStr(Vl) + \"上がった\"",
      "sourceRange": {
        "lineStart": 153,
        "lineEnd": 153,
        "columnStart": 13,
        "columnEnd": 57
      },
      "literalPrefix": "Print 敵全員の攻撃力は、",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0115",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 155,
        "lineEnd": 155,
        "columnStart": 9,
        "columnEnd": 26
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0117",
      "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
      "sourceRange": {
        "lineStart": 157,
        "lineEnd": 157,
        "columnStart": 9,
        "columnEnd": 89
      },
      "literalPrefix": "Sound ",
      "command": "SOUND",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0118",
      "statementText": "If EnemyCText(Enemy(ENO), Tp) <> \"\" Then Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
      "sourceRange": {
        "lineStart": 158,
        "lineEnd": 158,
        "columnStart": 9,
        "columnEnd": 94
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0119",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 158,
        "lineEnd": 158,
        "columnStart": 97,
        "columnEnd": 114
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0126",
      "statementText": "Message \"Print \" + EnemyName(Enemy(Target)) + \"の防御力は、\" + CStr(Vl) + \"上がった\"",
      "sourceRange": {
        "lineStart": 165,
        "lineEnd": 165,
        "columnStart": 13,
        "columnEnd": 86
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0128",
      "statementText": "Message \"Print しかし、効果はなかった\"",
      "sourceRange": {
        "lineStart": 167,
        "lineEnd": 167,
        "columnStart": 13,
        "columnEnd": 39
      },
      "literalPrefix": "Print しかし、効果はなかった",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0130",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 169,
        "lineEnd": 169,
        "columnStart": 9,
        "columnEnd": 26
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0132",
      "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
      "sourceRange": {
        "lineStart": 171,
        "lineEnd": 171,
        "columnStart": 9,
        "columnEnd": 89
      },
      "literalPrefix": "Sound ",
      "command": "SOUND",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0133",
      "statementText": "If EnemyCText(Enemy(ENO), Tp) <> \"\" Then Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
      "sourceRange": {
        "lineStart": 172,
        "lineEnd": 172,
        "columnStart": 9,
        "columnEnd": 94
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0134",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 172,
        "lineEnd": 172,
        "columnStart": 97,
        "columnEnd": 114
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0145",
      "statementText": "Message \"Print しかし、効果はなかった\"",
      "sourceRange": {
        "lineStart": 183,
        "lineEnd": 183,
        "columnStart": 13,
        "columnEnd": 39
      },
      "literalPrefix": "Print しかし、効果はなかった",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0147",
      "statementText": "Message \"Print 敵全員の防御力は、\" + CStr(Vl) + \"上がった\"",
      "sourceRange": {
        "lineStart": 185,
        "lineEnd": 185,
        "columnStart": 13,
        "columnEnd": 57
      },
      "literalPrefix": "Print 敵全員の防御力は、",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0149",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 187,
        "lineEnd": 187,
        "columnStart": 9,
        "columnEnd": 26
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0151",
      "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
      "sourceRange": {
        "lineStart": 189,
        "lineEnd": 189,
        "columnStart": 9,
        "columnEnd": 89
      },
      "literalPrefix": "Sound ",
      "command": "SOUND",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0152",
      "statementText": "If EnemyCText(Enemy(ENO), Tp) <> \"\" Then Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
      "sourceRange": {
        "lineStart": 190,
        "lineEnd": 190,
        "columnStart": 9,
        "columnEnd": 94
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0153",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 190,
        "lineEnd": 190,
        "columnStart": 97,
        "columnEnd": 114
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0160",
      "statementText": "Message \"Print \" + EnemyName(Enemy(Target)) + \"の早さは、\" + CStr(Vl) + \"上がった\"",
      "sourceRange": {
        "lineStart": 197,
        "lineEnd": 197,
        "columnStart": 13,
        "columnEnd": 85
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0162",
      "statementText": "Message \"Print しかし、効果はなかった\"",
      "sourceRange": {
        "lineStart": 199,
        "lineEnd": 199,
        "columnStart": 13,
        "columnEnd": 39
      },
      "literalPrefix": "Print しかし、効果はなかった",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0164",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 201,
        "lineEnd": 201,
        "columnStart": 9,
        "columnEnd": 26
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0166",
      "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
      "sourceRange": {
        "lineStart": 203,
        "lineEnd": 203,
        "columnStart": 9,
        "columnEnd": 89
      },
      "literalPrefix": "Sound ",
      "command": "SOUND",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0167",
      "statementText": "If EnemyCText(Enemy(ENO), Tp) <> \"\" Then Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
      "sourceRange": {
        "lineStart": 204,
        "lineEnd": 204,
        "columnStart": 9,
        "columnEnd": 94
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0168",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 204,
        "lineEnd": 204,
        "columnStart": 97,
        "columnEnd": 114
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0179",
      "statementText": "Message \"Print しかし、効果はなかった\"",
      "sourceRange": {
        "lineStart": 215,
        "lineEnd": 215,
        "columnStart": 13,
        "columnEnd": 39
      },
      "literalPrefix": "Print しかし、効果はなかった",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0181",
      "statementText": "Message \"Print 敵全員の早さは、\" + CStr(Vl) + \"上がった\"",
      "sourceRange": {
        "lineStart": 217,
        "lineEnd": 217,
        "columnStart": 13,
        "columnEnd": 56
      },
      "literalPrefix": "Print 敵全員の早さは、",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0183",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 219,
        "lineEnd": 219,
        "columnStart": 9,
        "columnEnd": 26
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0185",
      "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
      "sourceRange": {
        "lineStart": 221,
        "lineEnd": 221,
        "columnStart": 9,
        "columnEnd": 89
      },
      "literalPrefix": "Sound ",
      "command": "SOUND",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0186",
      "statementText": "If EnemyCText(Enemy(ENO), Tp) <> \"\" Then Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
      "sourceRange": {
        "lineStart": 222,
        "lineEnd": 222,
        "columnStart": 9,
        "columnEnd": 94
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0187",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 222,
        "lineEnd": 222,
        "columnStart": 97,
        "columnEnd": 114
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0195",
      "statementText": "Message \"Print \" + NM(Target) + \"の攻撃力は、\" + CStr(Vl) + \"下がった\"",
      "sourceRange": {
        "lineStart": 230,
        "lineEnd": 230,
        "columnStart": 13,
        "columnEnd": 72
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0197",
      "statementText": "Message \"Print しかし、効果はなかった\"",
      "sourceRange": {
        "lineStart": 232,
        "lineEnd": 232,
        "columnStart": 13,
        "columnEnd": 39
      },
      "literalPrefix": "Print しかし、効果はなかった",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0199",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 234,
        "lineEnd": 234,
        "columnStart": 9,
        "columnEnd": 26
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0201",
      "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
      "sourceRange": {
        "lineStart": 236,
        "lineEnd": 236,
        "columnStart": 9,
        "columnEnd": 89
      },
      "literalPrefix": "Sound ",
      "command": "SOUND",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0202",
      "statementText": "If EnemyCText(Enemy(ENO), Tp) <> \"\" Then Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
      "sourceRange": {
        "lineStart": 237,
        "lineEnd": 237,
        "columnStart": 9,
        "columnEnd": 94
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0203",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 237,
        "lineEnd": 237,
        "columnStart": 97,
        "columnEnd": 114
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0215",
      "statementText": "Message \"Print しかし、効果はなかった\"",
      "sourceRange": {
        "lineStart": 249,
        "lineEnd": 249,
        "columnStart": 13,
        "columnEnd": 39
      },
      "literalPrefix": "Print しかし、効果はなかった",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0217",
      "statementText": "Message \"Print 全員の攻撃力は、\" + CStr(Vl) + \"下がった\"",
      "sourceRange": {
        "lineStart": 251,
        "lineEnd": 251,
        "columnStart": 13,
        "columnEnd": 56
      },
      "literalPrefix": "Print 全員の攻撃力は、",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0219",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 253,
        "lineEnd": 253,
        "columnStart": 9,
        "columnEnd": 26
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0221",
      "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
      "sourceRange": {
        "lineStart": 255,
        "lineEnd": 255,
        "columnStart": 9,
        "columnEnd": 89
      },
      "literalPrefix": "Sound ",
      "command": "SOUND",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0222",
      "statementText": "If EnemyCText(Enemy(ENO), Tp) <> \"\" Then Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
      "sourceRange": {
        "lineStart": 256,
        "lineEnd": 256,
        "columnStart": 9,
        "columnEnd": 94
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0223",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 256,
        "lineEnd": 256,
        "columnStart": 97,
        "columnEnd": 114
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0231",
      "statementText": "Message \"Print \" + NM(Target) + \"の防御力は、\" + CStr(Vl) + \"下がった\"",
      "sourceRange": {
        "lineStart": 264,
        "lineEnd": 264,
        "columnStart": 13,
        "columnEnd": 72
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0233",
      "statementText": "Message \"Print しかし、効果はなかった\"",
      "sourceRange": {
        "lineStart": 266,
        "lineEnd": 266,
        "columnStart": 13,
        "columnEnd": 39
      },
      "literalPrefix": "Print しかし、効果はなかった",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0235",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 268,
        "lineEnd": 268,
        "columnStart": 9,
        "columnEnd": 26
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0237",
      "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
      "sourceRange": {
        "lineStart": 270,
        "lineEnd": 270,
        "columnStart": 9,
        "columnEnd": 89
      },
      "literalPrefix": "Sound ",
      "command": "SOUND",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0238",
      "statementText": "If EnemyCText(Enemy(ENO), Tp) <> \"\" Then Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
      "sourceRange": {
        "lineStart": 271,
        "lineEnd": 271,
        "columnStart": 9,
        "columnEnd": 94
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0239",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 271,
        "lineEnd": 271,
        "columnStart": 97,
        "columnEnd": 114
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0251",
      "statementText": "Message \"Print しかし、効果はなかった\"",
      "sourceRange": {
        "lineStart": 283,
        "lineEnd": 283,
        "columnStart": 13,
        "columnEnd": 39
      },
      "literalPrefix": "Print しかし、効果はなかった",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0253",
      "statementText": "Message \"Print 全員の防御力は、\" + CStr(Vl) + \"下がった\"",
      "sourceRange": {
        "lineStart": 285,
        "lineEnd": 285,
        "columnStart": 13,
        "columnEnd": 56
      },
      "literalPrefix": "Print 全員の防御力は、",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0255",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 287,
        "lineEnd": 287,
        "columnStart": 9,
        "columnEnd": 26
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0257",
      "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
      "sourceRange": {
        "lineStart": 289,
        "lineEnd": 289,
        "columnStart": 9,
        "columnEnd": 89
      },
      "literalPrefix": "Sound ",
      "command": "SOUND",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0258",
      "statementText": "If EnemyCText(Enemy(ENO), Tp) <> \"\" Then Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
      "sourceRange": {
        "lineStart": 290,
        "lineEnd": 290,
        "columnStart": 9,
        "columnEnd": 94
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0259",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 290,
        "lineEnd": 290,
        "columnStart": 97,
        "columnEnd": 114
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0267",
      "statementText": "Message \"Print \" + NM(Target) + \"の早さは、\" + CStr(Vl) + \"下がった\"",
      "sourceRange": {
        "lineStart": 298,
        "lineEnd": 298,
        "columnStart": 13,
        "columnEnd": 71
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0269",
      "statementText": "Message \"Print しかし、効果はなかった\"",
      "sourceRange": {
        "lineStart": 300,
        "lineEnd": 300,
        "columnStart": 13,
        "columnEnd": 39
      },
      "literalPrefix": "Print しかし、効果はなかった",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0271",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 302,
        "lineEnd": 302,
        "columnStart": 9,
        "columnEnd": 26
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0273",
      "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
      "sourceRange": {
        "lineStart": 304,
        "lineEnd": 304,
        "columnStart": 9,
        "columnEnd": 89
      },
      "literalPrefix": "Sound ",
      "command": "SOUND",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0274",
      "statementText": "If EnemyCText(Enemy(ENO), Tp) <> \"\" Then Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
      "sourceRange": {
        "lineStart": 305,
        "lineEnd": 305,
        "columnStart": 9,
        "columnEnd": 94
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0275",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 305,
        "lineEnd": 305,
        "columnStart": 97,
        "columnEnd": 114
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0287",
      "statementText": "Message \"Print しかし、効果はなかった\"",
      "sourceRange": {
        "lineStart": 317,
        "lineEnd": 317,
        "columnStart": 13,
        "columnEnd": 39
      },
      "literalPrefix": "Print しかし、効果はなかった",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0289",
      "statementText": "Message \"Print 全員の防御力は、\" + CStr(Vl) + \"下がった\"",
      "sourceRange": {
        "lineStart": 319,
        "lineEnd": 319,
        "columnStart": 13,
        "columnEnd": 56
      },
      "literalPrefix": "Print 全員の防御力は、",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0291",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 321,
        "lineEnd": 321,
        "columnStart": 9,
        "columnEnd": 26
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0294",
      "statementText": "Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
      "sourceRange": {
        "lineStart": 324,
        "lineEnd": 324,
        "columnStart": 13,
        "columnEnd": 56
      },
      "literalPrefix": "Sound ",
      "command": "SOUND",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0296",
      "statementText": "Message \"Sound Escape\"",
      "sourceRange": {
        "lineStart": 326,
        "lineEnd": 326,
        "columnStart": 13,
        "columnEnd": 34
      },
      "literalPrefix": "Sound Escape",
      "command": "SOUND",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0299",
      "statementText": "Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
      "sourceRange": {
        "lineStart": 329,
        "lineEnd": 329,
        "columnStart": 13,
        "columnEnd": 57
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0300",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 329,
        "lineEnd": 329,
        "columnStart": 60,
        "columnEnd": 77
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0302",
      "statementText": "Message \"Print \" + EnemyName(Enemy(ENO)) + \"は、逃げ出した\"",
      "sourceRange": {
        "lineStart": 331,
        "lineEnd": 331,
        "columnStart": 13,
        "columnEnd": 64
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0306",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 335,
        "lineEnd": 335,
        "columnStart": 9,
        "columnEnd": 26
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0309",
      "statementText": "Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
      "sourceRange": {
        "lineStart": 338,
        "lineEnd": 338,
        "columnStart": 13,
        "columnEnd": 57
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0311",
      "statementText": "Message \"Print \" + EnemyName(Enemy(ENO)) + \"は、何もしなかった\"",
      "sourceRange": {
        "lineStart": 340,
        "lineEnd": 340,
        "columnStart": 13,
        "columnEnd": 66
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ENEMY.BAS",
      "procedure": "EnemySub",
      "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
      "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
      "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0313",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 342,
        "lineEnd": 342,
        "columnStart": 9,
        "columnEnd": 26
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "FILESYS.BAS",
      "procedure": "LoadData",
      "procedureId": "FILESYS.BAS-cab069b3ba-6a507a5e.LoadData.text-000",
      "procedureIrPath": "docs/vb2-ir/procedures/FILESYS.BAS-cab069b3ba-6a507a5e.LoadData.text-000.json",
      "statementId": "FILESYS.BAS-cab069b3ba-6a507a5e.LoadData.text-000.decoded-statement-0010",
      "statementText": "If n = 0 Then Message \"Print データがありません。\"",
      "sourceRange": {
        "lineStart": 14,
        "lineEnd": 14,
        "columnStart": 5,
        "columnEnd": 44
      },
      "literalPrefix": "Print データがありません。",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "FILESYS.BAS",
      "procedure": "SaveData",
      "procedureId": "FILESYS.BAS-cab069b3ba-6a507a5e.SaveData.001",
      "procedureIrPath": "docs/vb2-ir/procedures/FILESYS.BAS-cab069b3ba-6a507a5e.SaveData.001.json",
      "statementId": "FILESYS.BAS-cab069b3ba-6a507a5e.SaveData.001.decoded-statement-0040",
      "statementText": "Message \"Print ＜　セーブ終了　＞\"",
      "sourceRange": {
        "lineStart": 142,
        "lineEnd": 142,
        "columnStart": 5,
        "columnEnd": 29
      },
      "literalPrefix": "Print ＜　セーブ終了　＞",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UsableCheck",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UsableCheck.text-001",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UsableCheck.text-001.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UsableCheck.text-001.decoded-statement-0003",
      "statementText": "Message \"Print %\" + CStr(ManNO) + \"は、\" + ItemName(IN - 1) + \"を使えない\"",
      "sourceRange": {
        "lineStart": 57,
        "lineEnd": 57,
        "columnStart": 9,
        "columnEnd": 75
      },
      "literalPrefix": "Print %",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UsableCheck",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UsableCheck.text-001",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UsableCheck.text-001.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UsableCheck.text-001.decoded-statement-0007",
      "statementText": "Message \"Print %\" + CStr(ManNO2) + \"には、\" + ItemName(IN - 1) + \"を使えない\"",
      "sourceRange": {
        "lineStart": 61,
        "lineEnd": 61,
        "columnStart": 9,
        "columnEnd": 77
      },
      "literalPrefix": "Print %",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UsableCheck",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UsableCheck.text-001",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UsableCheck.text-001.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UsableCheck.text-001.decoded-statement-0011",
      "statementText": "Message \"Print \" + ItemName(IN - 1) + \"は、移動中には使えない\"",
      "sourceRange": {
        "lineStart": 65,
        "lineEnd": 65,
        "columnStart": 9,
        "columnEnd": 59
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UsableCheck",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UsableCheck.text-001",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UsableCheck.text-001.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UsableCheck.text-001.decoded-statement-0015",
      "statementText": "Message \"Print \" + ItemName(IN - 1) + \"は、戦闘中には使えない\"",
      "sourceRange": {
        "lineStart": 69,
        "lineEnd": 69,
        "columnStart": 9,
        "columnEnd": 59
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UsableCheck",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UsableCheck.text-001",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UsableCheck.text-001.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UsableCheck.text-001.decoded-statement-0018",
      "statementText": "If UC = False And (MainState And Fighting) = 0 Then Message \"Click\"",
      "sourceRange": {
        "lineStart": 72,
        "lineEnd": 72,
        "columnStart": 5,
        "columnEnd": 71
      },
      "literalPrefix": "Click",
      "command": "CLICK",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0009",
      "statementText": "If ItemState(IN - 1) And 8192 Then Message \"Sound \" + ItemWave(IN - 1)",
      "sourceRange": {
        "lineStart": 86,
        "lineEnd": 86,
        "columnStart": 5,
        "columnEnd": 74
      },
      "literalPrefix": "Sound ",
      "command": "SOUND",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0012",
      "statementText": "Message \"Print \" + NM(ManNO) + \"は、\" + ItemName(IN - 1) + \"を使った\"",
      "sourceRange": {
        "lineStart": 89,
        "lineEnd": 89,
        "columnStart": 9,
        "columnEnd": 71
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0014",
      "statementText": "Message \"Print \" + NM(ManNO2) + \"は、\" + ItemName(IN - 1) + \"を装備した\"",
      "sourceRange": {
        "lineStart": 91,
        "lineEnd": 91,
        "columnStart": 9,
        "columnEnd": 73
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0018",
      "statementText": "Message \"Print \" + AD + \"のＨＰは\" + CStr(ItemEffect(IN - 1)) + \"回復した\"",
      "sourceRange": {
        "lineStart": 95,
        "lineEnd": 95,
        "columnStart": 9,
        "columnEnd": 74
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0019",
      "statementText": "Message \"HP \" + A2 + \" \" + CStr(ItemEffect(IN - 1))",
      "sourceRange": {
        "lineStart": 96,
        "lineEnd": 96,
        "columnStart": 9,
        "columnEnd": 59
      },
      "literalPrefix": "HP ",
      "command": "HP",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0021",
      "statementText": "Message \"Print \" + AD + \"のＭＰは\" + CStr(ItemEffect(IN - 1)) + \"回復した\"",
      "sourceRange": {
        "lineStart": 98,
        "lineEnd": 98,
        "columnStart": 9,
        "columnEnd": 74
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0022",
      "statementText": "Message \"MP \" + A2 + \" \" + CStr(ItemEffect(IN - 1))",
      "sourceRange": {
        "lineStart": 99,
        "lineEnd": 99,
        "columnStart": 9,
        "columnEnd": 59
      },
      "literalPrefix": "MP ",
      "command": "MP",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0024",
      "statementText": "Message \"Print \" + AD + \"のＨＰ、ＭＰは\" + CStr(ItemEffect(IN - 1)) + \"回復した\"",
      "sourceRange": {
        "lineStart": 101,
        "lineEnd": 101,
        "columnStart": 9,
        "columnEnd": 77
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0025",
      "statementText": "Message \"HP \" + A2 + \" \" + CStr(ItemEffect(IN - 1))",
      "sourceRange": {
        "lineStart": 102,
        "lineEnd": 102,
        "columnStart": 9,
        "columnEnd": 59
      },
      "literalPrefix": "HP ",
      "command": "HP",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0026",
      "statementText": "Message \"MP \" + A2 + \" \" + CStr(ItemEffect(IN - 1))",
      "sourceRange": {
        "lineStart": 103,
        "lineEnd": 103,
        "columnStart": 9,
        "columnEnd": 59
      },
      "literalPrefix": "MP ",
      "command": "MP",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0028",
      "statementText": "Message \"Print \" + AD + \"の最大ＨＰは\" + CStr(ItemEffect(IN - 1)) + \"あがった\"",
      "sourceRange": {
        "lineStart": 105,
        "lineEnd": 105,
        "columnStart": 9,
        "columnEnd": 76
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0039",
      "statementText": "Message \"Print \" + AD + \"の最大ＭＰは\" + CStr(ItemEffect(IN - 1)) + \"あがった\"",
      "sourceRange": {
        "lineStart": 115,
        "lineEnd": 115,
        "columnStart": 9,
        "columnEnd": 76
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0050",
      "statementText": "Message \"Print \" + AD + \"の攻撃力は\" + CStr(ItemEffect(IN - 1)) + \"あがった\"",
      "sourceRange": {
        "lineStart": 125,
        "lineEnd": 125,
        "columnStart": 9,
        "columnEnd": 75
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0059",
      "statementText": "Message \"Print \" + AD + \"の防御力は\" + CStr(ItemEffect(IN - 1)) + \"あがった\"",
      "sourceRange": {
        "lineStart": 134,
        "lineEnd": 134,
        "columnStart": 9,
        "columnEnd": 75
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0068",
      "statementText": "Message \"Print \" + AD + \"の早さは\" + CStr(ItemEffect(IN - 1)) + \"あがった\"",
      "sourceRange": {
        "lineStart": 143,
        "lineEnd": 143,
        "columnStart": 9,
        "columnEnd": 74
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0096",
      "statementText": "If F1 Then Message \"Print \" + EnemyName(Enemy(I)) + \"の攻撃力は\" + CStr(ItemEffect(IN - 1)) + \"下がった\"",
      "sourceRange": {
        "lineStart": 171,
        "lineEnd": 171,
        "columnStart": 17,
        "columnEnd": 111
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0099",
      "statementText": "If F = False Then Message \"Print しかし、効果はなかった\"",
      "sourceRange": {
        "lineStart": 174,
        "lineEnd": 174,
        "columnStart": 9,
        "columnEnd": 53
      },
      "literalPrefix": "Print しかし、効果はなかった",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0113",
      "statementText": "Message \"Print \" + EnemyName(Enemy(I)) + \"の防御力は\" + CStr(ItemEffect(IN - 1)) + \"下がった\"",
      "sourceRange": {
        "lineStart": 188,
        "lineEnd": 188,
        "columnStart": 17,
        "columnEnd": 100
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0117",
      "statementText": "If F = False Then Message \"Print しかし、効果はなかった\"",
      "sourceRange": {
        "lineStart": 192,
        "lineEnd": 192,
        "columnStart": 9,
        "columnEnd": 53
      },
      "literalPrefix": "Print しかし、効果はなかった",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0131",
      "statementText": "Message \"Print \" + EnemyName(Enemy(I)) + \"の早さは\" + CStr(ItemEffect(IN - 1)) + \"下がった\"",
      "sourceRange": {
        "lineStart": 206,
        "lineEnd": 206,
        "columnStart": 17,
        "columnEnd": 99
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0135",
      "statementText": "If F = False Then Message \"Print しかし、効果はなかった\"",
      "sourceRange": {
        "lineStart": 210,
        "lineEnd": 210,
        "columnStart": 9,
        "columnEnd": 53
      },
      "literalPrefix": "Print しかし、効果はなかった",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0148",
      "statementText": "Message \"Print \" + NM(I) + \"の攻撃力は\" + CStr(ItemEffect(IN - 1)) + \"上がった\"",
      "sourceRange": {
        "lineStart": 223,
        "lineEnd": 223,
        "columnStart": 17,
        "columnEnd": 86
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0152",
      "statementText": "If F = False Then Message \"Print しかし、効果はなかった\"",
      "sourceRange": {
        "lineStart": 227,
        "lineEnd": 227,
        "columnStart": 9,
        "columnEnd": 53
      },
      "literalPrefix": "Print しかし、効果はなかった",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0165",
      "statementText": "Message \"Print \" + NM(I) + \"の防御力は\" + CStr(ItemEffect(IN - 1)) + \"上がった\"",
      "sourceRange": {
        "lineStart": 240,
        "lineEnd": 240,
        "columnStart": 17,
        "columnEnd": 86
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0169",
      "statementText": "If F = False Then Message \"Print しかし、効果はなかった\"",
      "sourceRange": {
        "lineStart": 244,
        "lineEnd": 244,
        "columnStart": 9,
        "columnEnd": 53
      },
      "literalPrefix": "Print しかし、効果はなかった",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0182",
      "statementText": "Message \"Print \" + NM(I) + \"の早さは\" + CStr(ItemEffect(IN - 1)) + \"上がった\"",
      "sourceRange": {
        "lineStart": 257,
        "lineEnd": 257,
        "columnStart": 17,
        "columnEnd": 85
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0186",
      "statementText": "If F = False Then Message \"Print しかし、効果はなかった\"",
      "sourceRange": {
        "lineStart": 261,
        "lineEnd": 261,
        "columnStart": 9,
        "columnEnd": 53
      },
      "literalPrefix": "Print しかし、効果はなかった",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0199",
      "statementText": "Message \"EnemyDamage \" + CStr(EnmNO) + \" \" + CStr(DM) + \" Attack\"",
      "sourceRange": {
        "lineStart": 274,
        "lineEnd": 274,
        "columnStart": 17,
        "columnEnd": 81
      },
      "literalPrefix": "EnemyDamage ",
      "command": "ENEMYDAMAGE",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0212",
      "statementText": "Message \"Print \" + NM(ManNO2) + \"はこれ以上魔法を覚えられない\"",
      "sourceRange": {
        "lineStart": 287,
        "lineEnd": 287,
        "columnStart": 17,
        "columnEnd": 64
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0217",
      "statementText": "Message \"Print しかし、\" + NM(ManNO2) + \"はすでに\" + MagicName(ItemEffect(IN - 1) - 1) + \"を覚えている\"",
      "sourceRange": {
        "lineStart": 292,
        "lineEnd": 292,
        "columnStart": 17,
        "columnEnd": 105
      },
      "literalPrefix": "Print しかし、",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0222",
      "statementText": "Message \"Print \" + NM(ManNO2) + \"は、\" + MagicName(ItemEffect(IN - 1) - 1) + \"を覚えた\"",
      "sourceRange": {
        "lineStart": 297,
        "lineEnd": 297,
        "columnStart": 17,
        "columnEnd": 97
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0230",
      "statementText": "Message \"Print 特に何もおこらなかった\"",
      "sourceRange": {
        "lineStart": 305,
        "lineEnd": 305,
        "columnStart": 13,
        "columnEnd": 39
      },
      "literalPrefix": "Print 特に何もおこらなかった",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0238",
      "statementText": "Message \"Click\"",
      "sourceRange": {
        "lineStart": 313,
        "lineEnd": 313,
        "columnStart": 9,
        "columnEnd": 23
      },
      "literalPrefix": "Click",
      "command": "CLICK",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "ITEM.BAS",
      "procedure": "UseItem",
      "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
      "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
      "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0240",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 315,
        "lineEnd": 315,
        "columnStart": 9,
        "columnEnd": 26
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "MagicCheck",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.MagicCheck.text-001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.MagicCheck.text-001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.MagicCheck.text-001.decoded-statement-0003",
      "statementText": "Message \"Print ＭＰが足りない\"",
      "sourceRange": {
        "lineStart": 14,
        "lineEnd": 14,
        "columnStart": 9,
        "columnEnd": 31
      },
      "literalPrefix": "Print ＭＰが足りない",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "MagicCheck",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.MagicCheck.text-001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.MagicCheck.text-001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.MagicCheck.text-001.decoded-statement-0007",
      "statementText": "Message \"Print \" + MagicName(IN - 1) + \"は、移動中には使えない\"",
      "sourceRange": {
        "lineStart": 18,
        "lineEnd": 18,
        "columnStart": 9,
        "columnEnd": 60
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "MagicCheck",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.MagicCheck.text-001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.MagicCheck.text-001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.MagicCheck.text-001.decoded-statement-0011",
      "statementText": "Message \"Print \" + MagicName(IN - 1) + \"は、戦闘中には使えない\"",
      "sourceRange": {
        "lineStart": 22,
        "lineEnd": 22,
        "columnStart": 9,
        "columnEnd": 60
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "MagicCheck",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.MagicCheck.text-001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.MagicCheck.text-001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.MagicCheck.text-001.decoded-statement-0014",
      "statementText": "If UC = False And (MainState And Fighting) = 0 Then Message \"Click\"",
      "sourceRange": {
        "lineStart": 25,
        "lineEnd": 25,
        "columnStart": 5,
        "columnEnd": 71
      },
      "literalPrefix": "Click",
      "command": "CLICK",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0009",
      "statementText": "Message \"Sound \" + MagicWave(IN - 1)",
      "sourceRange": {
        "lineStart": 56,
        "lineEnd": 56,
        "columnStart": 9,
        "columnEnd": 44
      },
      "literalPrefix": "Sound ",
      "command": "SOUND",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0011",
      "statementText": "Message \"Sound Magic\"",
      "sourceRange": {
        "lineStart": 58,
        "lineEnd": 58,
        "columnStart": 9,
        "columnEnd": 29
      },
      "literalPrefix": "Sound Magic",
      "command": "SOUND",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0013",
      "statementText": "Message \"Print \" + NM(ManNO) + \"は、\" + MagicName(IN - 1) + \"を唱えた\"",
      "sourceRange": {
        "lineStart": 61,
        "lineEnd": 61,
        "columnStart": 5,
        "columnEnd": 68
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0014",
      "statementText": "Message \"MP \" + CStr(ManNO) + \" -\" + CStr(MagicMP(IN - 1))",
      "sourceRange": {
        "lineStart": 62,
        "lineEnd": 62,
        "columnStart": 5,
        "columnEnd": 62
      },
      "literalPrefix": "MP ",
      "command": "MP",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0017",
      "statementText": "Message \"Print \" + AD + \"のＨＰは\" + CStr(MagicEffect(IN - 1)) + \"回復した\"",
      "sourceRange": {
        "lineStart": 65,
        "lineEnd": 65,
        "columnStart": 9,
        "columnEnd": 75
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0018",
      "statementText": "Message \"HP \" + A2 + \" \" + CStr(MagicEffect(IN - 1))",
      "sourceRange": {
        "lineStart": 66,
        "lineEnd": 66,
        "columnStart": 9,
        "columnEnd": 60
      },
      "literalPrefix": "HP ",
      "command": "HP",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0020",
      "statementText": "Message \"Print \" + AD + \"のＭＰは\" + CStr(MagicEffect(IN - 1)) + \"回復した\"",
      "sourceRange": {
        "lineStart": 68,
        "lineEnd": 68,
        "columnStart": 9,
        "columnEnd": 75
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0021",
      "statementText": "Message \"MP \" + A2 + \" \" + CStr(MagicEffect(IN - 1))",
      "sourceRange": {
        "lineStart": 69,
        "lineEnd": 69,
        "columnStart": 9,
        "columnEnd": 60
      },
      "literalPrefix": "MP ",
      "command": "MP",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0023",
      "statementText": "Message \"Print \" + AD + \"のＨＰ、ＭＰは\" + CStr(MagicEffect(IN - 1)) + \"回復した\"",
      "sourceRange": {
        "lineStart": 71,
        "lineEnd": 71,
        "columnStart": 9,
        "columnEnd": 78
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0024",
      "statementText": "Message \"HP \" + A2 + \" \" + CStr(MagicEffect(IN - 1))",
      "sourceRange": {
        "lineStart": 72,
        "lineEnd": 72,
        "columnStart": 9,
        "columnEnd": 60
      },
      "literalPrefix": "HP ",
      "command": "HP",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0025",
      "statementText": "Message \"MP \" + A2 + \" \" + CStr(MagicEffect(IN - 1))",
      "sourceRange": {
        "lineStart": 73,
        "lineEnd": 73,
        "columnStart": 9,
        "columnEnd": 60
      },
      "literalPrefix": "MP ",
      "command": "MP",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0046",
      "statementText": "If F1 Then Message \"Print \" + EnemyName(Enemy(I)) + \"の攻撃力は\" + CStr(MagicEffect(IN - 1)) + \"下がった\"",
      "sourceRange": {
        "lineStart": 94,
        "lineEnd": 94,
        "columnStart": 17,
        "columnEnd": 112
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0049",
      "statementText": "If F = False Then Message \"Print しかし、効果はなかった\"",
      "sourceRange": {
        "lineStart": 97,
        "lineEnd": 97,
        "columnStart": 9,
        "columnEnd": 53
      },
      "literalPrefix": "Print しかし、効果はなかった",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0063",
      "statementText": "Message \"Print \" + EnemyName(Enemy(I)) + \"の防御力は\" + CStr(MagicEffect(IN - 1)) + \"下がった\"",
      "sourceRange": {
        "lineStart": 111,
        "lineEnd": 111,
        "columnStart": 17,
        "columnEnd": 101
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0067",
      "statementText": "If F = False Then Message \"Print しかし、効果はなかった\"",
      "sourceRange": {
        "lineStart": 115,
        "lineEnd": 115,
        "columnStart": 9,
        "columnEnd": 53
      },
      "literalPrefix": "Print しかし、効果はなかった",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0081",
      "statementText": "Message \"Print \" + EnemyName(Enemy(I)) + \"の早さは\" + CStr(MagicEffect(IN - 1)) + \"下がった\"",
      "sourceRange": {
        "lineStart": 129,
        "lineEnd": 129,
        "columnStart": 17,
        "columnEnd": 100
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0085",
      "statementText": "If F = False Then Message \"Print しかし、効果はなかった\"",
      "sourceRange": {
        "lineStart": 133,
        "lineEnd": 133,
        "columnStart": 9,
        "columnEnd": 53
      },
      "literalPrefix": "Print しかし、効果はなかった",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0098",
      "statementText": "Message \"Print \" + NM(I) + \"の攻撃力は\" + CStr(MagicEffect(IN - 1)) + \"上がった\"",
      "sourceRange": {
        "lineStart": 146,
        "lineEnd": 146,
        "columnStart": 17,
        "columnEnd": 87
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0102",
      "statementText": "If F = False Then Message \"Print しかし、効果はなかった\"",
      "sourceRange": {
        "lineStart": 150,
        "lineEnd": 150,
        "columnStart": 9,
        "columnEnd": 53
      },
      "literalPrefix": "Print しかし、効果はなかった",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0115",
      "statementText": "Message \"Print \" + NM(I) + \"の防御力は\" + CStr(MagicEffect(IN - 1)) + \"上がった\"",
      "sourceRange": {
        "lineStart": 163,
        "lineEnd": 163,
        "columnStart": 17,
        "columnEnd": 87
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0119",
      "statementText": "If F = False Then Message \"Print しかし、効果はなかった\"",
      "sourceRange": {
        "lineStart": 167,
        "lineEnd": 167,
        "columnStart": 9,
        "columnEnd": 53
      },
      "literalPrefix": "Print しかし、効果はなかった",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0132",
      "statementText": "Message \"Print \" + NM(I) + \"の早さは\" + CStr(MagicEffect(IN - 1)) + \"上がった\"",
      "sourceRange": {
        "lineStart": 180,
        "lineEnd": 180,
        "columnStart": 17,
        "columnEnd": 86
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0136",
      "statementText": "If F = False Then Message \"Print しかし、効果はなかった\"",
      "sourceRange": {
        "lineStart": 184,
        "lineEnd": 184,
        "columnStart": 9,
        "columnEnd": 53
      },
      "literalPrefix": "Print しかし、効果はなかった",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0149",
      "statementText": "Message \"EnemyDamage \" + CStr(I) + \" \" + CStr(DM) + \" Attack\"",
      "sourceRange": {
        "lineStart": 197,
        "lineEnd": 197,
        "columnStart": 17,
        "columnEnd": 77
      },
      "literalPrefix": "EnemyDamage ",
      "command": "ENEMYDAMAGE",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0154",
      "statementText": "Message \"Print 特に何もおこらなかった\"",
      "sourceRange": {
        "lineStart": 202,
        "lineEnd": 202,
        "columnStart": 13,
        "columnEnd": 39
      },
      "literalPrefix": "Print 特に何もおこらなかった",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0162",
      "statementText": "Message \"Click\"",
      "sourceRange": {
        "lineStart": 210,
        "lineEnd": 210,
        "columnStart": 9,
        "columnEnd": 23
      },
      "literalPrefix": "Click",
      "command": "CLICK",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAGIC.BAS",
      "procedure": "UseMagic",
      "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
      "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0164",
      "statementText": "Message \"Wait 100\"",
      "sourceRange": {
        "lineStart": 212,
        "lineEnd": 212,
        "columnStart": 9,
        "columnEnd": 26
      },
      "literalPrefix": "Wait 100",
      "command": "WAIT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAIN.BAS",
      "procedure": "EndFight",
      "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.json",
      "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.decoded-statement-0004",
      "statementText": "Message \"MessageClear\"",
      "sourceRange": {
        "lineStart": 51,
        "lineEnd": 51,
        "columnStart": 5,
        "columnEnd": 26
      },
      "literalPrefix": "MessageClear",
      "command": "MESSAGECLEAR",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAIN.BAS",
      "procedure": "EndFight",
      "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.json",
      "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.decoded-statement-0005",
      "statementText": "Message \"ChangeBGM \" + BGMFile",
      "sourceRange": {
        "lineStart": 52,
        "lineEnd": 52,
        "columnStart": 5,
        "columnEnd": 34
      },
      "literalPrefix": "ChangeBGM ",
      "command": "CHANGEBGM",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAIN.BAS",
      "procedure": "EndFight",
      "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.json",
      "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.decoded-statement-0006",
      "statementText": "Message \"WipeIn\"",
      "sourceRange": {
        "lineStart": 53,
        "lineEnd": 53,
        "columnStart": 5,
        "columnEnd": 20
      },
      "literalPrefix": "WipeIn",
      "command": "WIPEIN",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAIN.BAS",
      "procedure": "EndFight",
      "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001",
      "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.json",
      "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.decoded-statement-0007",
      "statementText": "Message \"EndFight 1\"",
      "sourceRange": {
        "lineStart": 54,
        "lineEnd": 54,
        "columnStart": 5,
        "columnEnd": 24
      },
      "literalPrefix": "EndFight 1",
      "command": "ENDFIGHT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAIN.BAS",
      "procedure": "EscapeFight",
      "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002",
      "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.json",
      "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.decoded-statement-0004",
      "statementText": "Message \"MessageClear\"",
      "sourceRange": {
        "lineStart": 63,
        "lineEnd": 63,
        "columnStart": 5,
        "columnEnd": 26
      },
      "literalPrefix": "MessageClear",
      "command": "MESSAGECLEAR",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAIN.BAS",
      "procedure": "EscapeFight",
      "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002",
      "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.json",
      "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.decoded-statement-0005",
      "statementText": "Message \"ChangeBGM \" + BGMFile",
      "sourceRange": {
        "lineStart": 64,
        "lineEnd": 64,
        "columnStart": 5,
        "columnEnd": 34
      },
      "literalPrefix": "ChangeBGM ",
      "command": "CHANGEBGM",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAIN.BAS",
      "procedure": "EscapeFight",
      "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002",
      "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.json",
      "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.decoded-statement-0006",
      "statementText": "Message \"WipeIn\"",
      "sourceRange": {
        "lineStart": 65,
        "lineEnd": 65,
        "columnStart": 5,
        "columnEnd": 20
      },
      "literalPrefix": "WipeIn",
      "command": "WIPEIN",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAIN.BAS",
      "procedure": "EscapeFight",
      "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002",
      "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.json",
      "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.decoded-statement-0007",
      "statementText": "Message \"EndFight 3\"",
      "sourceRange": {
        "lineStart": 66,
        "lineEnd": 66,
        "columnStart": 5,
        "columnEnd": 24
      },
      "literalPrefix": "EndFight 3",
      "command": "ENDFIGHT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAIN.BAS",
      "procedure": "Fight",
      "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003",
      "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.json",
      "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.decoded-statement-0016",
      "statementText": "Message \"Menu ET\"",
      "sourceRange": {
        "lineStart": 87,
        "lineEnd": 87,
        "columnStart": 5,
        "columnEnd": 21
      },
      "literalPrefix": "Menu ET",
      "command": "MENU",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAIN.BAS",
      "procedure": "Fight",
      "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003",
      "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.json",
      "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.decoded-statement-0017",
      "statementText": "Message \"WipeOut\"",
      "sourceRange": {
        "lineStart": 88,
        "lineEnd": 88,
        "columnStart": 5,
        "columnEnd": 21
      },
      "literalPrefix": "WipeOut",
      "command": "WIPEOUT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAIN.BAS",
      "procedure": "Fight",
      "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003",
      "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.json",
      "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.decoded-statement-0053",
      "statementText": "Message \"ShowEnemy\"",
      "sourceRange": {
        "lineStart": 124,
        "lineEnd": 124,
        "columnStart": 5,
        "columnEnd": 23
      },
      "literalPrefix": "ShowEnemy",
      "command": "SHOWENEMY",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAIN.BAS",
      "procedure": "Fight",
      "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003",
      "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.json",
      "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.decoded-statement-0054",
      "statementText": "Message \"Print 敵に遭遇した\"",
      "sourceRange": {
        "lineStart": 125,
        "lineEnd": 125,
        "columnStart": 5,
        "columnEnd": 26
      },
      "literalPrefix": "Print 敵に遭遇した",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAIN.BAS",
      "procedure": "Fight",
      "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003",
      "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.json",
      "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.decoded-statement-0055",
      "statementText": "Message \"Click\"",
      "sourceRange": {
        "lineStart": 126,
        "lineEnd": 126,
        "columnStart": 5,
        "columnEnd": 19
      },
      "literalPrefix": "Click",
      "command": "CLICK",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAIN.BAS",
      "procedure": "Fight",
      "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003",
      "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.json",
      "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.decoded-statement-0064",
      "statementText": "Message \"StartFight\"",
      "sourceRange": {
        "lineStart": 135,
        "lineEnd": 135,
        "columnStart": 5,
        "columnEnd": 24
      },
      "literalPrefix": "StartFight",
      "command": "STARTFIGHT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAIN.BAS",
      "procedure": "Fight",
      "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003",
      "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.json",
      "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.decoded-statement-0066",
      "statementText": "Message \"EndFight 0\"",
      "sourceRange": {
        "lineStart": 138,
        "lineEnd": 138,
        "columnStart": 5,
        "columnEnd": 24
      },
      "literalPrefix": "EndFight 0",
      "command": "ENDFIGHT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAIN.BAS",
      "procedure": "GameOver",
      "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004",
      "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.json",
      "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.decoded-statement-0001",
      "statementText": "Message \"StopBGM\"",
      "sourceRange": {
        "lineStart": 143,
        "lineEnd": 143,
        "columnStart": 5,
        "columnEnd": 21
      },
      "literalPrefix": "StopBGM",
      "command": "STOPBGM",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAIN.BAS",
      "procedure": "GameOver",
      "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004",
      "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.json",
      "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.decoded-statement-0002",
      "statementText": "Message \"Print 全滅してしまった・・。\"",
      "sourceRange": {
        "lineStart": 144,
        "lineEnd": 144,
        "columnStart": 5,
        "columnEnd": 31
      },
      "literalPrefix": "Print 全滅してしまった・・。",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAIN.BAS",
      "procedure": "GameOver",
      "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004",
      "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.json",
      "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.decoded-statement-0003",
      "statementText": "Message \"Click\"",
      "sourceRange": {
        "lineStart": 145,
        "lineEnd": 145,
        "columnStart": 5,
        "columnEnd": 19
      },
      "literalPrefix": "Click",
      "command": "CLICK",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAIN.BAS",
      "procedure": "GameOver",
      "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004",
      "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.json",
      "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.decoded-statement-0009",
      "statementText": "Message \"WipeOut\"",
      "sourceRange": {
        "lineStart": 151,
        "lineEnd": 151,
        "columnStart": 9,
        "columnEnd": 25
      },
      "literalPrefix": "WipeOut",
      "command": "WIPEOUT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAIN.BAS",
      "procedure": "GameOver",
      "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004",
      "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.json",
      "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.decoded-statement-0011",
      "statementText": "Message \"Menu First\"",
      "sourceRange": {
        "lineStart": 153,
        "lineEnd": 153,
        "columnStart": 5,
        "columnEnd": 24
      },
      "literalPrefix": "Menu First",
      "command": "MENU",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAIN.BAS",
      "procedure": "NewGame",
      "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.NewGame.005",
      "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.NewGame.005.json",
      "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.NewGame.005.decoded-statement-0002",
      "statementText": "If MainState = 0 Then Message \"WipeOut\"",
      "sourceRange": {
        "lineStart": 161,
        "lineEnd": 161,
        "columnStart": 5,
        "columnEnd": 43
      },
      "literalPrefix": "WipeOut",
      "command": "WIPEOUT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAIN.BAS",
      "procedure": "NewGame",
      "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.NewGame.005",
      "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.NewGame.005.json",
      "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.NewGame.005.decoded-statement-0012",
      "statementText": "Message \"WipeIn\"",
      "sourceRange": {
        "lineStart": 171,
        "lineEnd": 171,
        "columnStart": 5,
        "columnEnd": 20
      },
      "literalPrefix": "WipeIn",
      "command": "WIPEIN",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAIN.BAS",
      "procedure": "StartTurn",
      "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007",
      "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007.json",
      "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007.decoded-statement-0018",
      "statementText": "Message \"Victory\"",
      "sourceRange": {
        "lineStart": 201,
        "lineEnd": 201,
        "columnStart": 9,
        "columnEnd": 25
      },
      "literalPrefix": "Victory",
      "command": "VICTORY",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAIN.BAS",
      "procedure": "StartTurn",
      "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007",
      "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007.json",
      "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007.decoded-statement-0030",
      "statementText": "Message \"EndFight 0\"",
      "sourceRange": {
        "lineStart": 214,
        "lineEnd": 214,
        "columnStart": 9,
        "columnEnd": 28
      },
      "literalPrefix": "EndFight 0",
      "command": "ENDFIGHT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "MAIN.BAS",
      "procedure": "StartTurn",
      "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007",
      "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007.json",
      "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007.decoded-statement-0035",
      "statementText": "Message \"Command \" + CStr(TurnNO)",
      "sourceRange": {
        "lineStart": 219,
        "lineEnd": 219,
        "columnStart": 9,
        "columnEnd": 41
      },
      "literalPrefix": "Command ",
      "command": "COMMAND",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "SUB.BAS",
      "procedure": "Dead",
      "procedureId": "SUB.BAS-8ff879e9dc-302a874f.Dead.006",
      "procedureIrPath": "docs/vb2-ir/procedures/SUB.BAS-8ff879e9dc-302a874f.Dead.006.json",
      "statementId": "SUB.BAS-8ff879e9dc-302a874f.Dead.006.decoded-statement-0001",
      "statementText": "Message \"Print \" + NM(MN) + \"は、気絶してしまった。\"",
      "sourceRange": {
        "lineStart": 61,
        "lineEnd": 61,
        "columnStart": 5,
        "columnEnd": 45
      },
      "literalPrefix": "Print ",
      "command": "PRINT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "SUB.BAS",
      "procedure": "MsgSub",
      "procedureId": "SUB.BAS-8ff879e9dc-302a874f.MsgSub.014",
      "procedureIrPath": "docs/vb2-ir/procedures/SUB.BAS-8ff879e9dc-302a874f.MsgSub.014.json",
      "statementId": "SUB.BAS-8ff879e9dc-302a874f.MsgSub.014.decoded-statement-0036",
      "statementText": "Message \"WIPEOUT\"",
      "sourceRange": {
        "lineStart": 202,
        "lineEnd": 202,
        "columnStart": 9,
        "columnEnd": 25
      },
      "literalPrefix": "WIPEOUT",
      "command": "WIPEOUT",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "SUB.BAS",
      "procedure": "MsgSub",
      "procedureId": "SUB.BAS-8ff879e9dc-302a874f.MsgSub.014",
      "procedureIrPath": "docs/vb2-ir/procedures/SUB.BAS-8ff879e9dc-302a874f.MsgSub.014.json",
      "statementId": "SUB.BAS-8ff879e9dc-302a874f.MsgSub.014.decoded-statement-0038",
      "statementText": "Message \"WIPEIN\"",
      "sourceRange": {
        "lineStart": 204,
        "lineEnd": 204,
        "columnStart": 9,
        "columnEnd": 24
      },
      "literalPrefix": "WIPEIN",
      "command": "WIPEIN",
      "evidence": "decoded_bas_text_source_message_call"
    },
    {
      "module": "SUB.BAS",
      "procedure": "WalkingSub",
      "procedureId": "SUB.BAS-8ff879e9dc-302a874f.WalkingSub.018",
      "procedureIrPath": "docs/vb2-ir/procedures/SUB.BAS-8ff879e9dc-302a874f.WalkingSub.018.json",
      "statementId": "SUB.BAS-8ff879e9dc-302a874f.WalkingSub.018.decoded-statement-0032",
      "statementText": "Message \"Fight \" + CStr(ENMLevel)",
      "sourceRange": {
        "lineStart": 364,
        "lineEnd": 364,
        "columnStart": 17,
        "columnEnd": 49
      },
      "literalPrefix": "Fight ",
      "command": "FIGHT",
      "evidence": "decoded_bas_text_source_message_call"
    }
  ],
  "eventCommandEvidence": {
    "manifest": "docs/original-event-command-manifest.json",
    "commands": [
      {
        "command": "BACKTOTITLE",
        "count": 1,
        "requiresTimerMessageCandidate": true,
        "sampleSources": [
          "TOWN1.MPD@107,62"
        ]
      },
      {
        "command": "CLICK",
        "count": 261,
        "requiresTimerMessageCandidate": true,
        "sampleSources": [
          "defaultSave.openingScript",
          "MAP1.MPD@13,6",
          "MAP1.MPD@13,6",
          "MAP1.MPD@23,7",
          "MAP1.MPD@18,7",
          "MAP1.MPD@18,7",
          "MAP1.MPD@11,9",
          "MAP1.MPD@11,9",
          "MAP1.MPD@11,9",
          "MAP1.MPD@7,15",
          "MAP1.MPD@7,15",
          "MAP1.MPD@7,15"
        ]
      },
      {
        "command": "END",
        "count": 62,
        "requiresTimerMessageCandidate": false,
        "sampleSources": [
          "MAP1.MPD@13,6",
          "MAP1.MPD@18,7",
          "MAP1.MPD@20,18",
          "MAP1.MPD@11,9",
          "MAP1.MPD@7,15",
          "MAP1.MPD@109,63",
          "MAP1.MPD@123,50",
          "MAP1.MPD@117,41",
          "MAP1.MPD@127,22",
          "MAP1.MPD@0,22",
          "MAP1.MPD@96,57",
          "MAP1.MPD@67,66"
        ]
      },
      {
        "command": "EXIST",
        "count": 5,
        "requiresTimerMessageCandidate": true,
        "sampleSources": [
          "CAVE1.MPD@40,110",
          "TOWN1.MPD@21,6",
          "TOWN1.MPD@105,56",
          "TOWN1.MPD@15,35",
          "TOWN1.MPD@97,48"
        ]
      },
      {
        "command": "FIGHT",
        "count": 8,
        "requiresTimerMessageCandidate": true,
        "sampleSources": [
          "MAP1.MPD@18,7",
          "CAVE1.MPD@10,4",
          "CAVE1.MPD@24,105",
          "TOWER1.MPD@118,23",
          "TOWER1.MPD@61,44",
          "TOWER1.MPD@61,61",
          "TOWER1.MPD@9,94",
          "TOWER1.MPD@49,53"
        ]
      },
      {
        "command": "FLAG",
        "count": 50,
        "requiresTimerMessageCandidate": true,
        "sampleSources": [
          "MAP1.MPD@18,7",
          "CASTLE1.MPD@9,20",
          "CASTLE1.MPD@58,5",
          "CASTLE1.MPD@56,5",
          "CASTLE1.MPD@102,11",
          "CAVE1.MPD@6,20",
          "CAVE1.MPD@14,29",
          "CAVE1.MPD@51,18",
          "CAVE1.MPD@19,57",
          "CAVE1.MPD@7,111",
          "CAVE1.MPD@7,111",
          "CAVE1.MPD@7,111"
        ]
      },
      {
        "command": "GOTO",
        "count": 1,
        "requiresTimerMessageCandidate": false,
        "sampleSources": [
          "TOWER1.MPD@61,61"
        ]
      },
      {
        "command": "HP",
        "count": 2,
        "requiresTimerMessageCandidate": true,
        "sampleSources": [
          "MAP1.MPD@13,6",
          "MAP1.MPD@23,7"
        ]
      },
      {
        "command": "IF",
        "count": 129,
        "requiresTimerMessageCandidate": false,
        "sampleSources": [
          "MAP1.MPD@13,6",
          "MAP1.MPD@18,7",
          "MAP1.MPD@18,7",
          "MAP1.MPD@20,18",
          "MAP1.MPD@11,9",
          "MAP1.MPD@11,9",
          "MAP1.MPD@11,9",
          "MAP1.MPD@11,9",
          "MAP1.MPD@7,15",
          "MAP1.MPD@109,63",
          "MAP1.MPD@123,50",
          "MAP1.MPD@117,41"
        ]
      },
      {
        "command": "INN",
        "count": 5,
        "requiresTimerMessageCandidate": true,
        "sampleSources": [
          "TOWN1.MPD@23,13",
          "TOWN1.MPD@64,20",
          "TOWN1.MPD@113,24",
          "TOWN1.MPD@106,47",
          "TOWN1.MPD@23,41"
        ]
      },
      {
        "command": "ITEM",
        "count": 32,
        "requiresTimerMessageCandidate": true,
        "sampleSources": [
          "CASTLE1.MPD@56,5",
          "CAVE1.MPD@6,20",
          "CAVE1.MPD@51,18",
          "CAVE1.MPD@19,57",
          "CAVE1.MPD@7,111",
          "CAVE1.MPD@24,105",
          "CAVE1.MPD@35,82",
          "CAVE1.MPD@33,104",
          "CAVE1.MPD@40,110",
          "CAVE1.MPD@81,118",
          "TOWER1.MPD@70,6",
          "TOWER1.MPD@57,21"
        ]
      },
      {
        "command": "MONEY",
        "count": 3,
        "requiresTimerMessageCandidate": true,
        "sampleSources": [
          "CASTLE1.MPD@9,4",
          "CASTLE1.MPD@58,5",
          "CAVE1.MPD@14,29"
        ]
      },
      {
        "command": "MOVE",
        "count": 91,
        "requiresTimerMessageCandidate": true,
        "sampleSources": [
          "MAP1.MPD@18,7",
          "MAP1.MPD@20,18",
          "MAP1.MPD@20,18",
          "MAP1.MPD@11,9",
          "MAP1.MPD@7,15",
          "MAP1.MPD@4,19",
          "MAP1.MPD@108,39",
          "MAP1.MPD@101,29",
          "MAP1.MPD@98,57",
          "MAP1.MPD@120,52",
          "MAP1.MPD@96,57",
          "MAP1.MPD@96,57"
        ]
      },
      {
        "command": "MPD",
        "count": 47,
        "requiresTimerMessageCandidate": true,
        "sampleSources": [
          "MAP1.MPD@11,9",
          "CASTLE1.MPD@58,5",
          "CASTLE1.MPD@56,5",
          "CASTLE1.MPD@102,11",
          "CASTLE1.MPD@0,-1",
          "CAVE1.MPD@10,4",
          "CAVE1.MPD@6,20",
          "CAVE1.MPD@14,29",
          "CAVE1.MPD@51,18",
          "CAVE1.MPD@34,59",
          "CAVE1.MPD@19,57",
          "CAVE1.MPD@7,111"
        ]
      },
      {
        "command": "PRINT",
        "count": 569,
        "requiresTimerMessageCandidate": true,
        "sampleSources": [
          "defaultSave.openingScript",
          "defaultSave.openingScript",
          "MAP1.MPD@13,6",
          "MAP1.MPD@13,6",
          "MAP1.MPD@23,7",
          "MAP1.MPD@23,7",
          "MAP1.MPD@18,7",
          "MAP1.MPD@18,7",
          "MAP1.MPD@18,7",
          "MAP1.MPD@18,7",
          "MAP1.MPD@18,7",
          "MAP1.MPD@11,9"
        ]
      },
      {
        "command": "SHOP",
        "count": 7,
        "requiresTimerMessageCandidate": true,
        "sampleSources": [
          "TOWER1.MPD@35,8",
          "TOWN1.MPD@29,13",
          "TOWN1.MPD@72,20",
          "TOWN1.MPD@75,20",
          "TOWN1.MPD@112,53",
          "TOWN1.MPD@99,40",
          "TOWN1.MPD@25,41"
        ]
      },
      {
        "command": "SILENTCHAR",
        "count": 7,
        "requiresTimerMessageCandidate": true,
        "sampleSources": [
          "MAP1.MPD@96,57",
          "MAP1.MPD@20,20",
          "TOWER1.MPD@21,31",
          "TOWER1.MPD@23,31",
          "TOWN1.MPD@87,49",
          "TOWN1.MPD@33,43",
          "TOWN1.MPD@15,35"
        ]
      },
      {
        "command": "WAIT",
        "count": 28,
        "requiresTimerMessageCandidate": true,
        "sampleSources": [
          "TOWER1.MPD@9,94",
          "TOWN1.MPD@107,62",
          "TOWN1.MPD@107,62",
          "TOWN1.MPD@107,62",
          "TOWN1.MPD@107,62",
          "TOWN1.MPD@107,62",
          "TOWN1.MPD@107,62",
          "TOWN1.MPD@107,62",
          "TOWN1.MPD@15,35",
          "TOWN1.MPD@15,35",
          "TOWN1.MPD@15,35",
          "TOWN1.MPD@15,35"
        ]
      },
      {
        "command": "WALK",
        "count": 17,
        "requiresTimerMessageCandidate": true,
        "sampleSources": [
          "MAP1.MPD@109,63",
          "MAP1.MPD@109,63",
          "MAP1.MPD@123,50",
          "MAP1.MPD@123,50",
          "MAP1.MPD@117,41",
          "MAP1.MPD@117,41",
          "MAP1.MPD@127,22",
          "MAP1.MPD@127,22",
          "MAP1.MPD@0,22",
          "MAP1.MPD@0,22",
          "MAP1.MPD@96,57",
          "TOWER1.MPD@9,94"
        ]
      },
      {
        "command": "WIPEOUT",
        "count": 1,
        "requiresTimerMessageCandidate": true,
        "sampleSources": [
          "TOWN1.MPD@107,62"
        ]
      }
    ]
  },
  "msgSubBridgeEvidence": {
    "procedure": {
      "module": "SUB.BAS",
      "procedure": "MsgSub",
      "procedureId": "SUB.BAS-8ff879e9dc-302a874f.MsgSub.014",
      "procedureIrPath": "docs/vb2-ir/procedures/SUB.BAS-8ff879e9dc-302a874f.MsgSub.014.json",
      "decoded": true,
      "statementCount": 129
    },
    "statements": [
      {
        "statementId": "SUB.BAS-8ff879e9dc-302a874f.MsgSub.014.decoded-statement-0036",
        "statementText": "Message \"WIPEOUT\"",
        "sourceRange": {
          "lineStart": 202,
          "lineEnd": 202,
          "columnStart": 9,
          "columnEnd": 25
        }
      },
      {
        "statementId": "SUB.BAS-8ff879e9dc-302a874f.MsgSub.014.decoded-statement-0037",
        "statementText": "Message M$(MLine)",
        "sourceRange": {
          "lineStart": 203,
          "lineEnd": 203,
          "columnStart": 9,
          "columnEnd": 25
        }
      },
      {
        "statementId": "SUB.BAS-8ff879e9dc-302a874f.MsgSub.014.decoded-statement-0038",
        "statementText": "Message \"WIPEIN\"",
        "sourceRange": {
          "lineStart": 204,
          "lineEnd": 204,
          "columnStart": 9,
          "columnEnd": 24
        }
      },
      {
        "statementId": "SUB.BAS-8ff879e9dc-302a874f.MsgSub.014.decoded-statement-0039",
        "statementText": "Case \"END\"",
        "sourceRange": {
          "lineStart": 205,
          "lineEnd": 205,
          "columnStart": 5,
          "columnEnd": 14
        }
      },
      {
        "statementId": "SUB.BAS-8ff879e9dc-302a874f.MsgSub.014.decoded-statement-0041",
        "statementText": "Case \"GOTO\"",
        "sourceRange": {
          "lineStart": 207,
          "lineEnd": 207,
          "columnStart": 5,
          "columnEnd": 15
        }
      },
      {
        "statementId": "SUB.BAS-8ff879e9dc-302a874f.MsgSub.014.decoded-statement-0044",
        "statementText": "Case \"IF\"",
        "sourceRange": {
          "lineStart": 210,
          "lineEnd": 210,
          "columnStart": 5,
          "columnEnd": 13
        }
      },
      {
        "statementId": "SUB.BAS-8ff879e9dc-302a874f.MsgSub.014.decoded-statement-0108",
        "statementText": "Message M$(MLine)",
        "sourceRange": {
          "lineStart": 274,
          "lineEnd": 274,
          "columnStart": 9,
          "columnEnd": 25
        }
      },
      {
        "statementId": "SUB.BAS-8ff879e9dc-302a874f.MsgSub.014.decoded-statement-0116",
        "statementText": "Case \"END\"",
        "sourceRange": {
          "lineStart": 284,
          "lineEnd": 284,
          "columnStart": 5,
          "columnEnd": 14
        }
      },
      {
        "statementId": "SUB.BAS-8ff879e9dc-302a874f.MsgSub.014.decoded-statement-0127",
        "statementText": "Message M$(MLine)",
        "sourceRange": {
          "lineStart": 296,
          "lineEnd": 296,
          "columnStart": 5,
          "columnEnd": 21
        }
      }
    ],
    "evidenceBoundary": "MsgSub source-backed dispatch explains which lines are queued through Message and which commands are control-flow-only. It does not decode TimerMessage command effects."
  },
  "commandEffectCandidateCoverage": [
    {
      "command": "BACKTOTITLE",
      "basEmitterCount": 0,
      "eventScriptCommandCount": 1,
      "timerCandidateLineCount": 2,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0023",
          "sourceRange": {
            "byteStart": 20190,
            "byteEnd": 20214
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x0010",
            "0x026e",
            "0x000b",
            "0x4142",
            "0x4b43",
            "0x4f54",
            "0x4954",
            "0x4c54",
            "0x0045",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "BACKTOTITLE"
          ],
          "matchedCommands": [
            "BACKTOTITLE"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:948",
          "sourceRange": {
            "lineStart": 948,
            "lineEnd": 948
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "BACKTOTITLE"
          ],
          "matchedCommands": [
            "BACKTOTITLE"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [
        "TOWN1.MPD@107,62"
      ],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "CHANGEBGM",
      "basEmitterCount": 2,
      "eventScriptCommandCount": 0,
      "timerCandidateLineCount": 2,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [
        {
          "module": "MAIN.BAS",
          "procedure": "EndFight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.decoded-statement-0005",
          "statementText": "Message \"ChangeBGM \" + BGMFile",
          "sourceRange": {
            "lineStart": 52,
            "lineEnd": 52,
            "columnStart": 5,
            "columnEnd": 34
          },
          "literalPrefix": "ChangeBGM ",
          "command": "CHANGEBGM",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAIN.BAS",
          "procedure": "EscapeFight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.decoded-statement-0005",
          "statementText": "Message \"ChangeBGM \" + BGMFile",
          "sourceRange": {
            "lineStart": 64,
            "lineEnd": 64,
            "columnStart": 5,
            "columnEnd": 34
          },
          "literalPrefix": "ChangeBGM ",
          "command": "CHANGEBGM",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0025",
          "sourceRange": {
            "byteStart": 20222,
            "byteEnd": 20244
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x000e",
            "0x029a",
            "0x0009",
            "0x4843",
            "0x4e41",
            "0x4547",
            "0x4742",
            "0x004d",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "CHANGEBGM"
          ],
          "matchedCommands": [
            "CHANGEBGM"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:950",
          "sourceRange": {
            "lineStart": 950,
            "lineEnd": 950
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "CHANGEBGM"
          ],
          "matchedCommands": [
            "CHANGEBGM"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "CHAR",
      "basEmitterCount": 0,
      "eventScriptCommandCount": 0,
      "timerCandidateLineCount": 1,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:953",
          "sourceRange": {
            "lineStart": 953,
            "lineEnd": 953
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "CHAR"
          ],
          "matchedCommands": [
            "CHAR"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "CLICK",
      "basEmitterCount": 6,
      "eventScriptCommandCount": 261,
      "timerCandidateLineCount": 4,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [
        {
          "module": "ITEM.BAS",
          "procedure": "UsableCheck",
          "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UsableCheck.text-001",
          "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UsableCheck.text-001.json",
          "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UsableCheck.text-001.decoded-statement-0018",
          "statementText": "If UC = False And (MainState And Fighting) = 0 Then Message \"Click\"",
          "sourceRange": {
            "lineStart": 72,
            "lineEnd": 72,
            "columnStart": 5,
            "columnEnd": 71
          },
          "literalPrefix": "Click",
          "command": "CLICK",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ITEM.BAS",
          "procedure": "UseItem",
          "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
          "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
          "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0238",
          "statementText": "Message \"Click\"",
          "sourceRange": {
            "lineStart": 313,
            "lineEnd": 313,
            "columnStart": 9,
            "columnEnd": 23
          },
          "literalPrefix": "Click",
          "command": "CLICK",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAGIC.BAS",
          "procedure": "MagicCheck",
          "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.MagicCheck.text-001",
          "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.MagicCheck.text-001.json",
          "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.MagicCheck.text-001.decoded-statement-0014",
          "statementText": "If UC = False And (MainState And Fighting) = 0 Then Message \"Click\"",
          "sourceRange": {
            "lineStart": 25,
            "lineEnd": 25,
            "columnStart": 5,
            "columnEnd": 71
          },
          "literalPrefix": "Click",
          "command": "CLICK",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAGIC.BAS",
          "procedure": "UseMagic",
          "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
          "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
          "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0162",
          "statementText": "Message \"Click\"",
          "sourceRange": {
            "lineStart": 210,
            "lineEnd": 210,
            "columnStart": 9,
            "columnEnd": 23
          },
          "literalPrefix": "Click",
          "command": "CLICK",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAIN.BAS",
          "procedure": "Fight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.decoded-statement-0055",
          "statementText": "Message \"Click\"",
          "sourceRange": {
            "lineStart": 126,
            "lineEnd": 126,
            "columnStart": 5,
            "columnEnd": 19
          },
          "literalPrefix": "Click",
          "command": "CLICK",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAIN.BAS",
          "procedure": "GameOver",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.decoded-statement-0003",
          "statementText": "Message \"Click\"",
          "sourceRange": {
            "lineStart": 145,
            "lineEnd": 145,
            "columnStart": 5,
            "columnEnd": 19
          },
          "literalPrefix": "Click",
          "command": "CLICK",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0032",
          "sourceRange": {
            "byteStart": 20316,
            "byteEnd": 20334
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x000a",
            "0x0312",
            "0x0005",
            "0x4c43",
            "0x4349",
            "0x004b",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [
            "Form_Load"
          ],
          "literalTexts": [
            "CLICK"
          ],
          "matchedCommands": [
            "CLICK"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0280",
          "sourceRange": {
            "byteStart": 25608,
            "byteEnd": 25630
          },
          "rawWordsHex": [
            "0x2000",
            "0x00ed",
            "0x000a",
            "0x1c58",
            "0x0005",
            "0x6c43",
            "0x6369",
            "0x006b",
            "0x0024",
            "0x0001",
            "0x029f"
          ],
          "identifierReferenceCandidateNames": [
            "Picture1_Click"
          ],
          "literalTexts": [
            "Click"
          ],
          "matchedCommands": [
            "CLICK"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0291",
          "sourceRange": {
            "byteStart": 26946,
            "byteEnd": 26976
          },
          "rawWordsHex": [
            "0x2000",
            "0x000b",
            "0x087a",
            "0x0045",
            "0x22c4",
            "0x00ed",
            "0x000a",
            "0x22ac",
            "0x0005",
            "0x6c43",
            "0x6369",
            "0x006b",
            "0x0024",
            "0x0001",
            "0x029f"
          ],
          "identifierReferenceCandidateNames": [
            "MSGCashe",
            "Picture1_Click"
          ],
          "literalTexts": [
            "Click"
          ],
          "matchedCommands": [
            "CLICK"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:957",
          "sourceRange": {
            "lineStart": 957,
            "lineEnd": 957
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "CLICK"
          ],
          "matchedCommands": [
            "CLICK"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [
        "defaultSave.openingScript",
        "MAP1.MPD@13,6",
        "MAP1.MPD@13,6",
        "MAP1.MPD@23,7",
        "MAP1.MPD@18,7",
        "MAP1.MPD@18,7",
        "MAP1.MPD@11,9",
        "MAP1.MPD@11,9"
      ],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "COMMAND",
      "basEmitterCount": 1,
      "eventScriptCommandCount": 0,
      "timerCandidateLineCount": 2,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [
        {
          "module": "MAIN.BAS",
          "procedure": "StartTurn",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007.decoded-statement-0035",
          "statementText": "Message \"Command \" + CStr(TurnNO)",
          "sourceRange": {
            "lineStart": 219,
            "lineEnd": 219,
            "columnStart": 9,
            "columnEnd": 41
          },
          "literalPrefix": "Command ",
          "command": "COMMAND",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0034",
          "sourceRange": {
            "byteStart": 20342,
            "byteEnd": 20362
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x000c",
            "0x0338",
            "0x0007",
            "0x4f43",
            "0x4d4d",
            "0x4e41",
            "0x0044",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [
            "About"
          ],
          "literalTexts": [
            "COMMAND"
          ],
          "matchedCommands": [
            "COMMAND"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:959",
          "sourceRange": {
            "lineStart": 959,
            "lineEnd": 959
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "COMMAND"
          ],
          "matchedCommands": [
            "COMMAND"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "DAMAGE",
      "basEmitterCount": 2,
      "eventScriptCommandCount": 0,
      "timerCandidateLineCount": 2,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0030",
          "statementText": "Message \"DAMAGE \" + CStr(Target) + \" \" + CStr(V2) + \" \" + Wave",
          "sourceRange": {
            "lineStart": 74,
            "lineEnd": 74,
            "columnStart": 9,
            "columnEnd": 70
          },
          "literalPrefix": "DAMAGE ",
          "command": "DAMAGE",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0047",
          "statementText": "Message \"DAMAGE \" + CStr(I) + \" \" + CStr(V2) + \" Damage\"",
          "sourceRange": {
            "lineStart": 91,
            "lineEnd": 91,
            "columnStart": 17,
            "columnEnd": 72
          },
          "literalPrefix": "DAMAGE ",
          "command": "DAMAGE",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0040",
          "sourceRange": {
            "byteStart": 20488,
            "byteEnd": 20508
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x000c",
            "0x03f0",
            "0x0006",
            "0x4144",
            "0x414d",
            "0x4547",
            "0x0000",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [
            "About",
            "Enabled"
          ],
          "literalTexts": [
            "DAMAGE"
          ],
          "matchedCommands": [
            "DAMAGE"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:965",
          "sourceRange": {
            "lineStart": 965,
            "lineEnd": 965
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "DAMAGE"
          ],
          "matchedCommands": [
            "DAMAGE"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "DRAW",
      "basEmitterCount": 0,
      "eventScriptCommandCount": 0,
      "timerCandidateLineCount": 1,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:983",
          "sourceRange": {
            "lineStart": 983,
            "lineEnd": 983
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "DRAW"
          ],
          "matchedCommands": [
            "DRAW"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "DRAWSTATE",
      "basEmitterCount": 0,
      "eventScriptCommandCount": 0,
      "timerCandidateLineCount": 1,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:995",
          "sourceRange": {
            "lineStart": 995,
            "lineEnd": 995
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "DRAWSTATE"
          ],
          "matchedCommands": [
            "DRAWSTATE"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "END",
      "basEmitterCount": 0,
      "eventScriptCommandCount": 62,
      "timerCandidateLineCount": 0,
      "controlFlowHandledByMsgSub": true,
      "coverageStatus": "msgsub_control_flow_command",
      "decodedEffect": null,
      "sampleBasEmitters": [],
      "sampleTimerCandidates": [],
      "sampleEventSources": [
        "MAP1.MPD@13,6",
        "MAP1.MPD@18,7",
        "MAP1.MPD@20,18",
        "MAP1.MPD@11,9",
        "MAP1.MPD@7,15",
        "MAP1.MPD@109,63",
        "MAP1.MPD@123,50",
        "MAP1.MPD@117,41"
      ],
      "unknowns": []
    },
    {
      "command": "ENDENEMYDAMAGE",
      "basEmitterCount": 0,
      "eventScriptCommandCount": 0,
      "timerCandidateLineCount": 1,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:997",
          "sourceRange": {
            "lineStart": 997,
            "lineEnd": 997
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "ENDENEMYDAMAGE"
          ],
          "matchedCommands": [
            "ENDENEMYDAMAGE"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "ENDFIGHT",
      "basEmitterCount": 4,
      "eventScriptCommandCount": 0,
      "timerCandidateLineCount": 3,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [
        {
          "module": "MAIN.BAS",
          "procedure": "EndFight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.decoded-statement-0007",
          "statementText": "Message \"EndFight 1\"",
          "sourceRange": {
            "lineStart": 54,
            "lineEnd": 54,
            "columnStart": 5,
            "columnEnd": 24
          },
          "literalPrefix": "EndFight 1",
          "command": "ENDFIGHT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAIN.BAS",
          "procedure": "EscapeFight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.decoded-statement-0007",
          "statementText": "Message \"EndFight 3\"",
          "sourceRange": {
            "lineStart": 66,
            "lineEnd": 66,
            "columnStart": 5,
            "columnEnd": 24
          },
          "literalPrefix": "EndFight 3",
          "command": "ENDFIGHT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAIN.BAS",
          "procedure": "Fight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.decoded-statement-0066",
          "statementText": "Message \"EndFight 0\"",
          "sourceRange": {
            "lineStart": 138,
            "lineEnd": 138,
            "columnStart": 5,
            "columnEnd": 24
          },
          "literalPrefix": "EndFight 0",
          "command": "ENDFIGHT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAIN.BAS",
          "procedure": "StartTurn",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007.decoded-statement-0030",
          "statementText": "Message \"EndFight 0\"",
          "sourceRange": {
            "lineStart": 214,
            "lineEnd": 214,
            "columnStart": 9,
            "columnEnd": 28
          },
          "literalPrefix": "EndFight 0",
          "command": "ENDFIGHT",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0074",
          "sourceRange": {
            "byteStart": 21482,
            "byteEnd": 21504
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x000e",
            "0x08b6",
            "0x0008",
            "0x4e45",
            "0x4644",
            "0x4749",
            "0x5448",
            "0x0000",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "ENDFIGHT"
          ],
          "matchedCommands": [
            "ENDFIGHT"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0292",
          "sourceRange": {
            "byteStart": 26976,
            "byteEnd": 27004
          },
          "rawWordsHex": [
            "0x2000",
            "0x00ed",
            "0x0010",
            "0x22cc",
            "0x000a",
            "0x6e45",
            "0x4664",
            "0x6769",
            "0x7468",
            "0x3020",
            "0x0000",
            "0x0024",
            "0x0001",
            "0x029f"
          ],
          "identifierReferenceCandidateNames": [
            "Picture1_Click"
          ],
          "literalTexts": [
            "EndFight 0"
          ],
          "matchedCommands": [
            "ENDFIGHT"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:999",
          "sourceRange": {
            "lineStart": 999,
            "lineEnd": 999
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "ENDFIGHT"
          ],
          "matchedCommands": [
            "ENDFIGHT"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "ENEMYDAMAGE",
      "basEmitterCount": 2,
      "eventScriptCommandCount": 0,
      "timerCandidateLineCount": 2,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [
        {
          "module": "ITEM.BAS",
          "procedure": "UseItem",
          "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
          "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
          "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0199",
          "statementText": "Message \"EnemyDamage \" + CStr(EnmNO) + \" \" + CStr(DM) + \" Attack\"",
          "sourceRange": {
            "lineStart": 274,
            "lineEnd": 274,
            "columnStart": 17,
            "columnEnd": 81
          },
          "literalPrefix": "EnemyDamage ",
          "command": "ENEMYDAMAGE",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAGIC.BAS",
          "procedure": "UseMagic",
          "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
          "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
          "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0149",
          "statementText": "Message \"EnemyDamage \" + CStr(I) + \" \" + CStr(DM) + \" Attack\"",
          "sourceRange": {
            "lineStart": 197,
            "lineEnd": 197,
            "columnStart": 17,
            "columnEnd": 77
          },
          "literalPrefix": "EnemyDamage ",
          "command": "ENEMYDAMAGE",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0092",
          "sourceRange": {
            "byteStart": 21692,
            "byteEnd": 21716
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x0010",
            "0x09c6",
            "0x000b",
            "0x4e45",
            "0x4d45",
            "0x4459",
            "0x4d41",
            "0x4741",
            "0x0045",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "ENEMYDAMAGE"
          ],
          "matchedCommands": [
            "ENEMYDAMAGE"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1018",
          "sourceRange": {
            "lineStart": 1018,
            "lineEnd": 1018
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "ENEMYDAMAGE"
          ],
          "matchedCommands": [
            "ENEMYDAMAGE"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "EXIST",
      "basEmitterCount": 0,
      "eventScriptCommandCount": 5,
      "timerCandidateLineCount": 2,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0117",
          "sourceRange": {
            "byteStart": 22472,
            "byteEnd": 22490
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x000a",
            "0x0d68",
            "0x0005",
            "0x5845",
            "0x5349",
            "0x0054",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "EXIST"
          ],
          "matchedCommands": [
            "EXIST"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1043",
          "sourceRange": {
            "lineStart": 1043,
            "lineEnd": 1043
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "EXIST"
          ],
          "matchedCommands": [
            "EXIST"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [
        "CAVE1.MPD@40,110",
        "TOWN1.MPD@21,6",
        "TOWN1.MPD@105,56",
        "TOWN1.MPD@15,35",
        "TOWN1.MPD@97,48"
      ],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "FIGHT",
      "basEmitterCount": 1,
      "eventScriptCommandCount": 8,
      "timerCandidateLineCount": 3,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [
        {
          "module": "SUB.BAS",
          "procedure": "WalkingSub",
          "procedureId": "SUB.BAS-8ff879e9dc-302a874f.WalkingSub.018",
          "procedureIrPath": "docs/vb2-ir/procedures/SUB.BAS-8ff879e9dc-302a874f.WalkingSub.018.json",
          "statementId": "SUB.BAS-8ff879e9dc-302a874f.WalkingSub.018.decoded-statement-0032",
          "statementText": "Message \"Fight \" + CStr(ENMLevel)",
          "sourceRange": {
            "lineStart": 364,
            "lineEnd": 364,
            "columnStart": 17,
            "columnEnd": 49
          },
          "literalPrefix": "Fight ",
          "command": "FIGHT",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0120",
          "sourceRange": {
            "byteStart": 22536,
            "byteEnd": 22554
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x000a",
            "0x0dbe",
            "0x0005",
            "0x4946",
            "0x4847",
            "0x0054",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [
            "MMS_Magic"
          ],
          "literalTexts": [
            "FIGHT"
          ],
          "matchedCommands": [
            "FIGHT"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0170",
          "sourceRange": {
            "byteStart": 23344,
            "byteEnd": 23362
          },
          "rawWordsHex": [
            "0x2000",
            "0x00ed",
            "0x000a",
            "0x11c8",
            "0x0005",
            "0x4946",
            "0x4847",
            "0x0054",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "FIGHT"
          ],
          "matchedCommands": [
            "FIGHT"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1046",
          "sourceRange": {
            "lineStart": 1046,
            "lineEnd": 1046
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "FIGHT"
          ],
          "matchedCommands": [
            "FIGHT"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [
        "MAP1.MPD@18,7",
        "CAVE1.MPD@10,4",
        "CAVE1.MPD@24,105",
        "TOWER1.MPD@118,23",
        "TOWER1.MPD@61,44",
        "TOWER1.MPD@61,61",
        "TOWER1.MPD@9,94",
        "TOWER1.MPD@49,53"
      ],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "FLAG",
      "basEmitterCount": 0,
      "eventScriptCommandCount": 50,
      "timerCandidateLineCount": 2,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0124",
          "sourceRange": {
            "byteStart": 22600,
            "byteEnd": 22618
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x000a",
            "0x0e16",
            "0x0004",
            "0x4c46",
            "0x4741",
            "0x0000",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "FLAG"
          ],
          "matchedCommands": [
            "FLAG"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1050",
          "sourceRange": {
            "lineStart": 1050,
            "lineEnd": 1050
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "FLAG"
          ],
          "matchedCommands": [
            "FLAG"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [
        "MAP1.MPD@18,7",
        "CASTLE1.MPD@9,20",
        "CASTLE1.MPD@58,5",
        "CASTLE1.MPD@56,5",
        "CASTLE1.MPD@102,11",
        "CAVE1.MPD@6,20",
        "CAVE1.MPD@14,29",
        "CAVE1.MPD@51,18"
      ],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "GAMEOVER",
      "basEmitterCount": 0,
      "eventScriptCommandCount": 0,
      "timerCandidateLineCount": 1,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1056",
          "sourceRange": {
            "lineStart": 1056,
            "lineEnd": 1056
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "GAMEOVER"
          ],
          "matchedCommands": [
            "GAMEOVER"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "GOTO",
      "basEmitterCount": 0,
      "eventScriptCommandCount": 1,
      "timerCandidateLineCount": 0,
      "controlFlowHandledByMsgSub": true,
      "coverageStatus": "msgsub_control_flow_command",
      "decodedEffect": null,
      "sampleBasEmitters": [],
      "sampleTimerCandidates": [],
      "sampleEventSources": [
        "TOWER1.MPD@61,61"
      ],
      "unknowns": []
    },
    {
      "command": "HP",
      "basEmitterCount": 4,
      "eventScriptCommandCount": 2,
      "timerCandidateLineCount": 3,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [
        {
          "module": "ITEM.BAS",
          "procedure": "UseItem",
          "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
          "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
          "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0019",
          "statementText": "Message \"HP \" + A2 + \" \" + CStr(ItemEffect(IN - 1))",
          "sourceRange": {
            "lineStart": 96,
            "lineEnd": 96,
            "columnStart": 9,
            "columnEnd": 59
          },
          "literalPrefix": "HP ",
          "command": "HP",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ITEM.BAS",
          "procedure": "UseItem",
          "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
          "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
          "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0025",
          "statementText": "Message \"HP \" + A2 + \" \" + CStr(ItemEffect(IN - 1))",
          "sourceRange": {
            "lineStart": 102,
            "lineEnd": 102,
            "columnStart": 9,
            "columnEnd": 59
          },
          "literalPrefix": "HP ",
          "command": "HP",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAGIC.BAS",
          "procedure": "UseMagic",
          "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
          "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
          "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0018",
          "statementText": "Message \"HP \" + A2 + \" \" + CStr(MagicEffect(IN - 1))",
          "sourceRange": {
            "lineStart": 66,
            "lineEnd": 66,
            "columnStart": 9,
            "columnEnd": 60
          },
          "literalPrefix": "HP ",
          "command": "HP",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAGIC.BAS",
          "procedure": "UseMagic",
          "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
          "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
          "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0024",
          "statementText": "Message \"HP \" + A2 + \" \" + CStr(MagicEffect(IN - 1))",
          "sourceRange": {
            "lineStart": 72,
            "lineEnd": 72,
            "columnStart": 9,
            "columnEnd": 60
          },
          "literalPrefix": "HP ",
          "command": "HP",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0048",
          "sourceRange": {
            "byteStart": 20662,
            "byteEnd": 20714
          },
          "rawWordsHex": [
            "0x3000",
            "0x00ed",
            "0x0008",
            "0x04ca",
            "0x0003",
            "0x5048",
            "0x0020",
            "0x04e4",
            "0x1c0e",
            "0x0001",
            "0x0911",
            "0x00a3",
            "0x00ed",
            "0x0008",
            "0x04e0",
            "0x0002",
            "0x2d20",
            "0x0000",
            "0x00a3",
            "0x000b",
            "0x090b",
            "0x1cab",
            "0x00a3",
            "0x0024",
            "0x0001",
            "0x029f"
          ],
          "identifierReferenceCandidateNames": [
            "EndSelect",
            "BGMF",
            "Picture1_Click"
          ],
          "literalTexts": [
            "HP ",
            " -"
          ],
          "matchedCommands": [
            "HP"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0135",
          "sourceRange": {
            "byteStart": 22804,
            "byteEnd": 22820
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x0008",
            "0x0f16",
            "0x0002",
            "0x5048",
            "0x0000",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "HP"
          ],
          "matchedCommands": [
            "HP"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1061",
          "sourceRange": {
            "lineStart": 1061,
            "lineEnd": 1061
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "HP"
          ],
          "matchedCommands": [
            "HP"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [
        "MAP1.MPD@13,6",
        "MAP1.MPD@23,7"
      ],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "IF",
      "basEmitterCount": 0,
      "eventScriptCommandCount": 129,
      "timerCandidateLineCount": 0,
      "controlFlowHandledByMsgSub": true,
      "coverageStatus": "msgsub_control_flow_command",
      "decodedEffect": null,
      "sampleBasEmitters": [],
      "sampleTimerCandidates": [],
      "sampleEventSources": [
        "MAP1.MPD@13,6",
        "MAP1.MPD@18,7",
        "MAP1.MPD@18,7",
        "MAP1.MPD@20,18",
        "MAP1.MPD@11,9",
        "MAP1.MPD@11,9",
        "MAP1.MPD@11,9",
        "MAP1.MPD@11,9"
      ],
      "unknowns": []
    },
    {
      "command": "INN",
      "basEmitterCount": 0,
      "eventScriptCommandCount": 5,
      "timerCandidateLineCount": 2,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0152",
          "sourceRange": {
            "byteStart": 23078,
            "byteEnd": 23094
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x0008",
            "0x1082",
            "0x0003",
            "0x4e49",
            "0x004e",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "INN"
          ],
          "matchedCommands": [
            "INN"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1077",
          "sourceRange": {
            "lineStart": 1077,
            "lineEnd": 1077
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "INN"
          ],
          "matchedCommands": [
            "INN"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [
        "TOWN1.MPD@23,13",
        "TOWN1.MPD@64,20",
        "TOWN1.MPD@113,24",
        "TOWN1.MPD@106,47",
        "TOWN1.MPD@23,41"
      ],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "ITEM",
      "basEmitterCount": 0,
      "eventScriptCommandCount": 32,
      "timerCandidateLineCount": 2,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0159",
          "sourceRange": {
            "byteStart": 23190,
            "byteEnd": 23208
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x000a",
            "0x1106",
            "0x0004",
            "0x5449",
            "0x4d45",
            "0x0000",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "ITEM"
          ],
          "matchedCommands": [
            "ITEM"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1084",
          "sourceRange": {
            "lineStart": 1084,
            "lineEnd": 1084
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "ITEM"
          ],
          "matchedCommands": [
            "ITEM"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [
        "CASTLE1.MPD@56,5",
        "CAVE1.MPD@6,20",
        "CAVE1.MPD@51,18",
        "CAVE1.MPD@19,57",
        "CAVE1.MPD@7,111",
        "CAVE1.MPD@24,105",
        "CAVE1.MPD@35,82",
        "CAVE1.MPD@33,104"
      ],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "MENU",
      "basEmitterCount": 2,
      "eventScriptCommandCount": 0,
      "timerCandidateLineCount": 4,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [
        {
          "module": "MAIN.BAS",
          "procedure": "Fight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.decoded-statement-0016",
          "statementText": "Message \"Menu ET\"",
          "sourceRange": {
            "lineStart": 87,
            "lineEnd": 87,
            "columnStart": 5,
            "columnEnd": 21
          },
          "literalPrefix": "Menu ET",
          "command": "MENU",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAIN.BAS",
          "procedure": "GameOver",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.decoded-statement-0011",
          "statementText": "Message \"Menu First\"",
          "sourceRange": {
            "lineStart": 153,
            "lineEnd": 153,
            "columnStart": 5,
            "columnEnd": 24
          },
          "literalPrefix": "Menu First",
          "command": "MENU",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0039",
          "sourceRange": {
            "byteStart": 20460,
            "byteEnd": 20488
          },
          "rawWordsHex": [
            "0x2000",
            "0x00ed",
            "0x0010",
            "0x03c6",
            "0x000a",
            "0x654d",
            "0x756e",
            "0x4620",
            "0x6769",
            "0x7468",
            "0x0000",
            "0x0024",
            "0x0001",
            "0x029f"
          ],
          "identifierReferenceCandidateNames": [
            "Picture1_Click"
          ],
          "literalTexts": [
            "Menu Fight"
          ],
          "matchedCommands": [
            "MENU"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0132",
          "sourceRange": {
            "byteStart": 22760,
            "byteEnd": 22788
          },
          "rawWordsHex": [
            "0x2000",
            "0x00ed",
            "0x0010",
            "0x0edc",
            "0x000a",
            "0x654d",
            "0x756e",
            "0x4620",
            "0x7269",
            "0x7473",
            "0x0000",
            "0x0024",
            "0x0001",
            "0x029f"
          ],
          "identifierReferenceCandidateNames": [
            "Picture1_Click"
          ],
          "literalTexts": [
            "Menu First"
          ],
          "matchedCommands": [
            "MENU"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0166",
          "sourceRange": {
            "byteStart": 23284,
            "byteEnd": 23302
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x000a",
            "0x1174",
            "0x0004",
            "0x454d",
            "0x554e",
            "0x0000",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "MENU"
          ],
          "matchedCommands": [
            "MENU"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1091",
          "sourceRange": {
            "lineStart": 1091,
            "lineEnd": 1091
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "MENU"
          ],
          "matchedCommands": [
            "MENU"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "MESSAGECLEAR",
      "basEmitterCount": 2,
      "eventScriptCommandCount": 0,
      "timerCandidateLineCount": 2,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [
        {
          "module": "MAIN.BAS",
          "procedure": "EndFight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.decoded-statement-0004",
          "statementText": "Message \"MessageClear\"",
          "sourceRange": {
            "lineStart": 51,
            "lineEnd": 51,
            "columnStart": 5,
            "columnEnd": 26
          },
          "literalPrefix": "MessageClear",
          "command": "MESSAGECLEAR",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAIN.BAS",
          "procedure": "EscapeFight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.decoded-statement-0004",
          "statementText": "Message \"MessageClear\"",
          "sourceRange": {
            "lineStart": 63,
            "lineEnd": 63,
            "columnStart": 5,
            "columnEnd": 26
          },
          "literalPrefix": "MessageClear",
          "command": "MESSAGECLEAR",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0177",
          "sourceRange": {
            "byteStart": 23426,
            "byteEnd": 23452
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x0012",
            "0x1242",
            "0x000c",
            "0x454d",
            "0x5353",
            "0x4741",
            "0x4345",
            "0x454c",
            "0x5241",
            "0x0000",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [
            "About"
          ],
          "literalTexts": [
            "MESSAGECLEAR"
          ],
          "matchedCommands": [
            "MESSAGECLEAR"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1102",
          "sourceRange": {
            "lineStart": 1102,
            "lineEnd": 1102
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "MESSAGECLEAR"
          ],
          "matchedCommands": [
            "MESSAGECLEAR"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "MONEY",
      "basEmitterCount": 0,
      "eventScriptCommandCount": 3,
      "timerCandidateLineCount": 2,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0179",
          "sourceRange": {
            "byteStart": 23460,
            "byteEnd": 23478
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x000a",
            "0x1270",
            "0x0005",
            "0x4f4d",
            "0x454e",
            "0x0059",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "MONEY"
          ],
          "matchedCommands": [
            "MONEY"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1104",
          "sourceRange": {
            "lineStart": 1104,
            "lineEnd": 1104
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "MONEY"
          ],
          "matchedCommands": [
            "MONEY"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [
        "CASTLE1.MPD@9,4",
        "CASTLE1.MPD@58,5",
        "CAVE1.MPD@14,29"
      ],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "MOVE",
      "basEmitterCount": 0,
      "eventScriptCommandCount": 91,
      "timerCandidateLineCount": 2,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0184",
          "sourceRange": {
            "byteStart": 23556,
            "byteEnd": 23574
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x000a",
            "0x12e4",
            "0x0004",
            "0x4f4d",
            "0x4556",
            "0x0000",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "MOVE"
          ],
          "matchedCommands": [
            "MOVE"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1109",
          "sourceRange": {
            "lineStart": 1109,
            "lineEnd": 1109
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "MOVE"
          ],
          "matchedCommands": [
            "MOVE"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [
        "MAP1.MPD@18,7",
        "MAP1.MPD@20,18",
        "MAP1.MPD@20,18",
        "MAP1.MPD@11,9",
        "MAP1.MPD@7,15",
        "MAP1.MPD@4,19",
        "MAP1.MPD@108,39",
        "MAP1.MPD@101,29"
      ],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "MP",
      "basEmitterCount": 5,
      "eventScriptCommandCount": 0,
      "timerCandidateLineCount": 2,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [
        {
          "module": "ITEM.BAS",
          "procedure": "UseItem",
          "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
          "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
          "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0022",
          "statementText": "Message \"MP \" + A2 + \" \" + CStr(ItemEffect(IN - 1))",
          "sourceRange": {
            "lineStart": 99,
            "lineEnd": 99,
            "columnStart": 9,
            "columnEnd": 59
          },
          "literalPrefix": "MP ",
          "command": "MP",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ITEM.BAS",
          "procedure": "UseItem",
          "procedureId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002",
          "procedureIrPath": "docs/vb2-ir/procedures/ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.json",
          "statementId": "ITEM.BAS-2a757177b8-3fc33fcd.UseItem.text-002.decoded-statement-0026",
          "statementText": "Message \"MP \" + A2 + \" \" + CStr(ItemEffect(IN - 1))",
          "sourceRange": {
            "lineStart": 103,
            "lineEnd": 103,
            "columnStart": 9,
            "columnEnd": 59
          },
          "literalPrefix": "MP ",
          "command": "MP",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAGIC.BAS",
          "procedure": "UseMagic",
          "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
          "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
          "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0014",
          "statementText": "Message \"MP \" + CStr(ManNO) + \" -\" + CStr(MagicMP(IN - 1))",
          "sourceRange": {
            "lineStart": 62,
            "lineEnd": 62,
            "columnStart": 5,
            "columnEnd": 62
          },
          "literalPrefix": "MP ",
          "command": "MP",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAGIC.BAS",
          "procedure": "UseMagic",
          "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
          "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
          "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0021",
          "statementText": "Message \"MP \" + A2 + \" \" + CStr(MagicEffect(IN - 1))",
          "sourceRange": {
            "lineStart": 69,
            "lineEnd": 69,
            "columnStart": 9,
            "columnEnd": 60
          },
          "literalPrefix": "MP ",
          "command": "MP",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAGIC.BAS",
          "procedure": "UseMagic",
          "procedureId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001",
          "procedureIrPath": "docs/vb2-ir/procedures/MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.json",
          "statementId": "MAGIC.BAS-df8c6e67e4-98a8aa39.UseMagic.001.decoded-statement-0025",
          "statementText": "Message \"MP \" + A2 + \" \" + CStr(MagicEffect(IN - 1))",
          "sourceRange": {
            "lineStart": 73,
            "lineEnd": 73,
            "columnStart": 9,
            "columnEnd": 60
          },
          "literalPrefix": "MP ",
          "command": "MP",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0193",
          "sourceRange": {
            "byteStart": 23848,
            "byteEnd": 23864
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x0008",
            "0x141a",
            "0x0002",
            "0x504d",
            "0x0000",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "MP"
          ],
          "matchedCommands": [
            "MP"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1118",
          "sourceRange": {
            "lineStart": 1118,
            "lineEnd": 1118
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "MP"
          ],
          "matchedCommands": [
            "MP"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "MPD",
      "basEmitterCount": 0,
      "eventScriptCommandCount": 47,
      "timerCandidateLineCount": 2,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0209",
          "sourceRange": {
            "byteStart": 24122,
            "byteEnd": 24138
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x0008",
            "0x1586",
            "0x0003",
            "0x504d",
            "0x0044",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "MPD"
          ],
          "matchedCommands": [
            "MPD"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1134",
          "sourceRange": {
            "lineStart": 1134,
            "lineEnd": 1134
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "MPD"
          ],
          "matchedCommands": [
            "MPD"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [
        "MAP1.MPD@11,9",
        "CASTLE1.MPD@58,5",
        "CASTLE1.MPD@56,5",
        "CASTLE1.MPD@102,11",
        "CASTLE1.MPD@0,-1",
        "CAVE1.MPD@10,4",
        "CAVE1.MPD@6,20",
        "CAVE1.MPD@14,29"
      ],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "PRINT",
      "basEmitterCount": 103,
      "eventScriptCommandCount": 569,
      "timerCandidateLineCount": 13,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0011",
          "statementText": "Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
          "sourceRange": {
            "lineStart": 55,
            "lineEnd": 55,
            "columnStart": 13,
            "columnEnd": 57
          },
          "literalPrefix": "Print ",
          "command": "PRINT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0013",
          "statementText": "Message \"Print \" + EnemyName(Enemy(ENO)) + \"の攻撃\"",
          "sourceRange": {
            "lineStart": 57,
            "lineEnd": 57,
            "columnStart": 13,
            "columnEnd": 60
          },
          "literalPrefix": "Print ",
          "command": "PRINT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0034",
          "statementText": "Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
          "sourceRange": {
            "lineStart": 78,
            "lineEnd": 78,
            "columnStart": 13,
            "columnEnd": 57
          },
          "literalPrefix": "Print ",
          "command": "PRINT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0036",
          "statementText": "Message \"Print \" + EnemyName(Enemy(ENO)) + \"の攻撃\"",
          "sourceRange": {
            "lineStart": 80,
            "lineEnd": 80,
            "columnStart": 13,
            "columnEnd": 60
          },
          "literalPrefix": "Print ",
          "command": "PRINT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0052",
          "statementText": "If EnemyCText(Enemy(ENO), Tp) <> \"\" Then Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
          "sourceRange": {
            "lineStart": 96,
            "lineEnd": 96,
            "columnStart": 9,
            "columnEnd": 94
          },
          "literalPrefix": "Print ",
          "command": "PRINT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0060",
          "statementText": "Message \"Print \" + EnemyName(Enemy(Target)) + \"のＨＰは、\" + CStr(Vl) + \"回復した\"",
          "sourceRange": {
            "lineStart": 103,
            "lineEnd": 103,
            "columnStart": 9,
            "columnEnd": 81
          },
          "literalPrefix": "Print ",
          "command": "PRINT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0064",
          "statementText": "If EnemyCText(Enemy(ENO), Tp) <> \"\" Then Message \"Print \" + EnemyCText(Enemy(ENO), Tp)",
          "sourceRange": {
            "lineStart": 107,
            "lineEnd": 107,
            "columnStart": 9,
            "columnEnd": 94
          },
          "literalPrefix": "Print ",
          "command": "PRINT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0072",
          "statementText": "Message \"Print 敵全員のＨＰは、\" + CStr(Vl) + \"回復した\"",
          "sourceRange": {
            "lineStart": 114,
            "lineEnd": 114,
            "columnStart": 9,
            "columnEnd": 52
          },
          "literalPrefix": "Print 敵全員のＨＰは、",
          "command": "PRINT",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0036",
          "sourceRange": {
            "byteStart": 20378,
            "byteEnd": 20438
          },
          "rawWordsHex": [
            "0x2000",
            "0x00ed",
            "0x000c",
            "0x0366",
            "0x0006",
            "0x7250",
            "0x6e69",
            "0x2074",
            "0x0000",
            "0x000b",
            "0x02f7",
            "0x000e",
            "0x0001",
            "0x02b3",
            "0x00a3",
            "0x00ed",
            "0x0012",
            "0x0382",
            "0x000c",
            "0xcd82",
            "0xc782",
            "0xa482",
            "0xb782",
            "0xe982",
            "0x4881",
            "0x0000",
            "0x00a3",
            "0x0024",
            "0x0001",
            "0x029f"
          ],
          "identifierReferenceCandidateNames": [
            "About",
            "M_Check_Click",
            "Message",
            "Walking",
            "Picture1_Click"
          ],
          "literalTexts": [
            "Print ",
            "はどうする？"
          ],
          "matchedCommands": [
            "PRINT"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0049",
          "sourceRange": {
            "byteStart": 20714,
            "byteEnd": 20796
          },
          "rawWordsHex": [
            "0x3000",
            "0x00ed",
            "0x000c",
            "0x0508",
            "0x0006",
            "0x7250",
            "0x6e69",
            "0x2074",
            "0x0000",
            "0x000b",
            "0x02f7",
            "0x000e",
            "0x0001",
            "0x02b3",
            "0x00a3",
            "0x00ed",
            "0x000a",
            "0x0524",
            "0x0004",
            "0xcd82",
            "0x4181",
            "0x0000",
            "0x00a3",
            "0x000b",
            "0x090b",
            "0x1cab",
            "0x00a3",
            "0x00ed",
            "0x0010",
            "0x053c",
            "0x000a",
            "0xcc82"
          ],
          "identifierReferenceCandidateNames": [
            "About",
            "M_Check_Click",
            "Message",
            "BGMF",
            "Picture1_Click"
          ],
          "literalTexts": [
            "Print ",
            "は、",
            "のダメージ"
          ],
          "matchedCommands": [
            "PRINT"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0052",
          "sourceRange": {
            "byteStart": 20836,
            "byteEnd": 20902
          },
          "rawWordsHex": [
            "0x3000",
            "0x00ed",
            "0x000c",
            "0x05a4",
            "0x0006",
            "0x7250",
            "0x6e69",
            "0x2074",
            "0x0000",
            "0x000b",
            "0x02f7",
            "0x000e",
            "0x0001",
            "0x02b3",
            "0x00a3",
            "0x00ed",
            "0x0018",
            "0x05c0",
            "0x0012",
            "0xcd82",
            "0x4181",
            "0x6691",
            "0x8191",
            "0xad82",
            "0xa982",
            "0xed82",
            "0xb582",
            "0xbd82",
            "0x0000",
            "0x00a3",
            "0x0024",
            "0x0001"
          ],
          "identifierReferenceCandidateNames": [
            "About",
            "M_Check_Click",
            "Message",
            "Picture1_Click"
          ],
          "literalTexts": [
            "Print ",
            "は、素早くかわした"
          ],
          "matchedCommands": [
            "PRINT"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0055",
          "sourceRange": {
            "byteStart": 20936,
            "byteEnd": 21000
          },
          "rawWordsHex": [
            "0x3000",
            "0x00ed",
            "0x000c",
            "0x0620",
            "0x0006",
            "0x7250",
            "0x6e69",
            "0x2074",
            "0x0000",
            "0x000b",
            "0x02f7",
            "0x000e",
            "0x0001",
            "0x02b3",
            "0x00a3",
            "0x00ed",
            "0x0016",
            "0x063c",
            "0x0010",
            "0xcd82",
            "0x4181",
            "0x558d",
            "0x828c",
            "0xf082",
            "0x6896",
            "0xa282",
            "0xbe82",
            "0x0000",
            "0x00a3",
            "0x0024",
            "0x0001",
            "0x029f"
          ],
          "identifierReferenceCandidateNames": [
            "About",
            "M_Check_Click",
            "Message",
            "Picture1_Click"
          ],
          "literalTexts": [
            "Print ",
            "は、攻撃を防いだ"
          ],
          "matchedCommands": [
            "PRINT"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0100",
          "sourceRange": {
            "byteStart": 21910,
            "byteEnd": 21998
          },
          "rawWordsHex": [
            "0x3000",
            "0x00ed",
            "0x000c",
            "0x0acc",
            "0x0006",
            "0x7250",
            "0x6e69",
            "0x2074",
            "0x0000",
            "0x000b",
            "0x02f7",
            "0x000e",
            "0x0001",
            "0x0e33",
            "0x000e",
            "0x0001",
            "0x0f26",
            "0x00a3",
            "0x00ed",
            "0x000a",
            "0x0aee",
            "0x0004",
            "0xcd82",
            "0x4181",
            "0x0000",
            "0x00a3",
            "0x000b",
            "0x090b",
            "0x1cab",
            "0x00a3",
            "0x00ed",
            "0x0010"
          ],
          "identifierReferenceCandidateNames": [
            "About",
            "M_Check_Click",
            "SeeWndState",
            "Menu_ET",
            "BGMF",
            "Picture1_Click"
          ],
          "literalTexts": [
            "Print ",
            "は、",
            "のダメージ"
          ],
          "matchedCommands": [
            "PRINT"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0102",
          "sourceRange": {
            "byteStart": 22018,
            "byteEnd": 22086
          },
          "rawWordsHex": [
            "0x4000",
            "0x00ed",
            "0x000c",
            "0x0b42",
            "0x0006",
            "0x7250",
            "0x6e69",
            "0x2074",
            "0x0000",
            "0x000b",
            "0x02f7",
            "0x000e",
            "0x0001",
            "0x0e33",
            "0x000e",
            "0x0001",
            "0x0f26",
            "0x00a3",
            "0x00ed",
            "0x0014",
            "0x0b64",
            "0x000e",
            "0xf082",
            "0x4181",
            "0xe282",
            "0xc182",
            "0xc282",
            "0xaf82",
            "0xbd82",
            "0x0000",
            "0x00a3",
            "0x0024"
          ],
          "identifierReferenceCandidateNames": [
            "About",
            "M_Check_Click",
            "SeeWndState",
            "Menu_ET",
            "Picture1_Click"
          ],
          "literalTexts": [
            "Print ",
            "を、やっつけた"
          ],
          "matchedCommands": [
            "PRINT"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        }
      ],
      "sampleEventSources": [
        "defaultSave.openingScript",
        "defaultSave.openingScript",
        "MAP1.MPD@13,6",
        "MAP1.MPD@13,6",
        "MAP1.MPD@23,7",
        "MAP1.MPD@23,7",
        "MAP1.MPD@18,7",
        "MAP1.MPD@18,7"
      ],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "SHOP",
      "basEmitterCount": 0,
      "eventScriptCommandCount": 7,
      "timerCandidateLineCount": 2,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0259",
          "sourceRange": {
            "byteStart": 25198,
            "byteEnd": 25216
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x000a",
            "0x1a68",
            "0x0004",
            "0x4853",
            "0x504f",
            "0x0000",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "SHOP"
          ],
          "matchedCommands": [
            "SHOP"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1185",
          "sourceRange": {
            "lineStart": 1185,
            "lineEnd": 1185
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "SHOP"
          ],
          "matchedCommands": [
            "SHOP"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [
        "TOWER1.MPD@35,8",
        "TOWN1.MPD@29,13",
        "TOWN1.MPD@72,20",
        "TOWN1.MPD@75,20",
        "TOWN1.MPD@112,53",
        "TOWN1.MPD@99,40",
        "TOWN1.MPD@25,41"
      ],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "SHOWENEMY",
      "basEmitterCount": 1,
      "eventScriptCommandCount": 0,
      "timerCandidateLineCount": 2,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [
        {
          "module": "MAIN.BAS",
          "procedure": "Fight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.decoded-statement-0053",
          "statementText": "Message \"ShowEnemy\"",
          "sourceRange": {
            "lineStart": 124,
            "lineEnd": 124,
            "columnStart": 5,
            "columnEnd": 23
          },
          "literalPrefix": "ShowEnemy",
          "command": "SHOWENEMY",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0234",
          "sourceRange": {
            "byteStart": 24580,
            "byteEnd": 24602
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x000e",
            "0x178e",
            "0x0009",
            "0x4853",
            "0x574f",
            "0x4e45",
            "0x4d45",
            "0x0059",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "SHOWENEMY"
          ],
          "matchedCommands": [
            "SHOWENEMY"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1160",
          "sourceRange": {
            "lineStart": 1160,
            "lineEnd": 1160
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "SHOWENEMY"
          ],
          "matchedCommands": [
            "SHOWENEMY"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "SILENTCHAR",
      "basEmitterCount": 0,
      "eventScriptCommandCount": 7,
      "timerCandidateLineCount": 2,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0238",
          "sourceRange": {
            "byteStart": 24662,
            "byteEnd": 24686
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x0010",
            "0x17f4",
            "0x000a",
            "0x4953",
            "0x454c",
            "0x544e",
            "0x4843",
            "0x5241",
            "0x0000",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "SILENTCHAR"
          ],
          "matchedCommands": [
            "SILENTCHAR"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1164",
          "sourceRange": {
            "lineStart": 1164,
            "lineEnd": 1164
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "SILENTCHAR"
          ],
          "matchedCommands": [
            "SILENTCHAR"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [
        "MAP1.MPD@96,57",
        "MAP1.MPD@20,20",
        "TOWER1.MPD@21,31",
        "TOWER1.MPD@23,31",
        "TOWN1.MPD@87,49",
        "TOWN1.MPD@33,43",
        "TOWN1.MPD@15,35"
      ],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "SILENTMOVE",
      "basEmitterCount": 0,
      "eventScriptCommandCount": 0,
      "timerCandidateLineCount": 1,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1166",
          "sourceRange": {
            "lineStart": 1166,
            "lineEnd": 1166
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "SILENTMOVE"
          ],
          "matchedCommands": [
            "SILENTMOVE"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "SILENTWAY",
      "basEmitterCount": 0,
      "eventScriptCommandCount": 0,
      "timerCandidateLineCount": 1,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1173",
          "sourceRange": {
            "lineStart": 1173,
            "lineEnd": 1173
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "SILENTWAY"
          ],
          "matchedCommands": [
            "SILENTWAY"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "SOUND",
      "basEmitterCount": 20,
      "eventScriptCommandCount": 0,
      "timerCandidateLineCount": 7,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0032",
          "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
          "sourceRange": {
            "lineStart": 76,
            "lineEnd": 76,
            "columnStart": 9,
            "columnEnd": 89
          },
          "literalPrefix": "Sound ",
          "command": "SOUND",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0051",
          "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
          "sourceRange": {
            "lineStart": 95,
            "lineEnd": 95,
            "columnStart": 9,
            "columnEnd": 89
          },
          "literalPrefix": "Sound ",
          "command": "SOUND",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0063",
          "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
          "sourceRange": {
            "lineStart": 106,
            "lineEnd": 106,
            "columnStart": 9,
            "columnEnd": 89
          },
          "literalPrefix": "Sound ",
          "command": "SOUND",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0075",
          "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
          "sourceRange": {
            "lineStart": 117,
            "lineEnd": 117,
            "columnStart": 9,
            "columnEnd": 89
          },
          "literalPrefix": "Sound ",
          "command": "SOUND",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0096",
          "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
          "sourceRange": {
            "lineStart": 137,
            "lineEnd": 137,
            "columnStart": 9,
            "columnEnd": 89
          },
          "literalPrefix": "Sound ",
          "command": "SOUND",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0117",
          "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
          "sourceRange": {
            "lineStart": 157,
            "lineEnd": 157,
            "columnStart": 9,
            "columnEnd": 89
          },
          "literalPrefix": "Sound ",
          "command": "SOUND",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0132",
          "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
          "sourceRange": {
            "lineStart": 171,
            "lineEnd": 171,
            "columnStart": 9,
            "columnEnd": 89
          },
          "literalPrefix": "Sound ",
          "command": "SOUND",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0151",
          "statementText": "If EnemyCRepWav(Enemy(ENO), Tp) Then Message \"Sound \" + EnemyWaveFile(Enemy(ENO))",
          "sourceRange": {
            "lineStart": 189,
            "lineEnd": 189,
            "columnStart": 9,
            "columnEnd": 89
          },
          "literalPrefix": "Sound ",
          "command": "SOUND",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0047",
          "sourceRange": {
            "byteStart": 20628,
            "byteEnd": 20662
          },
          "rawWordsHex": [
            "0x3000",
            "0x00ed",
            "0x000c",
            "0x049e",
            "0x0006",
            "0x6f53",
            "0x6e75",
            "0x2064",
            "0x0000",
            "0x0ce4",
            "0x1c0e",
            "0x0001",
            "0x0911",
            "0x00a3",
            "0x0024",
            "0x0001",
            "0x029f"
          ],
          "identifierReferenceCandidateNames": [
            "About",
            "EndSelect",
            "Picture1_Click"
          ],
          "literalTexts": [
            "Sound "
          ],
          "matchedCommands": [
            "SOUND"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0051",
          "sourceRange": {
            "byteStart": 20808,
            "byteEnd": 20836
          },
          "rawWordsHex": [
            "0x3000",
            "0x00ed",
            "0x0010",
            "0x057e",
            "0x000b",
            "0x6f53",
            "0x6e75",
            "0x2064",
            "0x6f44",
            "0x6764",
            "0x0065",
            "0x0024",
            "0x0001",
            "0x029f"
          ],
          "identifierReferenceCandidateNames": [
            "Picture1_Click"
          ],
          "literalTexts": [
            "Sound Dodge"
          ],
          "matchedCommands": [
            "SOUND"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0054",
          "sourceRange": {
            "byteStart": 20906,
            "byteEnd": 20936
          },
          "rawWordsHex": [
            "0x3000",
            "0x00ed",
            "0x0012",
            "0x05f8",
            "0x000d",
            "0x6f53",
            "0x6e75",
            "0x2064",
            "0x6544",
            "0x6566",
            "0x736e",
            "0x0065",
            "0x0024",
            "0x0001",
            "0x029f"
          ],
          "identifierReferenceCandidateNames": [
            "Picture1_Click"
          ],
          "literalTexts": [
            "Sound Defense"
          ],
          "matchedCommands": [
            "SOUND"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0110",
          "sourceRange": {
            "byteStart": 22222,
            "byteEnd": 22250
          },
          "rawWordsHex": [
            "0x3000",
            "0x00ed",
            "0x0010",
            "0x0c30",
            "0x000b",
            "0x6f53",
            "0x6e75",
            "0x2064",
            "0x6f44",
            "0x6764",
            "0x0065",
            "0x0024",
            "0x0001",
            "0x029f"
          ],
          "identifierReferenceCandidateNames": [
            "Picture1_Click"
          ],
          "literalTexts": [
            "Sound Dodge"
          ],
          "matchedCommands": [
            "SOUND"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0113",
          "sourceRange": {
            "byteStart": 22334,
            "byteEnd": 22364
          },
          "rawWordsHex": [
            "0x3000",
            "0x00ed",
            "0x0012",
            "0x0cb8",
            "0x000d",
            "0x6f53",
            "0x6e75",
            "0x2064",
            "0x6544",
            "0x6566",
            "0x736e",
            "0x0065",
            "0x0024",
            "0x0001",
            "0x029f"
          ],
          "identifierReferenceCandidateNames": [
            "Picture1_Click"
          ],
          "literalTexts": [
            "Sound Defense"
          ],
          "matchedCommands": [
            "SOUND"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0249",
          "sourceRange": {
            "byteStart": 25022,
            "byteEnd": 25040
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x000a",
            "0x198a",
            "0x0005",
            "0x4f53",
            "0x4e55",
            "0x0044",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "SOUND"
          ],
          "matchedCommands": [
            "SOUND"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        }
      ],
      "sampleEventSources": [],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "STARTENEMYDAMAGE",
      "basEmitterCount": 0,
      "eventScriptCommandCount": 0,
      "timerCandidateLineCount": 1,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1177",
          "sourceRange": {
            "lineStart": 1177,
            "lineEnd": 1177
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "STARTENEMYDAMAGE"
          ],
          "matchedCommands": [
            "STARTENEMYDAMAGE"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "STARTFIGHT",
      "basEmitterCount": 1,
      "eventScriptCommandCount": 0,
      "timerCandidateLineCount": 2,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [
        {
          "module": "MAIN.BAS",
          "procedure": "Fight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.decoded-statement-0064",
          "statementText": "Message \"StartFight\"",
          "sourceRange": {
            "lineStart": 135,
            "lineEnd": 135,
            "columnStart": 5,
            "columnEnd": 24
          },
          "literalPrefix": "StartFight",
          "command": "STARTFIGHT",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0254",
          "sourceRange": {
            "byteStart": 25126,
            "byteEnd": 25150
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x0010",
            "0x1a0e",
            "0x000a",
            "0x5453",
            "0x5241",
            "0x4654",
            "0x4749",
            "0x5448",
            "0x0000",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "STARTFIGHT"
          ],
          "matchedCommands": [
            "STARTFIGHT"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1180",
          "sourceRange": {
            "lineStart": 1180,
            "lineEnd": 1180
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "STARTFIGHT"
          ],
          "matchedCommands": [
            "STARTFIGHT"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "STOPBGM",
      "basEmitterCount": 1,
      "eventScriptCommandCount": 0,
      "timerCandidateLineCount": 2,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [
        {
          "module": "MAIN.BAS",
          "procedure": "GameOver",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.decoded-statement-0001",
          "statementText": "Message \"StopBGM\"",
          "sourceRange": {
            "lineStart": 143,
            "lineEnd": 143,
            "columnStart": 5,
            "columnEnd": 21
          },
          "literalPrefix": "StopBGM",
          "command": "STOPBGM",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0268",
          "sourceRange": {
            "byteStart": 25336,
            "byteEnd": 25356
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x000c",
            "0x1b08",
            "0x0007",
            "0x5453",
            "0x504f",
            "0x4742",
            "0x004d",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [
            "About"
          ],
          "literalTexts": [
            "STOPBGM"
          ],
          "matchedCommands": [
            "STOPBGM"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1194",
          "sourceRange": {
            "lineStart": 1194,
            "lineEnd": 1194
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "STOPBGM"
          ],
          "matchedCommands": [
            "STOPBGM"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "TURN",
      "basEmitterCount": 0,
      "eventScriptCommandCount": 0,
      "timerCandidateLineCount": 1,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1196",
          "sourceRange": {
            "lineStart": 1196,
            "lineEnd": 1196
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "TURN"
          ],
          "matchedCommands": [
            "TURN"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "VICTORY",
      "basEmitterCount": 1,
      "eventScriptCommandCount": 0,
      "timerCandidateLineCount": 3,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [
        {
          "module": "MAIN.BAS",
          "procedure": "StartTurn",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.StartTurn.007.decoded-statement-0018",
          "statementText": "Message \"Victory\"",
          "sourceRange": {
            "lineStart": 201,
            "lineEnd": 201,
            "columnStart": 9,
            "columnEnd": 25
          },
          "literalPrefix": "Victory",
          "command": "VICTORY",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0273",
          "sourceRange": {
            "byteStart": 25398,
            "byteEnd": 25418
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x000c",
            "0x1b5e",
            "0x0007",
            "0x4956",
            "0x5443",
            "0x524f",
            "0x0059",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [
            "About"
          ],
          "literalTexts": [
            "VICTORY"
          ],
          "matchedCommands": [
            "VICTORY"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0275",
          "sourceRange": {
            "byteStart": 25426,
            "byteEnd": 25450
          },
          "rawWordsHex": [
            "0x2000",
            "0x00ed",
            "0x000c",
            "0x1b82",
            "0x0007",
            "0x6956",
            "0x7463",
            "0x726f",
            "0x0079",
            "0x0024",
            "0x0001",
            "0x0f68"
          ],
          "identifierReferenceCandidateNames": [
            "About",
            "BEnemyDefense"
          ],
          "literalTexts": [
            "Victory"
          ],
          "matchedCommands": [
            "VICTORY"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1199",
          "sourceRange": {
            "lineStart": 1199,
            "lineEnd": 1199
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "VICTORY"
          ],
          "matchedCommands": [
            "VICTORY"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "WAIT",
      "basEmitterCount": 34,
      "eventScriptCommandCount": 28,
      "timerCandidateLineCount": 4,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0038",
          "statementText": "Message \"Wait 100\"",
          "sourceRange": {
            "lineStart": 82,
            "lineEnd": 82,
            "columnStart": 9,
            "columnEnd": 26
          },
          "literalPrefix": "Wait 100",
          "command": "WAIT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0053",
          "statementText": "Message \"Wait 100\"",
          "sourceRange": {
            "lineStart": 96,
            "lineEnd": 96,
            "columnStart": 97,
            "columnEnd": 114
          },
          "literalPrefix": "Wait 100",
          "command": "WAIT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0061",
          "statementText": "Message \"Wait 100\"",
          "sourceRange": {
            "lineStart": 104,
            "lineEnd": 104,
            "columnStart": 9,
            "columnEnd": 26
          },
          "literalPrefix": "Wait 100",
          "command": "WAIT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0065",
          "statementText": "Message \"Wait 100\"",
          "sourceRange": {
            "lineStart": 107,
            "lineEnd": 107,
            "columnStart": 97,
            "columnEnd": 114
          },
          "literalPrefix": "Wait 100",
          "command": "WAIT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0073",
          "statementText": "Message \"Wait 100\"",
          "sourceRange": {
            "lineStart": 115,
            "lineEnd": 115,
            "columnStart": 9,
            "columnEnd": 26
          },
          "literalPrefix": "Wait 100",
          "command": "WAIT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0077",
          "statementText": "Message \"Wait 100\"",
          "sourceRange": {
            "lineStart": 118,
            "lineEnd": 118,
            "columnStart": 97,
            "columnEnd": 114
          },
          "literalPrefix": "Wait 100",
          "command": "WAIT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0094",
          "statementText": "Message \"Wait 100\"",
          "sourceRange": {
            "lineStart": 135,
            "lineEnd": 135,
            "columnStart": 9,
            "columnEnd": 26
          },
          "literalPrefix": "Wait 100",
          "command": "WAIT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "ENEMY.BAS",
          "procedure": "EnemySub",
          "procedureId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001",
          "procedureIrPath": "docs/vb2-ir/procedures/ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.json",
          "statementId": "ENEMY.BAS-80d964dde6-f9fd3ce2.EnemySub.001.decoded-statement-0098",
          "statementText": "Message \"Wait 100\"",
          "sourceRange": {
            "lineStart": 138,
            "lineEnd": 138,
            "columnStart": 97,
            "columnEnd": 114
          },
          "literalPrefix": "Wait 100",
          "command": "WAIT",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0057",
          "sourceRange": {
            "byteStart": 21004,
            "byteEnd": 21030
          },
          "rawWordsHex": [
            "0x2000",
            "0x00ed",
            "0x000e",
            "0x0672",
            "0x0008",
            "0x6157",
            "0x7469",
            "0x3120",
            "0x3030",
            "0x0000",
            "0x0024",
            "0x0001",
            "0x029f"
          ],
          "identifierReferenceCandidateNames": [
            "EvenyY",
            "Picture1_Click"
          ],
          "literalTexts": [
            "Wait 100"
          ],
          "matchedCommands": [
            "WAIT"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0116",
          "sourceRange": {
            "byteStart": 22446,
            "byteEnd": 22472
          },
          "rawWordsHex": [
            "0x2000",
            "0x00ed",
            "0x000e",
            "0x0d40",
            "0x0008",
            "0x6157",
            "0x7469",
            "0x3120",
            "0x3030",
            "0x0000",
            "0x0024",
            "0x0001",
            "0x029f"
          ],
          "identifierReferenceCandidateNames": [
            "Picture1_Click"
          ],
          "literalTexts": [
            "Wait 100"
          ],
          "matchedCommands": [
            "WAIT"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0293",
          "sourceRange": {
            "byteStart": 27004,
            "byteEnd": 27022
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x000a",
            "0x22f6",
            "0x0004",
            "0x4157",
            "0x5449",
            "0x0000",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "WAIT"
          ],
          "matchedCommands": [
            "WAIT"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1253",
          "sourceRange": {
            "lineStart": 1253,
            "lineEnd": 1253
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "WAIT"
          ],
          "matchedCommands": [
            "WAIT"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [
        "TOWER1.MPD@9,94",
        "TOWN1.MPD@107,62",
        "TOWN1.MPD@107,62",
        "TOWN1.MPD@107,62",
        "TOWN1.MPD@107,62",
        "TOWN1.MPD@107,62",
        "TOWN1.MPD@107,62",
        "TOWN1.MPD@107,62"
      ],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "WALK",
      "basEmitterCount": 0,
      "eventScriptCommandCount": 17,
      "timerCandidateLineCount": 3,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0174",
          "sourceRange": {
            "byteStart": 23396,
            "byteEnd": 23414
          },
          "rawWordsHex": [
            "0x2000",
            "0x00ed",
            "0x000a",
            "0x1214",
            "0x0004",
            "0x4157",
            "0x4b4c",
            "0x0000",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "WALK"
          ],
          "matchedCommands": [
            "WALK"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0295",
          "sourceRange": {
            "byteStart": 27042,
            "byteEnd": 27060
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x000a",
            "0x232a",
            "0x0004",
            "0x4157",
            "0x4b4c",
            "0x0000",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "WALK"
          ],
          "matchedCommands": [
            "WALK"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1255",
          "sourceRange": {
            "lineStart": 1255,
            "lineEnd": 1255
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "WALK"
          ],
          "matchedCommands": [
            "WALK"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [
        "MAP1.MPD@109,63",
        "MAP1.MPD@109,63",
        "MAP1.MPD@123,50",
        "MAP1.MPD@123,50",
        "MAP1.MPD@117,41",
        "MAP1.MPD@117,41",
        "MAP1.MPD@127,22",
        "MAP1.MPD@127,22"
      ],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "WALKSTART",
      "basEmitterCount": 0,
      "eventScriptCommandCount": 0,
      "timerCandidateLineCount": 1,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1260",
          "sourceRange": {
            "lineStart": 1260,
            "lineEnd": 1260
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "WALKSTART"
          ],
          "matchedCommands": [
            "WALKSTART"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "WAY",
      "basEmitterCount": 0,
      "eventScriptCommandCount": 0,
      "timerCandidateLineCount": 1,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1262",
          "sourceRange": {
            "lineStart": 1262,
            "lineEnd": 1262
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "WAY"
          ],
          "matchedCommands": [
            "WAY"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "WIPEIN",
      "basEmitterCount": 4,
      "eventScriptCommandCount": 0,
      "timerCandidateLineCount": 2,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [
        {
          "module": "MAIN.BAS",
          "procedure": "EndFight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.EndFight.001.decoded-statement-0006",
          "statementText": "Message \"WipeIn\"",
          "sourceRange": {
            "lineStart": 53,
            "lineEnd": 53,
            "columnStart": 5,
            "columnEnd": 20
          },
          "literalPrefix": "WipeIn",
          "command": "WIPEIN",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAIN.BAS",
          "procedure": "EscapeFight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.EscapeFight.002.decoded-statement-0006",
          "statementText": "Message \"WipeIn\"",
          "sourceRange": {
            "lineStart": 65,
            "lineEnd": 65,
            "columnStart": 5,
            "columnEnd": 20
          },
          "literalPrefix": "WipeIn",
          "command": "WIPEIN",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAIN.BAS",
          "procedure": "NewGame",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.NewGame.005",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.NewGame.005.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.NewGame.005.decoded-statement-0012",
          "statementText": "Message \"WipeIn\"",
          "sourceRange": {
            "lineStart": 171,
            "lineEnd": 171,
            "columnStart": 5,
            "columnEnd": 20
          },
          "literalPrefix": "WipeIn",
          "command": "WIPEIN",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "SUB.BAS",
          "procedure": "MsgSub",
          "procedureId": "SUB.BAS-8ff879e9dc-302a874f.MsgSub.014",
          "procedureIrPath": "docs/vb2-ir/procedures/SUB.BAS-8ff879e9dc-302a874f.MsgSub.014.json",
          "statementId": "SUB.BAS-8ff879e9dc-302a874f.MsgSub.014.decoded-statement-0038",
          "statementText": "Message \"WIPEIN\"",
          "sourceRange": {
            "lineStart": 204,
            "lineEnd": 204,
            "columnStart": 9,
            "columnEnd": 24
          },
          "literalPrefix": "WIPEIN",
          "command": "WIPEIN",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0306",
          "sourceRange": {
            "byteStart": 27224,
            "byteEnd": 27244
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x000c",
            "0x2418",
            "0x0006",
            "0x4957",
            "0x4550",
            "0x4e49",
            "0x0000",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [
            "About"
          ],
          "literalTexts": [
            "WIPEIN"
          ],
          "matchedCommands": [
            "WIPEIN"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1266",
          "sourceRange": {
            "lineStart": 1266,
            "lineEnd": 1266
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "WIPEIN"
          ],
          "matchedCommands": [
            "WIPEIN"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    },
    {
      "command": "WIPEOUT",
      "basEmitterCount": 4,
      "eventScriptCommandCount": 1,
      "timerCandidateLineCount": 3,
      "controlFlowHandledByMsgSub": false,
      "coverageStatus": "anchored_to_timer_candidate",
      "decodedEffect": null,
      "sampleBasEmitters": [
        {
          "module": "MAIN.BAS",
          "procedure": "Fight",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.Fight.003.decoded-statement-0017",
          "statementText": "Message \"WipeOut\"",
          "sourceRange": {
            "lineStart": 88,
            "lineEnd": 88,
            "columnStart": 5,
            "columnEnd": 21
          },
          "literalPrefix": "WipeOut",
          "command": "WIPEOUT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAIN.BAS",
          "procedure": "GameOver",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.GameOver.004.decoded-statement-0009",
          "statementText": "Message \"WipeOut\"",
          "sourceRange": {
            "lineStart": 151,
            "lineEnd": 151,
            "columnStart": 9,
            "columnEnd": 25
          },
          "literalPrefix": "WipeOut",
          "command": "WIPEOUT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "MAIN.BAS",
          "procedure": "NewGame",
          "procedureId": "MAIN.BAS-b3b51c6170-6c9943e1.NewGame.005",
          "procedureIrPath": "docs/vb2-ir/procedures/MAIN.BAS-b3b51c6170-6c9943e1.NewGame.005.json",
          "statementId": "MAIN.BAS-b3b51c6170-6c9943e1.NewGame.005.decoded-statement-0002",
          "statementText": "If MainState = 0 Then Message \"WipeOut\"",
          "sourceRange": {
            "lineStart": 161,
            "lineEnd": 161,
            "columnStart": 5,
            "columnEnd": 43
          },
          "literalPrefix": "WipeOut",
          "command": "WIPEOUT",
          "evidence": "decoded_bas_text_source_message_call"
        },
        {
          "module": "SUB.BAS",
          "procedure": "MsgSub",
          "procedureId": "SUB.BAS-8ff879e9dc-302a874f.MsgSub.014",
          "procedureIrPath": "docs/vb2-ir/procedures/SUB.BAS-8ff879e9dc-302a874f.MsgSub.014.json",
          "statementId": "SUB.BAS-8ff879e9dc-302a874f.MsgSub.014.decoded-statement-0036",
          "statementText": "Message \"WIPEOUT\"",
          "sourceRange": {
            "lineStart": 202,
            "lineEnd": 202,
            "columnStart": 9,
            "columnEnd": 25
          },
          "literalPrefix": "WIPEOUT",
          "command": "WIPEOUT",
          "evidence": "decoded_bas_text_source_message_call"
        }
      ],
      "sampleTimerCandidates": [
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0131",
          "sourceRange": {
            "byteStart": 22736,
            "byteEnd": 22760
          },
          "rawWordsHex": [
            "0x2000",
            "0x00ed",
            "0x000c",
            "0x0eba",
            "0x0007",
            "0x6957",
            "0x6570",
            "0x754f",
            "0x0074",
            "0x0024",
            "0x0001",
            "0x029f"
          ],
          "identifierReferenceCandidateNames": [
            "About",
            "Picture1_Click"
          ],
          "literalTexts": [
            "WipeOut"
          ],
          "matchedCommands": [
            "WIPEOUT"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "MAIN.FRM-85f02a1041-3e8145e1.TimerMessage_Timer.037.source-line-candidate-0308",
          "sourceRange": {
            "byteStart": 27254,
            "byteEnd": 27274
          },
          "rawWordsHex": [
            "0x1000",
            "0x00ed",
            "0x000c",
            "0x2446",
            "0x0007",
            "0x4957",
            "0x4550",
            "0x554f",
            "0x0054",
            "0x0026"
          ],
          "identifierReferenceCandidateNames": [
            "About"
          ],
          "literalTexts": [
            "WIPEOUT"
          ],
          "matchedCommands": [
            "WIPEOUT"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This is a MAIN.FRM source-line/string-literal candidate. It anchors the command vocabulary, but it is not counted as decoded command-effect behavior."
        },
        {
          "sourceLineCandidateId": "text_source/main.frm:TimerMessage_Timer:1268",
          "sourceRange": {
            "lineStart": 1268,
            "lineEnd": 1268
          },
          "rawWordsHex": [],
          "identifierReferenceCandidateNames": [],
          "literalTexts": [
            "WIPEOUT"
          ],
          "matchedCommands": [
            "WIPEOUT"
          ],
          "semanticStatus": "frm_source_line_candidate_not_decoded_effect",
          "evidenceBoundary": "This restored text_source/main.frm TimerMessage_Timer Case line anchors a source command branch. PRINT internals remain excluded from semantic proof when the restored PRINT text is suspect, but the branch vocabulary is source-backed."
        }
      ],
      "sampleEventSources": [
        "TOWN1.MPD@107,62"
      ],
      "unknowns": [
        {
          "kind": "queuedCommandEffectPendingTimerMessageSemantics",
          "reason": "The command is anchored to BAS/event emitters and TimerMessage_Timer candidates, but the concrete effect branch is not decoded or traced yet."
        }
      ]
    }
  ],
  "currentWebMessageCommandFindings": {
    "runtimeSource": "web/src/main.ts",
    "messageRuntimeSource": "web/src/runtime/originalMessageCommandRuntime.ts",
    "eventPolicySource": "web/src/runtime/events.ts",
    "windowPolicySource": "web/src/render/windows.ts",
    "messageRuntime": {
      "helperExists": true,
      "importsGeneratedManifest": true,
      "recordsRuntimeConsumption": true,
      "consumesDecodedMessageCommands": true,
      "consumesCommandVocabulary": true,
      "recordsFrmScope": true,
      "recordsRuntimeEffectScope": true
    },
    "mainConsumesMessageRuntime": {
      "enabledUsesRuntimeConsumption": true,
      "usesCommandNameHelper": true,
      "usesDispatchHelper": true,
      "usesSourceBackedEffectHelper": true,
      "changeBgmEffectPresent": true,
      "stopBgmEffectPresent": true,
      "soundEffectPresent": true,
      "messageClearEffectPresent": true
    },
    "eventPolicy": {
      "enabledStatus": true,
      "messageQueueEffectsDecoded": true,
      "enabled": true
    },
    "windowPolicy": {
      "messageCommandEffectsConsumed": true
    }
  },
  "unsupportedScopeDecisions": [
    {
      "kind": "timerMessageHandlerHandledAsSpecificReferenceVocabulary",
      "reason": "TimerMessage_Timer is used as command vocabulary evidence only; complete FRM restoration is not a project-wide requirement."
    },
    {
      "kind": "runtimeMessageEffectsConsumeBasAnchoredCommands",
      "reason": "Web runtime dispatch consumes BAS/event-emitted command vocabulary and keeps timing-specific FRM semantics scoped out."
    }
  ],
  "unknowns": [],
  "knownGaps": [
    "All decoded BAS Message literal command prefixes currently have TimerMessage_Timer command candidates.",
    "All generated event commands except END/GOTO/IF have TimerMessage_Timer command candidates; END/GOTO/IF are handled inside MsgSub control flow.",
    "TimerMessage_Timer remains candidate-only FRM evidence, so command effects are not decoded and runtime remains gated.",
    "Full FRM restoration is not required; the unresolved scope is this specific handler's command branches and timing."
  ]
} as const;
